import { getStorageItem, makeid } from "../helpers/utils";
import {
  DEFAULT_PARTNER_CODE,
  AVIVA_PARTNER_CODE,
  DBGB_PARTNER_CODE,
  TERM_PARTNER_CODE,
} from "../constants";

export const bankMasterMapping = {
  [DEFAULT_PARTNER_CODE]: {
    title: "Bank of Maharashtra",
    value: "AACX",
  },
  [AVIVA_PARTNER_CODE]: {
    title: "Select",
    value: "",
  },
  [DBGB_PARTNER_CODE]: {
    title: "Bihar Gramin Bank",
    value: "AACX",
  },
  [TERM_PARTNER_CODE]: {
    title: "Select",
    value: "",
  },
};

export const ifscPrefixMapping = {
  [DEFAULT_PARTNER_CODE]: "MAHB000",
  [AVIVA_PARTNER_CODE]: "",
  [DBGB_PARTNER_CODE]: "PUNB0MBGB06",
  [TERM_PARTNER_CODE]: "",
};

export const errorMessageObject = {
  bank_account_holder_name: "",
  bank_account_number: "",
  bank_name: "",
  bank_account_type: "",
  bank_micr_code: "",
  bank_ifsc_code: "",
};

export const touchFieldObject = {
  bank_account_holder_name: false,
  bank_account_number: false,
  bank_name: false,
  bank_account_type: false,
  bank_micr_code: false,
  bank_ifsc_code: false,
};

export const formObject = {
  bank_account_holder_name: "",
  bank_account_number: "",
  bank_code: getStorageItem("partnerCode")
    ? bankMasterMapping[getStorageItem("partnerCode")].value
    : "",
  bank_name: getStorageItem("partnerCode")
    ? bankMasterMapping[getStorageItem("partnerCode")].title
    : "",
  bank_account_type: "Savings",
  bank_micr_code: "123456789",
  bank_ifsc_code: getStorageItem("partnerCode")
    ? ifscPrefixMapping[getStorageItem("partnerCode")]
    : "",
  consent: true,
  partnerId: getStorageItem("partnerId"),
  verify_account_details: false,
  verify_account_details_error: false,
  name_in_bank: "",
  name_mismatch: false,
  proceed_verified_account_details: "",
  account_verification_partner: "",
  verified_account_details: "",
  is_account_verified: 0,
};

export const autoCompleteObject = {
  code: getStorageItem("partnerCode")
    ? bankMasterMapping[getStorageItem("partnerCode")].value
    : "",
  label: getStorageItem("partnerCode")
    ? bankMasterMapping[getStorageItem("partnerCode")].title
    : "",
};

export const autoCompleteSalesPerson = {
  code: "",
  label: "Search by employee id or name",
};

export const autoCompleteBranchName = {
  code: "",
  label: "Search by branch code or name",
};

export const ifscCodes = [
  {
    branch_code: "1",
    branch_name: "PUNE-BAJIRAO ROAD",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000001",
  },
  {
    branch_code: "2",
    branch_name: "MUMBAI-FORT",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000002",
  },
  {
    branch_code: "3",
    branch_name: "PUNE-DECCAN GYMKHANA",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000003",
  },
  {
    branch_code: "4",
    branch_name: "JALGAON CITY",
    category: "URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0000004",
  },
  {
    branch_code: "5",
    branch_name: "NAGPUR-SITABULDI",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000005",
  },
  {
    branch_code: "6",
    branch_name: "MUMBAI-RRMR MARG,GIRGAUM",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000006",
  },
  {
    branch_code: "7",
    branch_name: "PUNE-KIRKEE",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000007",
  },
  {
    branch_code: "8",
    branch_name: "RATNAGIRI CITY",
    category: "SEMI URBAN",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000008",
  },
  {
    branch_code: "9",
    branch_name: "KOPARGAON",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000009",
  },
  {
    branch_code: "12",
    branch_name: "CHALISGAON-STATION ROAD",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0000012",
  },
  {
    branch_code: "10",
    branch_name: "DHULE CITY",
    category: "URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0000010",
  },
  {
    branch_code: "11",
    branch_name: "SHOLAPUR-PHALTAN GULLI",
    category: "URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000011",
  },
  {
    branch_code: "13",
    branch_name: "HUBLI DHARAWAD-HUBLI",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000013",
  },
  {
    branch_code: "14",
    branch_name: "NASIK-CITY",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0000014",
  },
  {
    branch_code: "15",
    branch_name: "KALYAN",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000015",
  },
  {
    branch_code: "16",
    branch_name: "MUMBAI-Gadkari Chowk,DADAR",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000016",
  },
  {
    branch_code: "17",
    branch_name: "SHOLAPUR-NAVI PETH",
    category: "URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000017",
  },
  {
    branch_code: "18",
    branch_name: "LAXMIPURI-KOLHAPUR",
    category: "URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000018",
  },
  {
    branch_code: "19",
    branch_name: "HYDERABAD-SULTAN BAZAR",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0000019",
  },
  {
    branch_code: "20",
    branch_name: "SANGLI",
    category: "URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000020",
  },
  {
    branch_code: "21",
    branch_name: "AMRAVATI MAIN",
    category: "URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000021",
  },
  {
    branch_code: "22",
    branch_name: "THANA-STATION ROAD",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000022",
  },
  {
    branch_code: "23",
    branch_name: "HARIHAR",
    category: "SEMI URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000023",
  },
  {
    branch_code: "24",
    branch_name: "AHILYANAGAR CITY",
    category: "URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000024",
  },
  {
    branch_code: "26",
    branch_name: "MUMBAI-ZAVERI BAZAR",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000026",
  },
  {
    branch_code: "27",
    branch_name: "PANVEL",
    category: "URBAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000027",
  },
  {
    branch_code: "28",
    branch_name: "PUNE-BHAVANIPETH",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000028",
  },
  {
    branch_code: "29",
    branch_name: "SHRIRAMPUR",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000029",
  },
  {
    branch_code: "25",
    branch_name: "BHIWANDI",
    category: "URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0000025",
  },
  {
    branch_code: "30",
    branch_name: "KIRLOSKAR WADI",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000030",
  },
  {
    branch_code: "31",
    branch_name: "BELGAUM-CITY",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000031",
  },
  {
    branch_code: "32",
    branch_name: "CHHATRAPATI SAMBHAJINAGAR",
    category: "METROPOLITAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000032",
  },
  {
    branch_code: "33",
    branch_name: "JALNA-MAIN",
    category: "URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000033",
  },
  {
    branch_code: "34",
    branch_name: "AKOLA-M G ROAD",
    category: "URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0000034",
  },
  {
    branch_code: "35",
    branch_name: "NANDED",
    category: "URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000035",
  },
  {
    branch_code: "36",
    branch_name: "HINGOLI-SADAR BAZAR",
    category: "SEMI URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000036",
  },
  {
    branch_code: "37",
    branch_name: "AMBAJOGAI",
    category: "SEMI URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000037",
  },
  {
    branch_code: "38",
    branch_name: "LATUR-MAIN",
    category: "URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000038",
  },
  {
    branch_code: "39",
    branch_name: "MUMBAI-SION(EAST)",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000039",
  },
  {
    branch_code: "40",
    branch_name: "PUNE-SOMWARPETH",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000040",
  },
  {
    branch_code: "41",
    branch_name: "PUNE-TILAK ROAD",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000041",
  },
  {
    branch_code: "42",
    branch_name: "MUMBAI-DADAR GOKHALE RD.",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000042",
  },
  {
    branch_code: "43",
    branch_name: "PUNE-SHIVAJINAGAR",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000043",
  },
  {
    branch_code: "44",
    branch_name: "PARLI VAIJNATH",
    category: "SEMI URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000044",
  },
  {
    branch_code: "45",
    branch_name: "MUMBAI-AMBEDKAR RD.DADAR",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000045",
  },
  {
    branch_code: "46",
    branch_name: "KHAMGAON",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0000046",
  },
  {
    branch_code: "47",
    branch_name: "YEOTMAL",
    category: "URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000047",
  },
  {
    branch_code: "48",
    branch_name: "MUMBAI-MUMBAI CENTRAL",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000048",
  },
  {
    branch_code: "49",
    branch_name: "PUNE-CHATUSHRUNGI",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000049",
  },
  {
    branch_code: "50",
    branch_name: "MUMBAI-WORLI",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000050",
  },
  {
    branch_code: "52",
    branch_name: "AKLUJ",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000052",
  },
  {
    branch_code: "51",
    branch_name: "BARSI-SAWARKAR PETH",
    category: "URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000051",
  },
  {
    branch_code: "53",
    branch_name: "MUMBAI-VILE PARLE(EAST)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000053",
  },
  {
    branch_code: "54",
    branch_name: "ARVI",
    category: "SEMI URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000054",
  },
  {
    branch_code: "55",
    branch_name: "CHANDRAPUR",
    category: "URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000055",
  },
  {
    branch_code: "56",
    branch_name: "DHAMANGAON-GANDHI CHOWK",
    category: "SEMI URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000056",
  },
  {
    branch_code: "57",
    branch_name: "DURG-GANDHI CHOWK",
    category: "URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0000057",
  },
  {
    branch_code: "58",
    branch_name: "GONDIA",
    category: "URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000058",
  },
  {
    branch_code: "59",
    branch_name: "HINGANGHAT",
    category: "URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000059",
  },
  {
    branch_code: "60",
    branch_name: "NAGPUR-DHARAMPETH",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000060",
  },
  {
    branch_code: "61",
    branch_name: "NAGPUR-ITWARI",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000061",
  },
  {
    branch_code: "62",
    branch_name: "PULGAON",
    category: "SEMI URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000062",
  },
  {
    branch_code: "63",
    branch_name: "RAJNANDGAON",
    category: "URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0000063",
  },
  {
    branch_code: "64",
    branch_name: "WANI(YAVATMAL)",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000064",
  },
  {
    branch_code: "65",
    branch_name: "WARDHA",
    category: "URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000065",
  },
  {
    branch_code: "66",
    branch_name: "WARORA",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000066",
  },
  {
    branch_code: "67",
    branch_name: "MUMBAI-S.P.ROAD",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000067",
  },
  {
    branch_code: "68",
    branch_name: "BANDA",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000068",
  },
  {
    branch_code: "69",
    branch_name: "PHONDAGHAT",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000069",
  },
  {
    branch_code: "70",
    branch_name: "KUDAL (SINDHUDURG)",
    category: "SEMI URBAN",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000070",
  },
  {
    branch_code: "71",
    branch_name: "SAWANTWADI",
    category: "SEMI URBAN",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000071",
  },
  {
    branch_code: "72",
    branch_name: "MALVAN",
    category: "SEMI URBAN",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000072",
  },
  {
    branch_code: "73",
    branch_name: "BARAMATI",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000073",
  },
  {
    branch_code: "74",
    branch_name: "KHOPOLI",
    category: "SEMI URBAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000074",
  },
  {
    branch_code: "75",
    branch_name: "LONAVALA-TILAK ROAD",
    category: "SEMI URBAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000075",
  },
  {
    branch_code: "76",
    branch_name: "PUNE-CAMP",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000076",
  },
  {
    branch_code: "78",
    branch_name: "OJHAR-MAIN ROAD",
    category: "SEMI URBAN",
    zone: "NASIK",
    ifsc_code: "MAHB0000078",
  },
  {
    branch_code: "79",
    branch_name: "MUMBAI-PAREL",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000079",
  },
  {
    branch_code: "80",
    branch_name: "PUNE-PIMPRI",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000080",
  },
  {
    branch_code: "81",
    branch_name: "PUNE-HADAPSAR IND.ESTATE",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000081",
  },
  {
    branch_code: "82",
    branch_name: "MUMBAI-GOREGAON(W)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000082",
  },
  {
    branch_code: "83",
    branch_name: "MARGAO",
    category: "SEMI URBAN",
    zone: "GOA",
    ifsc_code: "MAHB0000083",
  },
  {
    branch_code: "84",
    branch_name: "PANAJI (PANJIM)",
    category: "SEMI URBAN",
    zone: "GOA",
    ifsc_code: "MAHB0000084",
  },
  {
    branch_code: "85",
    branch_name: "ICHALKARANJI",
    category: "URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000085",
  },
  {
    branch_code: "86",
    branch_name: "URAN-URAN(KOLABA)",
    category: "SEMI URBAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000086",
  },
  {
    branch_code: "87",
    branch_name: "JATH",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000087",
  },
  {
    branch_code: "88",
    branch_name: "SSI BRANCH-THANE",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000088",
  },
  {
    branch_code: "89",
    branch_name: "MUMBAI-CHEMBUR",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000089",
  },
  {
    branch_code: "90",
    branch_name: "MUMBAI-MULUND(WEST)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000090",
  },
  {
    branch_code: "91",
    branch_name: "MUMBAI-MAZAGAON",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000091",
  },
  {
    branch_code: "92",
    branch_name: "MUMBAI-BORIVALI WEST",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000092",
  },
  {
    branch_code: "93",
    branch_name: "MUMBAI-T.H.K.MARG,MAHIM",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000093",
  },
  {
    branch_code: "94",
    branch_name: "VIRAR",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000094",
  },
  {
    branch_code: "97",
    branch_name: "RAHURI-KASARGALLI",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000097",
  },
  {
    branch_code: "95",
    branch_name: "BHANDARA",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000095",
  },
  {
    branch_code: "96",
    branch_name: "NIRA",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000096",
  },
  {
    branch_code: "98",
    branch_name: "MURTIZAPUR",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0000098",
  },
  {
    branch_code: "99",
    branch_name: "BASSEIN",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000099",
  },
  {
    branch_code: "100",
    branch_name: "PUNE-SWARGATE",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000100",
  },
  {
    branch_code: "101",
    branch_name: "INDAPUR",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000101",
  },
  {
    branch_code: "102",
    branch_name: "PUNE-NAVI PETH",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000102",
  },
  {
    branch_code: "103",
    branch_name: "PARBHANI",
    category: "URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000103",
  },
  {
    branch_code: "104",
    branch_name: "ALANDI",
    category: "SEMI URBAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000104",
  },
  {
    branch_code: "105",
    branch_name: "BARODA-RAOPURA",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0000105",
  },
  {
    branch_code: "106",
    branch_name: "INDORE, M G ROAD BRANCH",
    category: "METROPOLITAN",
    zone: "INDORE",
    ifsc_code: "MAHB0000106",
  },
  {
    branch_code: "107",
    branch_name: "MAHAL,NAGPUR",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000107",
  },
  {
    branch_code: "108",
    branch_name: "MUMBAI-L.J.ROAD,MAHIM",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000108",
  },
  {
    branch_code: "109",
    branch_name: "DOMBIVLI EAST",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000109",
  },
  {
    branch_code: "110",
    branch_name: "THANA-NAUPADA",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000110",
  },
  {
    branch_code: "111",
    branch_name: "AKALKOT",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000111",
  },
  {
    branch_code: "112",
    branch_name: "MANCHAR",
    category: "SEMI URBAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000112",
  },
  {
    branch_code: "113",
    branch_name: "RAHIMATPUR-STATION ROAD",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0000113",
  },
  {
    branch_code: "114",
    branch_name: "PUNE-DAPODI",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000114",
  },
  {
    branch_code: "115",
    branch_name: "BADNERA",
    category: "URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000115",
  },
  {
    branch_code: "116",
    branch_name: "PUNE-KARVE ROAD",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000116",
  },
  {
    branch_code: "117",
    branch_name: "MUMBAI-MALAD(WEST)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000117",
  },
  {
    branch_code: "118",
    branch_name: "PUNE-AUNDH",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000118",
  },
  {
    branch_code: "119",
    branch_name: "MUMBAI-NAGDEVI STREET",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000119",
  },
  {
    branch_code: "120",
    branch_name: "AUSA",
    category: "SEMI URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000120",
  },
  {
    branch_code: "121",
    branch_name: "BEED",
    category: "URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000121",
  },
  {
    branch_code: "122",
    branch_name: "DIGRAS",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000122",
  },
  {
    branch_code: "124",
    branch_name: "PURNA",
    category: "SEMI URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000124",
  },
  {
    branch_code: "125",
    branch_name: "DHARASHIV",
    category: "URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000125",
  },
  {
    branch_code: "126",
    branch_name: "UDGIR",
    category: "URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000126",
  },
  {
    branch_code: "123",
    branch_name: "NASIK ROAD-JAIL ROAD",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0000123",
  },
  {
    branch_code: "127",
    branch_name: "PUNE-CHINCHWAD",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000127",
  },
  {
    branch_code: "128",
    branch_name: "MUMBAI-BHANDUP",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000128",
  },
  {
    branch_code: "129",
    branch_name: "DUDHANI",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000129",
  },
  {
    branch_code: "130",
    branch_name: "OTUR",
    category: "SEMI URBAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000130",
  },
  {
    branch_code: "131",
    branch_name: "LONI KALBHOR",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000131",
  },
  {
    branch_code: "132",
    branch_name: "MUMBAI-B.S.ROAD,DADAR",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000132",
  },
  {
    branch_code: "133",
    branch_name: "KAMPTEE",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000133",
  },
  {
    branch_code: "134",
    branch_name: "SATARA-CITY",
    category: "URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0000134",
  },
  {
    branch_code: "135",
    branch_name: "PUNE-MUNDHWA",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000135",
  },
  {
    branch_code: "136",
    branch_name: "BADLAPUR",
    category: "URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0000136",
  },
  {
    branch_code: "137",
    branch_name: "NAGPUR-HANUMAN NAGAR",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000137",
  },
  {
    branch_code: "138",
    branch_name: "PATHARDI",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000138",
  },
  {
    branch_code: "139",
    branch_name: "PUNTAMBA",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000139",
  },
  {
    branch_code: "140",
    branch_name: "DELHI-KAROL BAGH",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0000140",
  },
  {
    branch_code: "141",
    branch_name: "DEWAS",
    category: "URBAN",
    zone: "INDORE",
    ifsc_code: "MAHB0000141",
  },
  {
    branch_code: "142",
    branch_name: "KHANDWA",
    category: "URBAN",
    zone: "INDORE",
    ifsc_code: "MAHB0000142",
  },
  {
    branch_code: "143",
    branch_name: "PANDHANA",
    category: "SEMI URBAN",
    zone: "INDORE",
    ifsc_code: "MAHB0000143",
  },
  {
    branch_code: "144",
    branch_name: "SANSAR",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000144",
  },
  {
    branch_code: "145",
    branch_name: "AMBARNATH",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000145",
  },
  {
    branch_code: "146",
    branch_name: "MURUM",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000146",
  },
  {
    branch_code: "147",
    branch_name: "NEWASA-GANPATHI CHOWK",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000147",
  },
  {
    branch_code: "148",
    branch_name: "BHUSAVAL-STATION ROAD",
    category: "URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0000148",
  },
  {
    branch_code: "149",
    branch_name: "MAINDARGI",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000149",
  },
  {
    branch_code: "150",
    branch_name: "AJRA",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000150",
  },
  {
    branch_code: "151",
    branch_name: "THANA-KOPRI,THANA(EAST)3",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000151",
  },
  {
    branch_code: "152",
    branch_name: "UNIVERSITY BRANCH CHHATRAPATI SAMBHAJINAGAR",
    category: "METROPOLITAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000152",
  },
  {
    branch_code: "153",
    branch_name: "NAGPUR-SHANKAR NAGAR",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000153",
  },
  {
    branch_code: "154",
    branch_name: "PUNE-NARAYANPETH",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000154",
  },
  {
    branch_code: "155",
    branch_name: "MUMBAI-TARDEO ROAD",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000155",
  },
  {
    branch_code: "156",
    branch_name: "NANDRE",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000156",
  },
  {
    branch_code: "157",
    branch_name: "ALE",
    category: "SEMI URBAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000157",
  },
  {
    branch_code: "158",
    branch_name: "PUNE-PARVATI",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000158",
  },
  {
    branch_code: "159",
    branch_name: "BELGAUM-TILAKWADI",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000159",
  },
  {
    branch_code: "160",
    branch_name: "MALEGAON, PUNE",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000160",
  },
  {
    branch_code: "161",
    branch_name: "MUMBAI-THAKURDWAR ROAD",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000161",
  },
  {
    branch_code: "162",
    branch_name: "BANGALORE-BASAVANGUDI",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0000162",
  },
  {
    branch_code: "163",
    branch_name: "SHOLAPUR-SHOLAPUR CAMP",
    category: "URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000163",
  },
  {
    branch_code: "164",
    branch_name: "MUMBAI-BANDRA EAST",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000164",
  },
  {
    branch_code: "165",
    branch_name: "SAIKHEDA",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0000165",
  },
  {
    branch_code: "166",
    branch_name: "NASIK-SSI BRANCH (SATPUR)",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0000166",
  },
  {
    branch_code: "167",
    branch_name: "WAVI",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0000167",
  },
  {
    branch_code: "168",
    branch_name: "VANI",
    category: "SEMI URBAN",
    zone: "NASIK",
    ifsc_code: "MAHB0000168",
  },
  {
    branch_code: "169",
    branch_name: "VADNER-BHAIRAV",
    category: "SEMI URBAN",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000169",
  },
  {
    branch_code: "170",
    branch_name: "PUNE-KASARWADI",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000170",
  },
  {
    branch_code: "171",
    branch_name: "KEDGAON",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000171",
  },
  {
    branch_code: "172",
    branch_name: "PATAS",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000172",
  },
  {
    branch_code: "173",
    branch_name: "PABAL",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000173",
  },
  {
    branch_code: "174",
    branch_name: "GHODEGAON",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000174",
  },
  {
    branch_code: "175",
    branch_name: "YEWAT",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000175",
  },
  {
    branch_code: "176",
    branch_name: "SUPA",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000176",
  },
  {
    branch_code: "177",
    branch_name: "WALHE-BAZAR PETH",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000177",
  },
  {
    branch_code: "178",
    branch_name: "JAMBULPADA",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000178",
  },
  {
    branch_code: "179",
    branch_name: "SINDEWAHI",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000179",
  },
  {
    branch_code: "180",
    branch_name: "CHIMUR",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000180",
  },
  {
    branch_code: "181",
    branch_name: "BHADRAVATI-GANDHI CHOWK",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000181",
  },
  {
    branch_code: "182",
    branch_name: "MUL",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000182",
  },
  {
    branch_code: "184",
    branch_name: "PUNE-GHORPADI BAZAR",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000184",
  },
  {
    branch_code: "183",
    branch_name: "MUMBAI-BYCULLA,BOM.27DD",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000183",
  },
  {
    branch_code: "185",
    branch_name: "PUNE-GURUWARPETH",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000185",
  },
  {
    branch_code: "186",
    branch_name: "SHENDURJANAGHAT",
    category: "SEMI URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000186",
  },
  {
    branch_code: "187",
    branch_name: "DINDORI",
    category: "SEMI URBAN",
    zone: "NASIK",
    ifsc_code: "MAHB0000187",
  },
  {
    branch_code: "188",
    branch_name: "KARAD",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0000188",
  },
  {
    branch_code: "189",
    branch_name: "PADGHA",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0000189",
  },
  {
    branch_code: "190",
    branch_name: "KASARA",
    category: "SEMI URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0000190",
  },
  {
    branch_code: "191",
    branch_name: "KINHAVLI",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0000191",
  },
  {
    branch_code: "192",
    branch_name: "TITVALA",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000192",
  },
  {
    branch_code: "193",
    branch_name: "ARNALA",
    category: "SEMI URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0000193",
  },
  {
    branch_code: "194",
    branch_name: "DAHANU",
    category: "SEMI URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0000194",
  },
  {
    branch_code: "195",
    branch_name: "PALGHAR",
    category: "SEMI URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0000195",
  },
  {
    branch_code: "196",
    branch_name: "CHIKHALTHANA",
    category: "METROPOLITAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000196",
  },
  {
    branch_code: "197",
    branch_name: "NALLA SOPARA",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000197",
  },
  {
    branch_code: "198",
    branch_name: "VAJRESHWARI-GANESHPURI",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0000198",
  },
  {
    branch_code: "199",
    branch_name: "ELLORA",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000199",
  },
  {
    branch_code: "200",
    branch_name: "WAI",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0000200",
  },
  {
    branch_code: "201",
    branch_name: "TEMBHURNI",
    category: "SEMI URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000201",
  },
  {
    branch_code: "202",
    branch_name: "BIDKIN",
    category: "SEMI URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000202",
  },
  {
    branch_code: "203",
    branch_name: "PACHOD",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000203",
  },
  {
    branch_code: "204",
    branch_name: "BADNAPUR",
    category: "SEMI URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000204",
  },
  {
    branch_code: "205",
    branch_name: "PISHORE",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000205",
  },
  {
    branch_code: "206",
    branch_name: "JAFERABAD",
    category: "SEMI URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000206",
  },
  {
    branch_code: "207",
    branch_name: "SHIVOOR",
    category: "SEMI URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000207",
  },
  {
    branch_code: "208",
    branch_name: "SOEGAON",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000208",
  },
  {
    branch_code: "209",
    branch_name: "DHAVADA",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000209",
  },
  {
    branch_code: "210",
    branch_name: "VELHE MAHAL",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000210",
  },
  {
    branch_code: "211",
    branch_name: "REDI",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000211",
  },
  {
    branch_code: "212",
    branch_name: "NASARAPUR",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000212",
  },
  {
    branch_code: "213",
    branch_name: "AHMEDABAD-BHADRA",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0000213",
  },
  {
    branch_code: "214",
    branch_name: "NASIK-NASIK COLLEGE CAMP",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0000214",
  },
  {
    branch_code: "215",
    branch_name: "TARADGAON",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000215",
  },
  {
    branch_code: "216",
    branch_name: "BHUINJ",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000216",
  },
  {
    branch_code: "217",
    branch_name: "NIRMAL",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000217",
  },
  {
    branch_code: "218",
    branch_name: "SHIRWAL",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0000218",
  },
  {
    branch_code: "219",
    branch_name: "PANCHGANI",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0000219",
  },
  {
    branch_code: "220",
    branch_name: "TARALE",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000220",
  },
  {
    branch_code: "221",
    branch_name: "NAGTHANE",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000221",
  },
  {
    branch_code: "222",
    branch_name: "MANOR",
    category: "SEMI URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0000222",
  },
  {
    branch_code: "223",
    branch_name: "KHATAV",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000223",
  },
  {
    branch_code: "224",
    branch_name: "MHASWAD",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0000224",
  },
  {
    branch_code: "225",
    branch_name: "WATHAR STATION",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000225",
  },
  {
    branch_code: "227",
    branch_name: "MUMBAI-VIKHROLI(EAST)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000227",
  },
  {
    branch_code: "228",
    branch_name: "MUMBAI-GHATKOPAR(EAST)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000228",
  },
  {
    branch_code: "229",
    branch_name: "ALIBAG",
    category: "SEMI URBAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000229",
  },
  {
    branch_code: "230",
    branch_name: "PUSEGAON",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000230",
  },
  {
    branch_code: "231",
    branch_name: "ASHTA",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000231",
  },
  {
    branch_code: "233",
    branch_name: "UJJAIN-CHHOTA SARAFA",
    category: "URBAN",
    zone: "INDORE",
    ifsc_code: "MAHB0000233",
  },
  {
    branch_code: "234",
    branch_name: "GANPATIPULE MALGUND",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000234",
  },
  {
    branch_code: "235",
    branch_name: "MIRAJ-LAXMI MARKET",
    category: "URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000235",
  },
  {
    branch_code: "236",
    branch_name: "NARODI-ANNASAHEB PATH",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000236",
  },
  {
    branch_code: "237",
    branch_name: "PANDHARPUR",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000237",
  },
  {
    branch_code: "238",
    branch_name: "PAITHAN-NATH GALLI",
    category: "SEMI URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000238",
  },
  {
    branch_code: "239",
    branch_name: "SATANA-T.D.A.ROAD",
    category: "SEMI URBAN",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000239",
  },
  {
    branch_code: "240",
    branch_name: "NAGPUR-DEONAGAR",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000240",
  },
  {
    branch_code: "242",
    branch_name: "MUMBAI-DOMBIVLI(WEST)",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000242",
  },
  {
    branch_code: "243",
    branch_name: "PUNE-PAUD PHATA",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000243",
  },
  {
    branch_code: "244",
    branch_name: "PUNE-KOTHRUD",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000244",
  },
  {
    branch_code: "245",
    branch_name: "CHAMORSHI",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000245",
  },
  {
    branch_code: "246",
    branch_name: "AHERI",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000246",
  },
  {
    branch_code: "247",
    branch_name: "BHOR-MANGALWAR PETH",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000247",
  },
  {
    branch_code: "248",
    branch_name: "KILLARI",
    category: "SEMI URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000248",
  },
  {
    branch_code: "249",
    branch_name: "AUNDHA NAGANATH",
    category: "SEMI URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000249",
  },
  {
    branch_code: "250",
    branch_name: "AKHADA BALAPUR",
    category: "SEMI URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000250",
  },
  {
    branch_code: "251",
    branch_name: "POYNAD",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000251",
  },
  {
    branch_code: "252",
    branch_name: "LONI-MARKET YARD",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000252",
  },
  {
    branch_code: "253",
    branch_name: "PUSLA",
    category: "SEMI URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000253",
  },
  {
    branch_code: "254",
    branch_name: "GHODNADI(SIRUR)",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000254",
  },
  {
    branch_code: "255",
    branch_name: "PHALTAN",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0000255",
  },
  {
    branch_code: "256",
    branch_name: "MALHAR PETH",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000256",
  },
  {
    branch_code: "257",
    branch_name: "UMARKHED-BAZAR PETH",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000257",
  },
  {
    branch_code: "258",
    branch_name: "AJGAON",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000258",
  },
  {
    branch_code: "259",
    branch_name: "KANNAD-BAZARPETH",
    category: "SEMI URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000259",
  },
  {
    branch_code: "260",
    branch_name: "MILL CORNER",
    category: "METROPOLITAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000260",
  },
  {
    branch_code: "261",
    branch_name: "GHATANJI",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000261",
  },
  {
    branch_code: "262",
    branch_name: "PANDWARKAWADA",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000262",
  },
  {
    branch_code: "263",
    branch_name: "AMBAD",
    category: "SEMI URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000263",
  },
  {
    branch_code: "264",
    branch_name: "PEN-DEOALI",
    category: "SEMI URBAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000264",
  },
  {
    branch_code: "265",
    branch_name: "WALSANG",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000265",
  },
  {
    branch_code: "266",
    branch_name: "MAHUD BURDUK",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000266",
  },
  {
    branch_code: "267",
    branch_name: "VAIJAPUR",
    category: "SEMI URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000267",
  },
  {
    branch_code: "268",
    branch_name: "GWALIOR-LASHKAR",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0000268",
  },
  {
    branch_code: "269",
    branch_name: "SILLOD",
    category: "SEMI URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000269",
  },
  {
    branch_code: "270",
    branch_name: "BHOKARDAN",
    category: "SEMI URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000270",
  },
  {
    branch_code: "271",
    branch_name: "GANGAPUR",
    category: "SEMI URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000271",
  },
  {
    branch_code: "272",
    branch_name: "ALLAPALLI",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000272",
  },
  {
    branch_code: "273",
    branch_name: "PALI",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000273",
  },
  {
    branch_code: "274",
    branch_name: "KHAREPATAN",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000274",
  },
  {
    branch_code: "275",
    branch_name: "SINNAR",
    category: "SEMI URBAN",
    zone: "NASIK",
    ifsc_code: "MAHB0000275",
  },
  {
    branch_code: "276",
    branch_name: "MANMAD",
    category: "SEMI URBAN",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000276",
  },
  {
    branch_code: "277",
    branch_name: "YEOLA",
    category: "SEMI URBAN",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000277",
  },
  {
    branch_code: "278",
    branch_name: "MALEGAON (NASIK)",
    category: "URBAN",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000278",
  },
  {
    branch_code: "279",
    branch_name: "WASHIM-RAVIVAR BAZAR",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0000279",
  },
  {
    branch_code: "281",
    branch_name: "WADE",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000281",
  },
  {
    branch_code: "282",
    branch_name: "TASGAON",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000282",
  },
  {
    branch_code: "283",
    branch_name: "JAIGAD",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000283",
  },
  {
    branch_code: "284",
    branch_name: "BORLI PANCHATAN",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000284",
  },
  {
    branch_code: "285",
    branch_name: "PATAN(SATARA)",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0000285",
  },
  {
    branch_code: "286",
    branch_name: "KOREGAON",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0000286",
  },
  {
    branch_code: "287",
    branch_name: "KHED (RAJGURUNAGAR)",
    category: "SEMI URBAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000287",
  },
  {
    branch_code: "288",
    branch_name: "LIMB",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000288",
  },
  {
    branch_code: "289",
    branch_name: "MORSHI",
    category: "SEMI URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000289",
  },
  {
    branch_code: "290",
    branch_name: "AMALNER-KUNTE ROAD",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0000290",
  },
  {
    branch_code: "291",
    branch_name: "BRAHMAPURI",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000291",
  },
  {
    branch_code: "292",
    branch_name: "KUDAL(SATARA)",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000292",
  },
  {
    branch_code: "293",
    branch_name: "PIMPODE BUDRUK",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000293",
  },
  {
    branch_code: "294",
    branch_name: "MUMBAI-JACOB CIRCLE",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000294",
  },
  {
    branch_code: "295",
    branch_name: "GHUNKI",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000295",
  },
  {
    branch_code: "296",
    branch_name: "CHIPLUN",
    category: "SEMI URBAN",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000296",
  },
  {
    branch_code: "297",
    branch_name: "KHANAPUR",
    category: "SEMI URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000297",
  },
  {
    branch_code: "298",
    branch_name: "UMBRAJ",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0000298",
  },
  {
    branch_code: "299",
    branch_name: "MUMBAI-SANTA CRUZ(WEST)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000299",
  },
  {
    branch_code: "300",
    branch_name: "CHENNAI-BROADWAY",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0000300",
  },
  {
    branch_code: "301",
    branch_name: "KRANTI CHOWK",
    category: "METROPOLITAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000301",
  },
  {
    branch_code: "302",
    branch_name: "MUMBAI-SHIVAJI PARK",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000302",
  },
  {
    branch_code: "303",
    branch_name: "THARSA NIMKHEDA",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000303",
  },
  {
    branch_code: "304",
    branch_name: "BANGALORE-CITY MARKET",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0000304",
  },
  {
    branch_code: "305",
    branch_name: "SATARA-POWAI NAKA",
    category: "URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0000305",
  },
  {
    branch_code: "306",
    branch_name: "MUMBAI-BORIVALI(EAST)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000306",
  },
  {
    branch_code: "307",
    branch_name: "KHARDI",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0000307",
  },
  {
    branch_code: "308",
    branch_name: "TALASARI",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0000308",
  },
  {
    branch_code: "309",
    branch_name: "PACHORA-MAIN ROAD",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0000309",
  },
  {
    branch_code: "310",
    branch_name: "MUMBAI-BORI BUNDER",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000310",
  },
  {
    branch_code: "311",
    branch_name: "MUMBAI-ANDHERI EAST",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000311",
  },
  {
    branch_code: "312",
    branch_name: "NAGPUR-HINGNA INDL.EST.",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000312",
  },
  {
    branch_code: "313",
    branch_name: "PUNE-VISHRANTWADI",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000313",
  },
  {
    branch_code: "315",
    branch_name: "PUNE-PADMAVATI",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000315",
  },
  {
    branch_code: "317",
    branch_name: "AUNDH",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000317",
  },
  {
    branch_code: "318",
    branch_name: "MUMBAI-PRABHADEVI",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000318",
  },
  {
    branch_code: "319",
    branch_name: "RAJAPUR-MAIN BAZAR",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000319",
  },
  {
    branch_code: "320",
    branch_name: "PUNE-T.M.V.COLONY",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000320",
  },
  {
    branch_code: "321",
    branch_name: "PUNE-SAHAKAR NAGAR",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000321",
  },
  {
    branch_code: "323",
    branch_name: "MASUR-CHIPLUN-P.ROAD",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000323",
  },
  {
    branch_code: "322",
    branch_name: "PUNE-KASBA PETH",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000322",
  },
  {
    branch_code: "324",
    branch_name: "SAKHARWADI",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000324",
  },
  {
    branch_code: "326",
    branch_name: "KOLHAPUR-MAHADWAR ROAD",
    category: "URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000326",
  },
  {
    branch_code: "327",
    branch_name: "MUMBAI-KHAR(WEST)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000327",
  },
  {
    branch_code: "329",
    branch_name: "MUMBAI-LALBAUG",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000329",
  },
  {
    branch_code: "330",
    branch_name: "PUNE-ERANDAVANA",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000330",
  },
  {
    branch_code: "332",
    branch_name: "NASIK-PANCHAVATI",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0000332",
  },
  {
    branch_code: "333",
    branch_name: "PUNE-YERAVADA",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000333",
  },
  {
    branch_code: "335",
    branch_name: "PUNE-SHANKARSHET ROAD",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000335",
  },
  {
    branch_code: "336",
    branch_name: "MUMBAI-KURLA(WEST)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000336",
  },
  {
    branch_code: "337",
    branch_name: "KUMBHAR PIMPALGAON",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000337",
  },
  {
    branch_code: "338",
    branch_name: "GHANSAVANGI",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000338",
  },
  {
    branch_code: "349",
    branch_name: "SHIRPUR-MAIN ROAD",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0000349",
  },
  {
    branch_code: "339",
    branch_name: "MUMBAI-KINGS'CIRCLE",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000339",
  },
  {
    branch_code: "340",
    branch_name: "PUNE-SALISBURY PARK",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000340",
  },
  {
    branch_code: "341",
    branch_name: "JABALPUR (MAIN)",
    category: "METROPOLITAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0000341",
  },
  {
    branch_code: "342",
    branch_name: "BIJAPUR-M.G.CHOWK",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000342",
  },
  {
    branch_code: "343",
    branch_name: "N.DELHI-CONNAUGHT PLACE",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0000343",
  },
  {
    branch_code: "344",
    branch_name: "BANGALORE-MALLESWARAM",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0000344",
  },
  {
    branch_code: "345",
    branch_name: "SURAT-RING ROAD",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0000345",
  },
  {
    branch_code: "346",
    branch_name: "DAVANGERE",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000346",
  },
  {
    branch_code: "347",
    branch_name: "ULHASNAGAR-CAMP NO.IV",
    category: "URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0000347",
  },
  {
    branch_code: "348",
    branch_name: "DHULE-DEOPUR",
    category: "URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0000348",
  },
  {
    branch_code: "350",
    branch_name: "MUMBAI-DELISLE ROAD",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000350",
  },
  {
    branch_code: "351",
    branch_name: "DELHI-CHANDANI CHOWK",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0000351",
  },
  {
    branch_code: "352",
    branch_name: "LASALGAON",
    category: "SEMI URBAN",
    zone: "NASIK",
    ifsc_code: "MAHB0000352",
  },
  {
    branch_code: "353",
    branch_name: "TURBHE-VASHI",
    category: "METROPOLITAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000353",
  },
  {
    branch_code: "354",
    branch_name: "COIMBATORE-RAJA STREET",
    category: "METROPOLITAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0000354",
  },
  {
    branch_code: "355",
    branch_name: "KATTA (PENDUR)",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000355",
  },
  {
    branch_code: "356",
    branch_name: "NAGPUR-WARDHMAN NAGAR",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000356",
  },
  {
    branch_code: "357",
    branch_name: "RAJKOT-U.N.DHEBAR ROAD",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0000357",
  },
  {
    branch_code: "358",
    branch_name: "AKOLNER",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000358",
  },
  {
    branch_code: "359",
    branch_name: "SHAHAPUR",
    category: "SEMI URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0000359",
  },
  {
    branch_code: "360",
    branch_name: "JEUR",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000360",
  },
  {
    branch_code: "361",
    branch_name: "KUNDAL",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000361",
  },
  {
    branch_code: "362",
    branch_name: "MALKAPUR",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000362",
  },
  {
    branch_code: "364",
    branch_name: "PANDHURNA",
    category: "SEMI URBAN",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000364",
  },
  {
    branch_code: "365",
    branch_name: "FARIDABAD",
    category: "METROPOLITAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0000365",
  },
  {
    branch_code: "366",
    branch_name: "NANDURBAR",
    category: "URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0000366",
  },
  {
    branch_code: "367",
    branch_name: "AKOT-JAWAHAR ROAD",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0000367",
  },
  {
    branch_code: "368",
    branch_name: "GADAG-NEHRU ROAD",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000368",
  },
  {
    branch_code: "369",
    branch_name: "BAWADHAN",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0000369",
  },
  {
    branch_code: "371",
    branch_name: "MUMBAI-D.PHALKE ROAD",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000371",
  },
  {
    branch_code: "372",
    branch_name: "KAMSHET-PUNE MUMBAI RD.",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000372",
  },
  {
    branch_code: "373",
    branch_name: "MADURAI-DINDIGUL ROAD",
    category: "METROPOLITAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0000373",
  },
  {
    branch_code: "375",
    branch_name: "SALEM-MAIN ROAD",
    category: "URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0000375",
  },
  {
    branch_code: "376",
    branch_name: "CALCUTTA-CHOURINGHEE RD.",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0000376",
  },
  {
    branch_code: "377",
    branch_name: "VASCO-DA-GAMA",
    category: "SEMI URBAN",
    zone: "GOA",
    ifsc_code: "MAHB0000377",
  },
  {
    branch_code: "378",
    branch_name: "GHAZIABAD-NAVYUG MARKET",
    category: "METROPOLITAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0000378",
  },
  {
    branch_code: "379",
    branch_name: "ERNAKULAM (Cochhi) ",
    category: "URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0000379",
  },
  {
    branch_code: "380",
    branch_name: "RAICHUR-BRESTHWAR ROAD",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000380",
  },
  {
    branch_code: "381",
    branch_name: "MANGALORE",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000381",
  },
  {
    branch_code: "382",
    branch_name: "LUDHIANA",
    category: "METROPOLITAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0000382",
  },
  {
    branch_code: "383",
    branch_name: "HYDERABAD-KACHIGUDA",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0000383",
  },
  {
    branch_code: "384",
    branch_name: "CHANDIGARH",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0000384",
  },
  {
    branch_code: "385",
    branch_name: "TARAPUR-MIDC I.E",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0000385",
  },
  {
    branch_code: "386",
    branch_name: "PUNE-BHOSARIGAON",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000386",
  },
  {
    branch_code: "387",
    branch_name: "SECUNDERABAD-M.G.ROAD",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0000387",
  },
  {
    branch_code: "388",
    branch_name: "TIRUCHIRAPALLI",
    category: "URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0000388",
  },
  {
    branch_code: "389",
    branch_name: "JAIPUR-MIRZA ISMAIL ROAD",
    category: "METROPOLITAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0000389",
  },
  {
    branch_code: "390",
    branch_name: "ROHA-INDUSTRIAL ESTATE",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000390",
  },
  {
    branch_code: "391",
    branch_name: "PUNE-AKURDI",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000391",
  },
  {
    branch_code: "392",
    branch_name: "SOUTH EXTN. NEW DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0000392",
  },
  {
    branch_code: "393",
    branch_name: "AHMEDABAD-RELIEF ROAD",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0000393",
  },
  {
    branch_code: "394",
    branch_name: "TUTICORIN",
    category: "URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0000394",
  },
  {
    branch_code: "395",
    branch_name: "GADHINGLAJ",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000395",
  },
  {
    branch_code: "396",
    branch_name: "VIJAYAWADA-BRAHMIN ST.",
    category: "METROPOLITAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0000396",
  },
  {
    branch_code: "397",
    branch_name: "MUMBAI-KANJURMARG (WEST)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000397",
  },
  {
    branch_code: "398",
    branch_name: "VISAKHAPATNAM-MAIN ROAD",
    category: "METROPOLITAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0000398",
  },
  {
    branch_code: "399",
    branch_name: "THIRUVANANTHAPURAM-M.G.ROAD",
    category: "URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0000399",
  },
  {
    branch_code: "400",
    branch_name: "CHENNAI-MOUNT ROAD",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0000400",
  },
  {
    branch_code: "401",
    branch_name: "JAMNAGAR",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0000401",
  },
  {
    branch_code: "402",
    branch_name: "BANGALORE-SHIVAJINAGAR",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0000402",
  },
  {
    branch_code: "403",
    branch_name: "BANGALORE-BRIGADE ROAD",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0000403",
  },
  {
    branch_code: "448",
    branch_name: "BETUL",
    category: "URBAN",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000448",
  },
  {
    branch_code: "404",
    branch_name: "BHAVNAGAR",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0000404",
  },
  {
    branch_code: "405",
    branch_name: "BULDHANA-MAIN ROAD",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0000405",
  },
  {
    branch_code: "406",
    branch_name: "DEULGAONRAJA-JALNA ROAD",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0000406",
  },
  {
    branch_code: "407",
    branch_name: "SAIGAON",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000407",
  },
  {
    branch_code: "408",
    branch_name: "CALICUT-KOZHIKODE",
    category: "URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0000408",
  },
  {
    branch_code: "409",
    branch_name: "BALAGHAT-MAIN ROAD",
    category: "SEMI URBAN",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000409",
  },
  {
    branch_code: "410",
    branch_name: "KOLHAPUR-RAJARAMPURI",
    category: "URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000410",
  },
  {
    branch_code: "411",
    branch_name: "GUNTUR",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0000411",
  },
  {
    branch_code: "412",
    branch_name: "KAGAL-MAIN ROAD",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000412",
  },
  {
    branch_code: "413",
    branch_name: "NIPANI-NEHRU CHOWK",
    category: "SEMI URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000413",
  },
  {
    branch_code: "414",
    branch_name: "NARAYANGAON",
    category: "SEMI URBAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000414",
  },
  {
    branch_code: "415",
    branch_name: "MUMBAI-SEWARI",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000415",
  },
  {
    branch_code: "416",
    branch_name: "MUMBAI-VARSOVA",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000416",
  },
  {
    branch_code: "417",
    branch_name: "KANPUR",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0000417",
  },
  {
    branch_code: "418",
    branch_name: "DEGLUR-LOHIA MAITAN ROAD",
    category: "SEMI URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000418",
  },
  {
    branch_code: "419",
    branch_name: "DHARAMABAD",
    category: "SEMI URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000419",
  },
  {
    branch_code: "420",
    branch_name: "SANGAMNER",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000420",
  },
  {
    branch_code: "421",
    branch_name: "SEONI",
    category: "URBAN",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000421",
  },
  {
    branch_code: "422",
    branch_name: "NEW DELHI-ASAF ALI ROAD",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0000422",
  },
  {
    branch_code: "424",
    branch_name: "CHANDWAD",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000424",
  },
  {
    branch_code: "425",
    branch_name: "GULBARGA",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000425",
  },
  {
    branch_code: "426",
    branch_name: "NANDGAON",
    category: "SEMI URBAN",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000426",
  },
  {
    branch_code: "427",
    branch_name: "RATLAM",
    category: "URBAN",
    zone: "INDORE",
    ifsc_code: "MAHB0000427",
  },
  {
    branch_code: "428",
    branch_name: "GANDHINAGAR-BANGALORE",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0000428",
  },
  {
    branch_code: "429",
    branch_name: "VIKRAMGAD",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0000429",
  },
  {
    branch_code: "430",
    branch_name: "KALLAM",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000430",
  },
  {
    branch_code: "431",
    branch_name: "LUCKNOW",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0000431",
  },
  {
    branch_code: "432",
    branch_name: "NAVSARI",
    category: "URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0000432",
  },
  {
    branch_code: "433",
    branch_name: "ADILABAD",
    category: "URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0000433",
  },
  {
    branch_code: "435",
    branch_name: "MAPUCA",
    category: "SEMI URBAN",
    zone: "GOA",
    ifsc_code: "MAHB0000435",
  },
  {
    branch_code: "436",
    branch_name: "INDORE-GODHA COLONY",
    category: "METROPOLITAN",
    zone: "INDORE",
    ifsc_code: "MAHB0000436",
  },
  {
    branch_code: "437",
    branch_name: "BALLARSHA",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000437",
  },
  {
    branch_code: "434",
    branch_name: "BULSAR",
    category: "URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0000434",
  },
  {
    branch_code: "438",
    branch_name: "JALANDHAR",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0000438",
  },
  {
    branch_code: "439",
    branch_name: "RAIPUR",
    category: "METROPOLITAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0000439",
  },
  {
    branch_code: "440",
    branch_name: "KAKINADA",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0000440",
  },
  {
    branch_code: "441",
    branch_name: "NADIAD",
    category: "URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0000441",
  },
  {
    branch_code: "442",
    branch_name: "AMRITSAR",
    category: "METROPOLITAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0000442",
  },
  {
    branch_code: "443",
    branch_name: "FEROZEPUR",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0000443",
  },
  {
    branch_code: "444",
    branch_name: "KARNAL",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0000444",
  },
  {
    branch_code: "445",
    branch_name: "BAMBAVADE",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000445",
  },
  {
    branch_code: "446",
    branch_name: "AHILYANAGAR CAMP",
    category: "URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000446",
  },
  {
    branch_code: "447",
    branch_name: "LAVALE",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000447",
  },
  {
    branch_code: "449",
    branch_name: "CHINDWARA",
    category: "URBAN",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000449",
  },
  {
    branch_code: "450",
    branch_name: "CHENNAI-T.NAGAR",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0000450",
  },
  {
    branch_code: "452",
    branch_name: "NAGPUR-SADAR BAZAR",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000452",
  },
  {
    branch_code: "451",
    branch_name: "RATNAGIRI-SHIVAJINAGAR",
    category: "SEMI URBAN",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000451",
  },
  {
    branch_code: "453",
    branch_name: "MUMBAI-KANDIVALI(WEST)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000453",
  },
  {
    branch_code: "454",
    branch_name: "MUMBAI-MATUNGA",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000454",
  },
  {
    branch_code: "455",
    branch_name: "N.S.RD.-CALCUTTA",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0000455",
  },
  {
    branch_code: "456",
    branch_name: "ANAND",
    category: "URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0000456",
  },
  {
    branch_code: "457",
    branch_name: "PORBUNDER",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0000457",
  },
  {
    branch_code: "458",
    branch_name: "PONDICHERRY",
    category: "URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0000458",
  },
  {
    branch_code: "459",
    branch_name: "KARWAR",
    category: "SEMI URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000459",
  },
  {
    branch_code: "460",
    branch_name: "BILASPUR",
    category: "URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0000460",
  },
  {
    branch_code: "461",
    branch_name: "PAWAS",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000461",
  },
  {
    branch_code: "462",
    branch_name: "SASWAD",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000462",
  },
  {
    branch_code: "463",
    branch_name: "BHIGWAN",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000463",
  },
  {
    branch_code: "464",
    branch_name: "SAKHAR PETH-SOLAPUR",
    category: "URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000464",
  },
  {
    branch_code: "465",
    branch_name: "RAJUR",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000465",
  },
  {
    branch_code: "466",
    branch_name: "URAN ISLAMPUR",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000466",
  },
  {
    branch_code: "467",
    branch_name: "SONEPAT",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0000467",
  },
  {
    branch_code: "469",
    branch_name: "DHARAWAD",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000469",
  },
  {
    branch_code: "470",
    branch_name: "MUMBAI-DEONAR COLONY",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000470",
  },
  {
    branch_code: "471",
    branch_name: "MUMBAI-VILEPARLE(WEST)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000471",
  },
  {
    branch_code: "472",
    branch_name: "VARANASI",
    category: "METROPOLITAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0000472",
  },
  {
    branch_code: "473",
    branch_name: "KHANAPUR(PUNE)",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000473",
  },
  {
    branch_code: "474",
    branch_name: "AMBALA CONTONMENT",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0000474",
  },
  {
    branch_code: "475",
    branch_name: "HOSHIARPUR",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0000475",
  },
  {
    branch_code: "476",
    branch_name: "NIMGAON KETKI",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000476",
  },
  {
    branch_code: "477",
    branch_name: "CHAROTINAKA",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0000477",
  },
  {
    branch_code: "478",
    branch_name: "GADMUDSHINGI",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000478",
  },
  {
    branch_code: "479",
    branch_name: "TIRUPPUR",
    category: "URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0000479",
  },
  {
    branch_code: "480",
    branch_name: "WARASGAON",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000480",
  },
  {
    branch_code: "481",
    branch_name: "GHATLODIA",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0000481",
  },
  {
    branch_code: "482",
    branch_name: "KASABE SUKANE",
    category: "SEMI URBAN",
    zone: "NASIK",
    ifsc_code: "MAHB0000482",
  },
  {
    branch_code: "483",
    branch_name: "BALINGE",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000483",
  },
  {
    branch_code: "484",
    branch_name: "MUMBAI-S.S.TRUST,BANDRA(EAST)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000484",
  },
  {
    branch_code: "485",
    branch_name: "MUMBAI-CUFFE PARADE",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000485",
  },
  {
    branch_code: "486",
    branch_name: "TALAMADUGU",
    category: "RURAL",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0000486",
  },
  {
    branch_code: "487",
    branch_name: "JAINAD",
    category: "RURAL",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0000487",
  },
  {
    branch_code: "488",
    branch_name: "TAKALI SIKUNDAR",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000488",
  },
  {
    branch_code: "489",
    branch_name: "SINDKED RAJA",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0000489",
  },
  {
    branch_code: "490",
    branch_name: "BANDORA",
    category: "SEMI URBAN",
    zone: "GOA",
    ifsc_code: "MAHB0000490",
  },
  {
    branch_code: "491",
    branch_name: "MARCAI",
    category: "RURAL",
    zone: "GOA",
    ifsc_code: "MAHB0000491",
  },
  {
    branch_code: "492",
    branch_name: "ASHTI",
    category: "SEMI URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000492",
  },
  {
    branch_code: "494",
    branch_name: "GUDIHATNOOR",
    category: "RURAL",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0000494",
  },
  {
    branch_code: "495",
    branch_name: "GIMMA KHURD",
    category: "RURAL",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0000495",
  },
  {
    branch_code: "496",
    branch_name: "MANDHAL",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000496",
  },
  {
    branch_code: "501",
    branch_name: "BELAPUR",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000501",
  },
  {
    branch_code: "497",
    branch_name: "SANGRUL",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000497",
  },
  {
    branch_code: "500",
    branch_name: "ALLAHABAD",
    category: "METROPOLITAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0000500",
  },
  {
    branch_code: "499",
    branch_name: "SENAPATI KAPSHI",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000499",
  },
  {
    branch_code: "502",
    branch_name: "KATI",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000502",
  },
  {
    branch_code: "503",
    branch_name: "GOREGAON (BHANDARA)",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000503",
  },
  {
    branch_code: "504",
    branch_name: "BIDRI",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000504",
  },
  {
    branch_code: "505",
    branch_name: "MORATGI",
    category: "RURAL",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000505",
  },
  {
    branch_code: "506",
    branch_name: "ABHONA",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000506",
  },
  {
    branch_code: "507",
    branch_name: "KUMBHARJUA",
    category: "RURAL",
    zone: "GOA",
    ifsc_code: "MAHB0000507",
  },
  {
    branch_code: "508",
    branch_name: "PAT-PARULE",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000508",
  },
  {
    branch_code: "509",
    branch_name: "KADUS",
    category: "SEMI URBAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000509",
  },
  {
    branch_code: "510",
    branch_name: "APEGAON",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000510",
  },
  {
    branch_code: "511",
    branch_name: "MARG TAMHANE",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000511",
  },
  {
    branch_code: "512",
    branch_name: "CHOUDAPUR",
    category: "RURAL",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000512",
  },
  {
    branch_code: "513",
    branch_name: "KARANJA (chanje ) ",
    category: "SEMI URBAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000513",
  },
  {
    branch_code: "514",
    branch_name: "VALAN",
    category: "SEMI URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0000514",
  },
  {
    branch_code: "515",
    branch_name: "GUNSADA",
    category: "RURAL",
    zone: "SURAT",
    ifsc_code: "MAHB0000515",
  },
  {
    branch_code: "516",
    branch_name: "TALERE",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000516",
  },
  {
    branch_code: "517",
    branch_name: "CHHEGAON MAKHAN",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0000517",
  },
  {
    branch_code: "518",
    branch_name: "STN.RD.-SOLAPUR",
    category: "URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000518",
  },
  {
    branch_code: "519",
    branch_name: "SANGLI-VISHRAMBAG (KUPWAD)",
    category: "URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000519",
  },
  {
    branch_code: "520",
    branch_name: "PARALI",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000520",
  },
  {
    branch_code: "521",
    branch_name: "YEDSHI",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000521",
  },
  {
    branch_code: "522",
    branch_name: "NHAVI",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0000522",
  },
  {
    branch_code: "523",
    branch_name: "PRAKASHE",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0000523",
  },
  {
    branch_code: "524",
    branch_name: "ANAKAPALLE",
    category: "SEMI URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0000524",
  },
  {
    branch_code: "525",
    branch_name: "SAOLI (CHANDRAPUR)",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000525",
  },
  {
    branch_code: "526",
    branch_name: "NAGPUR-MIRCHI BAZAR",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000526",
  },
  {
    branch_code: "527",
    branch_name: "JALGAON ROAD",
    category: "URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0000527",
  },
  {
    branch_code: "528",
    branch_name: "GHODA DONGARI",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000528",
  },
  {
    branch_code: "529",
    branch_name: "HOSPET",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000529",
  },
  {
    branch_code: "530",
    branch_name: "SAUNDANE",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000530",
  },
  {
    branch_code: "531",
    branch_name: "KOLAK",
    category: "RURAL",
    zone: "SURAT",
    ifsc_code: "MAHB0000531",
  },
  {
    branch_code: "532",
    branch_name: "VEER",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000532",
  },
  {
    branch_code: "533",
    branch_name: "KOLHAPUR-TARABAI CHOWK",
    category: "URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000533",
  },
  {
    branch_code: "534",
    branch_name: "NASIK-UPNAGAR",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0000534",
  },
  {
    branch_code: "535",
    branch_name: "JAMSHENDE",
    category: "SEMI URBAN",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000535",
  },
  {
    branch_code: "536",
    branch_name: "PATHARLI",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000536",
  },
  {
    branch_code: "537",
    branch_name: "JUNNARDEO",
    category: "SEMI URBAN",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000537",
  },
  {
    branch_code: "538",
    branch_name: "BANGALORE-CHAMRAJPET",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0000538",
  },
  {
    branch_code: "540",
    branch_name: "KOTA",
    category: "METROPOLITAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0000540",
  },
  {
    branch_code: "541",
    branch_name: "SHIRAJGAON (KASBA)",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000541",
  },
  {
    branch_code: "542",
    branch_name: "AHMEDABAD-MANINAGAR",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0000542",
  },
  {
    branch_code: "543",
    branch_name: "NAGAPUR",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000543",
  },
  {
    branch_code: "544",
    branch_name: "KAPADNE",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0000544",
  },
  {
    branch_code: "545",
    branch_name: "KURAI",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000545",
  },
  {
    branch_code: "546",
    branch_name: "BORGAON-MANJU",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0000546",
  },
  {
    branch_code: "547",
    branch_name: "EKLEHRA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000547",
  },
  {
    branch_code: "548",
    branch_name: "THAKURLI",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000548",
  },
  {
    branch_code: "549",
    branch_name: "KEM",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000549",
  },
  {
    branch_code: "550",
    branch_name: "SANKH",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000550",
  },
  {
    branch_code: "551",
    branch_name: "SAIDAPUR",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000551",
  },
  {
    branch_code: "552",
    branch_name: "TAMIA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000552",
  },
  {
    branch_code: "553",
    branch_name: "CALCUTTA-RASHBEHARI AVENUE",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0000553",
  },
  {
    branch_code: "554",
    branch_name: "SALEKASA",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000554",
  },
  {
    branch_code: "555",
    branch_name: "KIRNAPUR",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000555",
  },
  {
    branch_code: "556",
    branch_name: "RANWAD",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0000556",
  },
  {
    branch_code: "557",
    branch_name: "SANGRAMPUR",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0000557",
  },
  {
    branch_code: "558",
    branch_name: "MAKHJAN",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000558",
  },
  {
    branch_code: "559",
    branch_name: "AMRAVATI-RUKMININAGAR",
    category: "URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000559",
  },
  {
    branch_code: "560",
    branch_name: "UMRETH",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000560",
  },
  {
    branch_code: "561",
    branch_name: "N.DELHI-EAST PATEL NAGAR",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0000561",
  },
  {
    branch_code: "562",
    branch_name: "SHENOLI",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000562",
  },
  {
    branch_code: "563",
    branch_name: "MUMBAI-BHOIWADA",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000563",
  },
  {
    branch_code: "564",
    branch_name: "MULAWA",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000564",
  },
  {
    branch_code: "565",
    branch_name: "HYDERABAD-BASHIRBAGH",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0000565",
  },
  {
    branch_code: "566",
    branch_name: "KARAJGI",
    category: "RURAL",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000566",
  },
  {
    branch_code: "568",
    branch_name: "KHALGHAT",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0000568",
  },
  {
    branch_code: "570",
    branch_name: "AKOLA-JATHAR PETH",
    category: "URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0000570",
  },
  {
    branch_code: "571",
    branch_name: "CHENNAI-BESANTNAGAR",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0000571",
  },
  {
    branch_code: "572",
    branch_name: "UPALE DHUMALE",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000572",
  },
  {
    branch_code: "569",
    branch_name: "BANOSA",
    category: "SEMI URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000569",
  },
  {
    branch_code: "573",
    branch_name: "IRLE-VAIRAG",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000573",
  },
  {
    branch_code: "574",
    branch_name: "MALKAPUR (AKOLA)",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0000574",
  },
  {
    branch_code: "575",
    branch_name: "KALYAN-PARNAKA",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000575",
  },
  {
    branch_code: "577",
    branch_name: "DHAMNI (PUNE)",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000577",
  },
  {
    branch_code: "578",
    branch_name: "NANDURA",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0000578",
  },
  {
    branch_code: "579",
    branch_name: "NIZAMABAD",
    category: "URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0000579",
  },
  {
    branch_code: "580",
    branch_name: "PENNUR",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000580",
  },
  {
    branch_code: "581",
    branch_name: "MIRAJGAON",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000581",
  },
  {
    branch_code: "582",
    branch_name: "KHEDI (SAWALIGARH)",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000582",
  },
  {
    branch_code: "583",
    branch_name: "MEERUT",
    category: "METROPOLITAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0000583",
  },
  {
    branch_code: "584",
    branch_name: "GHUMKA",
    category: "RURAL",
    zone: "RAIPUR",
    ifsc_code: "MAHB0000584",
  },
  {
    branch_code: "585",
    branch_name: "KOLHAPUR-GANGAVES",
    category: "URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000585",
  },
  {
    branch_code: "586",
    branch_name: "NARPOLI",
    category: "URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0000586",
  },
  {
    branch_code: "587",
    branch_name: "NEW DELHI-VIVEK VIHAR",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0000587",
  },
  {
    branch_code: "588",
    branch_name: "MUMBAI-SAYANI ROAD",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000588",
  },
  {
    branch_code: "589",
    branch_name: "MAHABALESHWAR",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0000589",
  },
  {
    branch_code: "590",
    branch_name: "NASIK-DWARKA",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0000590",
  },
  {
    branch_code: "591",
    branch_name: "VAKTANA,SURAT",
    category: "RURAL",
    zone: "SURAT",
    ifsc_code: "MAHB0000591",
  },
  {
    branch_code: "592",
    branch_name: "MIROLI",
    category: "RURAL",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0000592",
  },
  {
    branch_code: "593",
    branch_name: "DELHI-PRESS ENCLAVE",
    category: "SEMI URBAN",
    zone: "DELHI",
    ifsc_code: "MAHB0000593",
  },
  {
    branch_code: "594",
    branch_name: "AGRA'M.G.ROAD ",
    category: "METROPOLITAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0000594",
  },
  {
    branch_code: "596",
    branch_name: "NANDURSHINGOTE",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0000596",
  },
  {
    branch_code: "597",
    branch_name: "MULHER",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000597",
  },
  {
    branch_code: "598",
    branch_name: "NAGARSOOL",
    category: "SEMI URBAN",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000598",
  },
  {
    branch_code: "595",
    branch_name: "DAFALAPUR",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000595",
  },
  {
    branch_code: "599",
    branch_name: "WADALI BHOI",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000599",
  },
  {
    branch_code: "600",
    branch_name: "MUKHED",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000600",
  },
  {
    branch_code: "601",
    branch_name: "PUNE-NIGDI",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000601",
  },
  {
    branch_code: "602",
    branch_name: "KHERDI",
    category: "SEMI URBAN",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000602",
  },
  {
    branch_code: "603",
    branch_name: "HEDVI",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000603",
  },
  {
    branch_code: "604",
    branch_name: "VEHELGAON",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000604",
  },
  {
    branch_code: "605",
    branch_name: "ULHASNAGAR-CAMP-III",
    category: "URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0000605",
  },
  {
    branch_code: "606",
    branch_name: "PARASIA",
    category: "SEMI URBAN",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000606",
  },
  {
    branch_code: "607",
    branch_name: "KUKANE",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000607",
  },
  {
    branch_code: "608",
    branch_name: "SOUNDAD",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000608",
  },
  {
    branch_code: "609",
    branch_name: "DAWANA",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0000609",
  },
  {
    branch_code: "610",
    branch_name: "SUNDREL",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0000610",
  },
  {
    branch_code: "611",
    branch_name: "RAJOD",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0000611",
  },
  {
    branch_code: "612",
    branch_name: "DEOGAON RANGARI",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000612",
  },
  {
    branch_code: "613",
    branch_name: "NANDORA",
    category: "SEMI URBAN",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000613",
  },
  {
    branch_code: "614",
    branch_name: "PADHAR",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000614",
  },
  {
    branch_code: "615",
    branch_name: "ANDA",
    category: "RURAL",
    zone: "RAIPUR",
    ifsc_code: "MAHB0000615",
  },
  {
    branch_code: "616",
    branch_name: "GUDI KHEDA",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0000616",
  },
  {
    branch_code: "621",
    branch_name: "THUGAON(PURNANAGAR)",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000621",
  },
  {
    branch_code: "617",
    branch_name: "BHISI",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000617",
  },
  {
    branch_code: "618",
    branch_name: "DEWAI GOVINDPUR",
    category: "URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000618",
  },
  {
    branch_code: "619",
    branch_name: "SATARA-SSI BR.(KRISHNANAGAR)-KHED",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0000619",
  },
  {
    branch_code: "620",
    branch_name: "DHEBEWADI",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000620",
  },
  {
    branch_code: "622",
    branch_name: "UMRI (AKOLA)",
    category: "URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0000622",
  },
  {
    branch_code: "623",
    branch_name: "JUNNAR",
    category: "SEMI URBAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000623",
  },
  {
    branch_code: "625",
    branch_name: "TURKABAD",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000625",
  },
  {
    branch_code: "630",
    branch_name: "PALASPA",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000630",
  },
  {
    branch_code: "624",
    branch_name: "CHITALI",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000624",
  },
  {
    branch_code: "627",
    branch_name: "SHOLAPUR-UJANI COLONY",
    category: "URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000627",
  },
  {
    branch_code: "626",
    branch_name: "PONKAL",
    category: "RURAL",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0000626",
  },
  {
    branch_code: "628",
    branch_name: "PIRAMAN-SSI BRANCH",
    category: "SEMI URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0000628",
  },
  {
    branch_code: "629",
    branch_name: "GHOT",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000629",
  },
  {
    branch_code: "631",
    branch_name: "NAYADONGRI",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000631",
  },
  {
    branch_code: "632",
    branch_name: "DHARNA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000632",
  },
  {
    branch_code: "633",
    branch_name: "HATTA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000633",
  },
  {
    branch_code: "634",
    branch_name: "GANDAI",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0000634",
  },
  {
    branch_code: "635",
    branch_name: "DOMBIVLI-TILAKNAGAR",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000635",
  },
  {
    branch_code: "636",
    branch_name: "MUMBAI-GOREGAON(EAST)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000636",
  },
  {
    branch_code: "637",
    branch_name: "BEJ",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000637",
  },
  {
    branch_code: "638",
    branch_name: "YEODA",
    category: "SEMI URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000638",
  },
  {
    branch_code: "639",
    branch_name: "GADGENAGAR-AMRAVATI",
    category: "URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000639",
  },
  {
    branch_code: "640",
    branch_name: "DASAI",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0000640",
  },
  {
    branch_code: "642",
    branch_name: "THANE-VARTAKNAGAR",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000642",
  },
  {
    branch_code: "641",
    branch_name: "THANGAON",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0000641",
  },
  {
    branch_code: "643",
    branch_name: "VADANGALLI",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0000643",
  },
  {
    branch_code: "644",
    branch_name: "PALARI",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000644",
  },
  {
    branch_code: "645",
    branch_name: "NARAYANPUR(MOHAS)",
    category: "RURAL",
    zone: "JABALPUR",
    ifsc_code: "MAHB0000645",
  },
  {
    branch_code: "646",
    branch_name: "BALKUNWA",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0000646",
  },
  {
    branch_code: "647",
    branch_name: "MALHAR",
    category: "RURAL",
    zone: "RAIPUR",
    ifsc_code: "MAHB0000647",
  },
  {
    branch_code: "648",
    branch_name: "MANDWARA",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0000648",
  },
  {
    branch_code: "650",
    branch_name: "DEORASHTRA",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000650",
  },
  {
    branch_code: "651",
    branch_name: "SHIRPUR",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0000651",
  },
  {
    branch_code: "652",
    branch_name: "RANJANI",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000652",
  },
  {
    branch_code: "653",
    branch_name: "RANI-UNCHEGAON",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000653",
  },
  {
    branch_code: "649",
    branch_name: "TURBHE",
    category: "METROPOLITAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000649",
  },
  {
    branch_code: "654",
    branch_name: "BONKATTA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000654",
  },
  {
    branch_code: "655",
    branch_name: "DAPUR",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0000655",
  },
  {
    branch_code: "656",
    branch_name: "KANASHI",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000656",
  },
  {
    branch_code: "657",
    branch_name: "GUNAWAD",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0000657",
  },
  {
    branch_code: "658",
    branch_name: "BORDEHI",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000658",
  },
  {
    branch_code: "659",
    branch_name: "PARADSINGHA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000659",
  },
  {
    branch_code: "660",
    branch_name: "KODRIA",
    category: "SEMI URBAN",
    zone: "INDORE",
    ifsc_code: "MAHB0000660",
  },
  {
    branch_code: "661",
    branch_name: "KARANJALI",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0000661",
  },
  {
    branch_code: "662",
    branch_name: "KOLHAPUR-SHIVAJI.UNI",
    category: "URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000662",
  },
  {
    branch_code: "663",
    branch_name: "KOHOR",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0000663",
  },
  {
    branch_code: "664",
    branch_name: "NER",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000664",
  },
  {
    branch_code: "665",
    branch_name: "NAGPUR-NANDANVAN COLONY",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000665",
  },
  {
    branch_code: "666",
    branch_name: "MATARGAON BK",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0000666",
  },
  {
    branch_code: "667",
    branch_name: "AHMEDPUR",
    category: "SEMI URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000667",
  },
  {
    branch_code: "669",
    branch_name: "KALWADI",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000669",
  },
  {
    branch_code: "670",
    branch_name: "HASSALPUR",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0000670",
  },
  {
    branch_code: "672",
    branch_name: "NASIK-CANADA CORNER",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0000672",
  },
  {
    branch_code: "674",
    branch_name: "SHREEPUR(BORGAON)",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000674",
  },
  {
    branch_code: "675",
    branch_name: "PUNE-SHANIWAR PETH",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000675",
  },
  {
    branch_code: "678",
    branch_name: "HASNABAD",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000678",
  },
  {
    branch_code: "677",
    branch_name: "RAMPAILI",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000677",
  },
  {
    branch_code: "676",
    branch_name: "CHENNAI-ASHOKNAGAR",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0000676",
  },
  {
    branch_code: "679",
    branch_name: "KHAROD",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0000679",
  },
  {
    branch_code: "680",
    branch_name: "DAUND",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000680",
  },
  {
    branch_code: "681",
    branch_name: "RANJANGAON",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000681",
  },
  {
    branch_code: "682",
    branch_name: "DEHUGAON",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000682",
  },
  {
    branch_code: "683",
    branch_name: "UMRI",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000683",
  },
  {
    branch_code: "685",
    branch_name: "ANJI",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000685",
  },
  {
    branch_code: "686",
    branch_name: "SEONI PANDHURNA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000686",
  },
  {
    branch_code: "684",
    branch_name: "GONDAVALE (BUDRUK)",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000684",
  },
  {
    branch_code: "687",
    branch_name: "IEET",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000687",
  },
  {
    branch_code: "688",
    branch_name: "MASOD",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000688",
  },
  {
    branch_code: "689",
    branch_name: "UGLI",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000689",
  },
  {
    branch_code: "690",
    branch_name: "SILAWAD",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0000690",
  },
  {
    branch_code: "691",
    branch_name: "BARMANDAL",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0000691",
  },
  {
    branch_code: "692",
    branch_name: "JAWHAR",
    category: "SEMI URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0000692",
  },
  {
    branch_code: "693",
    branch_name: "JEE-JAMGAON",
    category: "RURAL",
    zone: "RAIPUR",
    ifsc_code: "MAHB0000693",
  },
  {
    branch_code: "696",
    branch_name: "SUKRI",
    category: "RURAL",
    zone: "JABALPUR",
    ifsc_code: "MAHB0000696",
  },
  {
    branch_code: "697",
    branch_name: "WADOD BAZAR",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000697",
  },
  {
    branch_code: "695",
    branch_name: "MIDC DOMBIVALI",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000695",
  },
  {
    branch_code: "698",
    branch_name: "SATNER",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000698",
  },
  {
    branch_code: "701",
    branch_name: "PATNA",
    category: "METROPOLITAN",
    zone: "PATNA",
    ifsc_code: "MAHB0000701",
  },
  {
    branch_code: "699",
    branch_name: "SAIKHEDA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000699",
  },
  {
    branch_code: "700",
    branch_name: "SULGAON",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0000700",
  },
  {
    branch_code: "703",
    branch_name: "MURBAD",
    category: "SEMI URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0000703",
  },
  {
    branch_code: "704",
    branch_name: "HIMMATNAGAR",
    category: "SEMI URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0000704",
  },
  {
    branch_code: "705",
    branch_name: "SHIRDHON",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000705",
  },
  {
    branch_code: "706",
    branch_name: "KALWA",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000706",
  },
  {
    branch_code: "707",
    branch_name: "PUNE-BIBWEWADI",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000707",
  },
  {
    branch_code: "708",
    branch_name: "JODHPUR-B",
    category: "METROPOLITAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0000708",
  },
  {
    branch_code: "709",
    branch_name: "HIWARKHED",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000709",
  },
  {
    branch_code: "710",
    branch_name: "ACHARA",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000710",
  },
  {
    branch_code: "711",
    branch_name: "TAMBVE",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000711",
  },
  {
    branch_code: "712",
    branch_name: "WADA",
    category: "SEMI URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0000712",
  },
  {
    branch_code: "713",
    branch_name: "BANOTI",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000713",
  },
  {
    branch_code: "702",
    branch_name: "HATHIJAN",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0000702",
  },
  {
    branch_code: "714",
    branch_name: "ANE",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000714",
  },
  {
    branch_code: "715",
    branch_name: "CALCUTTA-S.P.MUKHERJEE ROAD",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0000715",
  },
  {
    branch_code: "716",
    branch_name: "TARSALI",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0000716",
  },
  {
    branch_code: "717",
    branch_name: "KOREGAON-BHIMA",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000717",
  },
  {
    branch_code: "718",
    branch_name: "TAMALWADI",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000718",
  },
  {
    branch_code: "719",
    branch_name: "KURUM",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0000719",
  },
  {
    branch_code: "720",
    branch_name: "ASSADULLABAD",
    category: "URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000720",
  },
  {
    branch_code: "721",
    branch_name: "BUDBUDA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000721",
  },
  {
    branch_code: "722",
    branch_name: "HADOLTI",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0000722",
  },
  {
    branch_code: "723",
    branch_name: "ACHLER",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000723",
  },
  {
    branch_code: "724",
    branch_name: "KOYNANAGAR (Mauli Nagar) ",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000724",
  },
  {
    branch_code: "725",
    branch_name: "KALAMESHWAR BRANCH",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000725",
  },
  {
    branch_code: "726",
    branch_name: "WAIFALE",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000726",
  },
  {
    branch_code: "727",
    branch_name: "PATHARI.",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000727",
  },
  {
    branch_code: "728",
    branch_name: "PORLA",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000728",
  },
  {
    branch_code: "729",
    branch_name: "JANWAL.",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0000729",
  },
  {
    branch_code: "730",
    branch_name: "NARKHEDA BRANCH",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000730",
  },
  {
    branch_code: "731",
    branch_name: "BHOMA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000731",
  },
  {
    branch_code: "732",
    branch_name: "NANDORI",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000732",
  },
  {
    branch_code: "733",
    branch_name: "MAHULI JAHAGIR",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000733",
  },
  {
    branch_code: "734",
    branch_name: "TALEGAON",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000734",
  },
  {
    branch_code: "735",
    branch_name: "CHAUL",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000735",
  },
  {
    branch_code: "736",
    branch_name: "LAKHAMAPUR",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000736",
  },
  {
    branch_code: "737",
    branch_name: "RITHAD",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0000737",
  },
  {
    branch_code: "738",
    branch_name: "VILE (BHIRA)",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000738",
  },
  {
    branch_code: "739",
    branch_name: "KUTASA",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0000739",
  },
  {
    branch_code: "740",
    branch_name: "VADGAON RASAI",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000740",
  },
  {
    branch_code: "741",
    branch_name: "SAGAVE-KATRADEVI WADI",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000741",
  },
  {
    branch_code: "742",
    branch_name: "PARGAON",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000742",
  },
  {
    branch_code: "743",
    branch_name: "TULJAPUR",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000743",
  },
  {
    branch_code: "744",
    branch_name: "TALEGAON DHAMDHERE",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000744",
  },
  {
    branch_code: "745",
    branch_name: "GONDEGAON",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000745",
  },
  {
    branch_code: "746",
    branch_name: "KUNDA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000746",
  },
  {
    branch_code: "747",
    branch_name: "SAOLI",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000747",
  },
  {
    branch_code: "750",
    branch_name: "PUNE-MODEL COLONY.",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000750",
  },
  {
    branch_code: "749",
    branch_name: "KADGAON",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000749",
  },
  {
    branch_code: "751",
    branch_name: "UNDALE",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000751",
  },
  {
    branch_code: "752",
    branch_name: "SATGAON-SAKHARITOLA",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000752",
  },
  {
    branch_code: "753",
    branch_name: "BHOPAL-TATYA TOPE NAGAR",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0000753",
  },
  {
    branch_code: "754",
    branch_name: "AHMEDABAD-NAVRANGPURA",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0000754",
  },
  {
    branch_code: "756",
    branch_name: "PUNE-GANESHNAGAR.",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000756",
  },
  {
    branch_code: "755",
    branch_name: "CHANDOL",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0000755",
  },
  {
    branch_code: "757",
    branch_name: "PANAJ",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0000757",
  },
  {
    branch_code: "758",
    branch_name: "TODALBAGI",
    category: "RURAL",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000758",
  },
  {
    branch_code: "759",
    branch_name: "KELZAR-WARD NO.3",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000759",
  },
  {
    branch_code: "760",
    branch_name: "GANGAKHED (ISAD)",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0000760",
  },
  {
    branch_code: "761",
    branch_name: "MUMBAI-MULUND EAST",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000761",
  },
  {
    branch_code: "762",
    branch_name: "AJANG-VADEL",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000762",
  },
  {
    branch_code: "763",
    branch_name: "KADAVAL",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000763",
  },
  {
    branch_code: "764",
    branch_name: "CHANDIKAPUR",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000764",
  },
  {
    branch_code: "765",
    branch_name: "DHANORAFASI (LONI TAKLI)",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000765",
  },
  {
    branch_code: "766",
    branch_name: "PUNE-CHARHOLI",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000766",
  },
  {
    branch_code: "768",
    branch_name: "INDORE-LOKMANYA NAGAR",
    category: "METROPOLITAN",
    zone: "INDORE",
    ifsc_code: "MAHB0000768",
  },
  {
    branch_code: "769",
    branch_name: "THANE-PANCHPAKHADI",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000769",
  },
  {
    branch_code: "770",
    branch_name: "PATHARI (BABULGAON)",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0000770",
  },
  {
    branch_code: "771",
    branch_name: "DEULGAON GATH",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0000771",
  },
  {
    branch_code: "772",
    branch_name: "BURONDI",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000772",
  },
  {
    branch_code: "773",
    branch_name: "AHMEDABAD-ASHRAM ROAD",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0000773",
  },
  {
    branch_code: "775",
    branch_name: "DHANPURI",
    category: "RURAL",
    zone: "JABALPUR",
    ifsc_code: "MAHB0000775",
  },
  {
    branch_code: "776",
    branch_name: "PUNE-DHANKAWADI",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000776",
  },
  {
    branch_code: "777",
    branch_name: "ARTHE",
    category: "RURAL",
    zone: "JALGAON",
    ifsc_code: "MAHB0000777",
  },
  {
    branch_code: "778",
    branch_name: "NUNSAR",
    category: "RURAL",
    zone: "JABALPUR",
    ifsc_code: "MAHB0000778",
  },
  {
    branch_code: "779",
    branch_name: "JOULKHEDA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000779",
  },
  {
    branch_code: "780",
    branch_name: "MANDANE",
    category: "RURAL",
    zone: "JALGAON",
    ifsc_code: "MAHB0000780",
  },
  {
    branch_code: "781",
    branch_name: "KARMETA( JABALPUR)",
    category: "METROPOLITAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0000781",
  },
  {
    branch_code: "782",
    branch_name: "GANESHPUR",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000782",
  },
  {
    branch_code: "783",
    branch_name: "DAWWA",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000783",
  },
  {
    branch_code: "784",
    branch_name: "PAHELA",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000784",
  },
  {
    branch_code: "785",
    branch_name: "KHAWASA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000785",
  },
  {
    branch_code: "786",
    branch_name: "KARANJA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000786",
  },
  {
    branch_code: "788",
    branch_name: "MANDLA",
    category: "SEMI URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0000788",
  },
  {
    branch_code: "789",
    branch_name: "MUMBAI-MULUND COLONY",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000789",
  },
  {
    branch_code: "790",
    branch_name: "RAMNAGAR",
    category: "RURAL",
    zone: "JABALPUR",
    ifsc_code: "MAHB0000790",
  },
  {
    branch_code: "791",
    branch_name: "KOLKATA-NEW ALIPORE",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0000791",
  },
  {
    branch_code: "792",
    branch_name: "ANANDWAN",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000792",
  },
  {
    branch_code: "793",
    branch_name: "CHASKAMAN",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000793",
  },
  {
    branch_code: "794",
    branch_name: "NEW DELHI-GREATERKAILASH",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0000794",
  },
  {
    branch_code: "795",
    branch_name: "KHAMARIA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000795",
  },
  {
    branch_code: "796",
    branch_name: "BHANEGAON",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000796",
  },
  {
    branch_code: "798",
    branch_name: "CHANDRAPUR-LOHARA",
    category: "URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000798",
  },
  {
    branch_code: "799",
    branch_name: "PADOLI",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000799",
  },
  {
    branch_code: "800",
    branch_name: "ASHTA (SEONI)",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000800",
  },
  {
    branch_code: "801",
    branch_name: "KHADI",
    category: "RURAL",
    zone: "BHOPAL",
    ifsc_code: "MAHB0000801",
  },
  {
    branch_code: "802",
    branch_name: "KHAJURIA KALAN",
    category: "RURAL",
    zone: "BHOPAL",
    ifsc_code: "MAHB0000802",
  },
  {
    branch_code: "803",
    branch_name: "BHAUKHEDI",
    category: "RURAL",
    zone: "BHOPAL",
    ifsc_code: "MAHB0000803",
  },
  {
    branch_code: "804",
    branch_name: "BHEDASGAON",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000804",
  },
  {
    branch_code: "805",
    branch_name: "VELTUR",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000805",
  },
  {
    branch_code: "806",
    branch_name: "NAND",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000806",
  },
  {
    branch_code: "807",
    branch_name: "SARPAWARAM",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0000807",
  },
  {
    branch_code: "808",
    branch_name: "KACHRAUD",
    category: "RURAL",
    zone: "BHOPAL",
    ifsc_code: "MAHB0000808",
  },
  {
    branch_code: "809",
    branch_name: "DIWADIA",
    category: "RURAL",
    zone: "BHOPAL",
    ifsc_code: "MAHB0000809",
  },
  {
    branch_code: "810",
    branch_name: "BIKANER",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0000810",
  },
  {
    branch_code: "811",
    branch_name: "GANDHINAGAR",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0000811",
  },
  {
    branch_code: "812",
    branch_name: "BRAMHAPURI",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000812",
  },
  {
    branch_code: "813",
    branch_name: "SUSTE",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000813",
  },
  {
    branch_code: "814",
    branch_name: "SAKOL",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0000814",
  },
  {
    branch_code: "815",
    branch_name: "MOHADI BRANCH",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0000815",
  },
  {
    branch_code: "816",
    branch_name: "NANDESHWAR",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000816",
  },
  {
    branch_code: "817",
    branch_name: "WATAMBARE",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000817",
  },
  {
    branch_code: "818",
    branch_name: "KOOR BRANCH",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000818",
  },
  {
    branch_code: "819",
    branch_name: "MANJARDE",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000819",
  },
  {
    branch_code: "820",
    branch_name: "JAIKHADA",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000820",
  },
  {
    branch_code: "821",
    branch_name: "BRIJIS NAGAR",
    category: "RURAL",
    zone: "BHOPAL",
    ifsc_code: "MAHB0000821",
  },
  {
    branch_code: "823",
    branch_name: "VEERGAON",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000823",
  },
  {
    branch_code: "839",
    branch_name: "MULTAI",
    category: "SEMI URBAN",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000839",
  },
  {
    branch_code: "824",
    branch_name: "SHINGANAPUR",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000824",
  },
  {
    branch_code: "825",
    branch_name: "GAUDGAON",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000825",
  },
  {
    branch_code: "826",
    branch_name: "SHEMBA",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0000826",
  },
  {
    branch_code: "827",
    branch_name: "KALMAN",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000827",
  },
  {
    branch_code: "828",
    branch_name: "LASURNE",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000828",
  },
  {
    branch_code: "829",
    branch_name: "SAWANGI BAZAR",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000829",
  },
  {
    branch_code: "830",
    branch_name: "CHINCHOLI LIMBAJI",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000830",
  },
  {
    branch_code: "831",
    branch_name: "UDAIPUR",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0000831",
  },
  {
    branch_code: "832",
    branch_name: "NIMGAON",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000832",
  },
  {
    branch_code: "833",
    branch_name: "WADEGAON",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000833",
  },
  {
    branch_code: "834",
    branch_name: "AMBAD INDUESTATE BRANCH",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0000834",
  },
  {
    branch_code: "835",
    branch_name: "SAWALMENDHA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000835",
  },
  {
    branch_code: "836",
    branch_name: "BAWANBIR",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0000836",
  },
  {
    branch_code: "837",
    branch_name: "HAJI TAKLI",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000837",
  },
  {
    branch_code: "838",
    branch_name: "ROHINKHED",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0000838",
  },
  {
    branch_code: "841",
    branch_name: "GHATBORI",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0000841",
  },
  {
    branch_code: "822",
    branch_name: "PUNE-SANGAMWADI",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000822",
  },
  {
    branch_code: "842",
    branch_name: "UGAON",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0000842",
  },
  {
    branch_code: "843",
    branch_name: "KATOL (MURTI)",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000843",
  },
  {
    branch_code: "844",
    branch_name: "RUIKAR COLONY-KOLHAPUR",
    category: "URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000844",
  },
  {
    branch_code: "845",
    branch_name: "DABHADI",
    category: "SEMI URBAN",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000845",
  },
  {
    branch_code: "846",
    branch_name: "JARIPATKA",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000846",
  },
  {
    branch_code: "847",
    branch_name: "MERA (KHURD)",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0000847",
  },
  {
    branch_code: "848",
    branch_name: "WARASEONI",
    category: "SEMI URBAN",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000848",
  },
  {
    branch_code: "849",
    branch_name: "SADASHIVA NAGAR-BELGAUM",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000849",
  },
  {
    branch_code: "850",
    branch_name: "NAROL",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0000850",
  },
  {
    branch_code: "851",
    branch_name: "OLD JALNA",
    category: "URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000851",
  },
  {
    branch_code: "852",
    branch_name: "PUNE-MAYUR COLONY",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000852",
  },
  {
    branch_code: "856",
    branch_name: "TURKEWADI",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000856",
  },
  {
    branch_code: "853",
    branch_name: "PUNE-THERGAON",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000853",
  },
  {
    branch_code: "854",
    branch_name: "GHUGHARIAKHEDI",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0000854",
  },
  {
    branch_code: "855",
    branch_name: "RODIA",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0000855",
  },
  {
    branch_code: "857",
    branch_name: "TARNA",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000857",
  },
  {
    branch_code: "858",
    branch_name: "GHOTAWADE",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000858",
  },
  {
    branch_code: "859",
    branch_name: "PUNE-KONDHAVE (BUDRUK)",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000859",
  },
  {
    branch_code: "860",
    branch_name: "MEDHA",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000860",
  },
  {
    branch_code: "861",
    branch_name: "KANHER",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000861",
  },
  {
    branch_code: "862",
    branch_name: "CHIMANGAON",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000862",
  },
  {
    branch_code: "863",
    branch_name: "VEVJI BRANCH",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0000863",
  },
  {
    branch_code: "864",
    branch_name: "KHANAPUR (AMRAVATI)",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000864",
  },
  {
    branch_code: "865",
    branch_name: "CHINCHOLI",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000865",
  },
  {
    branch_code: "866",
    branch_name: "KHED",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000866",
  },
  {
    branch_code: "867",
    branch_name: "MAHULI CHOR",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000867",
  },
  {
    branch_code: "868",
    branch_name: "PIMPLOD",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000868",
  },
  {
    branch_code: "869",
    branch_name: "BHATKULI",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000869",
  },
  {
    branch_code: "870",
    branch_name: "KANNAMWARGRAM",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000870",
  },
  {
    branch_code: "871",
    branch_name: "RALEGAON SHINDI",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000871",
  },
  {
    branch_code: "872",
    branch_name: "WAKADI",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000872",
  },
  {
    branch_code: "874",
    branch_name: "BHOUR",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000874",
  },
  {
    branch_code: "876",
    branch_name: "BAGMANDALE",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000876",
  },
  {
    branch_code: "877",
    branch_name: "KASHELE",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000877",
  },
  {
    branch_code: "878",
    branch_name: "ACHALPUR",
    category: "URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000878",
  },
  {
    branch_code: "879",
    branch_name: "MASOD-TAPOVAN (AMRAVATI)",
    category: "URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000879",
  },
  {
    branch_code: "875",
    branch_name: "KHADKEWADA",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000875",
  },
  {
    branch_code: "880",
    branch_name: "DESRANE",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000880",
  },
  {
    branch_code: "881",
    branch_name: "LAKHALGAON",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0000881",
  },
  {
    branch_code: "882",
    branch_name: "YESGAON",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000882",
  },
  {
    branch_code: "883",
    branch_name: "HISALE",
    category: "RURAL",
    zone: "JALGAON",
    ifsc_code: "MAHB0000883",
  },
  {
    branch_code: "884",
    branch_name: "PADALDE",
    category: "RURAL",
    zone: "JALGAON",
    ifsc_code: "MAHB0000884",
  },
  {
    branch_code: "885",
    branch_name: "RANJANGAON",
    category: "RURAL",
    zone: "JALGAON",
    ifsc_code: "MAHB0000885",
  },
  {
    branch_code: "886",
    branch_name: "ADKUR",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000886",
  },
  {
    branch_code: "887",
    branch_name: "SAKRA",
    category: "RURAL",
    zone: "JABALPUR",
    ifsc_code: "MAHB0000887",
  },
  {
    branch_code: "888",
    branch_name: "JEEN",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000888",
  },
  {
    branch_code: "889",
    branch_name: "SUSUNDRA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0000889",
  },
  {
    branch_code: "890",
    branch_name: "C.B.D.BRANCH,BELAPUR",
    category: "METROPOLITAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000890",
  },
  {
    branch_code: "891",
    branch_name: "MAKA",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000891",
  },
  {
    branch_code: "892",
    branch_name: "RITHPUR",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000892",
  },
  {
    branch_code: "893",
    branch_name: "PIMPALKOTHE",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000893",
  },
  {
    branch_code: "894",
    branch_name: "SEHORE",
    category: "URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0000894",
  },
  {
    branch_code: "895",
    branch_name: "PUNE-KALE COLONY",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000895",
  },
  {
    branch_code: "896",
    branch_name: "KHARGONE",
    category: "URBAN",
    zone: "INDORE",
    ifsc_code: "MAHB0000896",
  },
  {
    branch_code: "897",
    branch_name: "DHAR",
    category: "SEMI URBAN",
    zone: "INDORE",
    ifsc_code: "MAHB0000897",
  },
  {
    branch_code: "898",
    branch_name: "BHADANE",
    category: "RURAL",
    zone: "JALGAON",
    ifsc_code: "MAHB0000898",
  },
  {
    branch_code: "899",
    branch_name: "PIMPRIGAWALI",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0000899",
  },
  {
    branch_code: "900",
    branch_name: "SHRIWARDHAN",
    category: "SEMI URBAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000900",
  },
  {
    branch_code: "902",
    branch_name: "MUMBAI-ANDHERI(WEST)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000902",
  },
  {
    branch_code: "903",
    branch_name: "WAROOR",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000903",
  },
  {
    branch_code: "904",
    branch_name: "UMBERKHEDA",
    category: "RURAL",
    zone: "JALGAON",
    ifsc_code: "MAHB0000904",
  },
  {
    branch_code: "901",
    branch_name: "DELHI-DR.MUKHARJEE NAGAR",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0000901",
  },
  {
    branch_code: "905",
    branch_name: "DELHI-PREET VIHAR",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0000905",
  },
  {
    branch_code: "906",
    branch_name: "MARTALA",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0000906",
  },
  {
    branch_code: "907",
    branch_name: "SHIROSHI",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0000907",
  },
  {
    branch_code: "908",
    branch_name: "INDURI",
    category: "SEMI URBAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000908",
  },
  {
    branch_code: "909",
    branch_name: "MURUD JANJIRA",
    category: "SEMI URBAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000909",
  },
  {
    branch_code: "910",
    branch_name: "MANGRULPIR",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0000910",
  },
  {
    branch_code: "911",
    branch_name: "SURJI(ANJANGAON)",
    category: "SEMI URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000911",
  },
  {
    branch_code: "912",
    branch_name: "PANSHET",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000912",
  },
  {
    branch_code: "913",
    branch_name: "TERKHEDA",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000913",
  },
  {
    branch_code: "914",
    branch_name: "JATEGAON",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000914",
  },
  {
    branch_code: "916",
    branch_name: "THANEPADA",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0000916",
  },
  {
    branch_code: "915",
    branch_name: "BELGAUM-UMRED",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000915",
  },
  {
    branch_code: "917",
    branch_name: "HARISAL",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000917",
  },
  {
    branch_code: "918",
    branch_name: "HYDERABAD-KHAIRATABAD",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0000918",
  },
  {
    branch_code: "919",
    branch_name: "MOLAGI",
    category: "RURAL",
    zone: "JALGAON",
    ifsc_code: "MAHB0000919",
  },
  {
    branch_code: "921",
    branch_name: "VARASAI",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000921",
  },
  {
    branch_code: "922",
    branch_name: "BHILAR",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000922",
  },
  {
    branch_code: "923",
    branch_name: "DAHEGAON BOLKA",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000923",
  },
  {
    branch_code: "924",
    branch_name: "CHARAN",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000924",
  },
  {
    branch_code: "925",
    branch_name: "CALCUTTA-SHYAM BAZAR",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0000925",
  },
  {
    branch_code: "926",
    branch_name: "AHMEDABAD-KESHAVNAGAR",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0000926",
  },
  {
    branch_code: "927",
    branch_name: "TEMBHE",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000927",
  },
  {
    branch_code: "928",
    branch_name: "LATUR-M I D C AREA",
    category: "URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0000928",
  },
  {
    branch_code: "929",
    branch_name: "AMRAVATI-KHAPARDE BAGICHA",
    category: "URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0000929",
  },
  {
    branch_code: "930",
    branch_name: "SOLAPUR-ASHOK CHOWK",
    category: "URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000930",
  },
  {
    branch_code: "931",
    branch_name: "MAHI-JALGAON",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000931",
  },
  {
    branch_code: "932",
    branch_name: "SALWAN",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000932",
  },
  {
    branch_code: "934",
    branch_name: "SHINDEWADI",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000934",
  },
  {
    branch_code: "935",
    branch_name: "FURSUNGI",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000935",
  },
  {
    branch_code: "936",
    branch_name: "KHAMB",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000936",
  },
  {
    branch_code: "937",
    branch_name: "SAVEDI",
    category: "URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000937",
  },
  {
    branch_code: "938",
    branch_name: "CHHATRAPATI SAMBHAJINAGAR-CIDCO",
    category: "METROPOLITAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0000938",
  },
  {
    branch_code: "939",
    branch_name: "DANG SAUNDANE",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000939",
  },
  {
    branch_code: "940",
    branch_name: "GADCHIROLI",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000940",
  },
  {
    branch_code: "941",
    branch_name: "PUNE-INDUSTRIAL FINANCE",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000941",
  },
  {
    branch_code: "942",
    branch_name: "BANGALORE-RAJESWARI NAGAR",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0000942",
  },
  {
    branch_code: "943",
    branch_name: "WARANGAL",
    category: "URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0000943",
  },
  {
    branch_code: "944",
    branch_name: "KHASBAG-BELGAUM",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000944",
  },
  {
    branch_code: "945",
    branch_name: "BURHANPUR(MP)",
    category: "URBAN",
    zone: "INDORE",
    ifsc_code: "MAHB0000945",
  },
  {
    branch_code: "946",
    branch_name: "BHOPAL-GAUTAMNAGAR",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0000946",
  },
  {
    branch_code: "947",
    branch_name: "AYODHYANAGAR",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000947",
  },
  {
    branch_code: "948",
    branch_name: "MYSORE-JAILAXMIPURAM",
    category: "URBAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0000948",
  },
  {
    branch_code: "949",
    branch_name: "CALCUTTA-MAHATMA GANDHI ROAD",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0000949",
  },
  {
    branch_code: "950",
    branch_name: "NIZAMPUR",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000950",
  },
  {
    branch_code: "951",
    branch_name: "BHAGWAN NAGAR-NAGPUR.",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0000951",
  },
  {
    branch_code: "953",
    branch_name: "OTUR",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000953",
  },
  {
    branch_code: "952",
    branch_name: "TUDIYE",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000952",
  },
  {
    branch_code: "954",
    branch_name: "PUNE-VADGAON SHERI",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000954",
  },
  {
    branch_code: "955",
    branch_name: "HYDERABAD-SAFILGUDA",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0000955",
  },
  {
    branch_code: "956",
    branch_name: "BALLARI",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0000956",
  },
  {
    branch_code: "957",
    branch_name: "BIRWADI",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000957",
  },
  {
    branch_code: "958",
    branch_name: "KINGAON RAJA",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0000958",
  },
  {
    branch_code: "959",
    branch_name: "IGATPURI",
    category: "SEMI URBAN",
    zone: "NASIK",
    ifsc_code: "MAHB0000959",
  },
  {
    branch_code: "960",
    branch_name: "PATAN",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000960",
  },
  {
    branch_code: "961",
    branch_name: "PAHAPAL",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000961",
  },
  {
    branch_code: "962",
    branch_name: "BRAHMANGAON",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000962",
  },
  {
    branch_code: "963",
    branch_name: "KALVAN",
    category: "SEMI URBAN",
    zone: "MALEGAON",
    ifsc_code: "MAHB0000963",
  },
  {
    branch_code: "964",
    branch_name: "MUMBAI-DAHISAR (E)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000964",
  },
  {
    branch_code: "965",
    branch_name: "CHANDANI CHOWK MKT",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0000965",
  },
  {
    branch_code: "966",
    branch_name: "VADGAON (chinchpur Pangul)",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000966",
  },
  {
    branch_code: "967",
    branch_name: "NIMGAON SAVA",
    category: "SEMI URBAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000967",
  },
  {
    branch_code: "968",
    branch_name: "TAKLI BHAN",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0000968",
  },
  {
    branch_code: "969",
    branch_name: "KODOLI",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0000969",
  },
  {
    branch_code: "970",
    branch_name: "PUNE-KARVE NAGAR",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0000970",
  },
  {
    branch_code: "971",
    branch_name: "AHMEDABAD-AMBAWADI",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0000971",
  },
  {
    branch_code: "972",
    branch_name: "CORPORATE FINANCE BRANCH MUMBAI SOUTH",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0000972",
  },
  {
    branch_code: "973",
    branch_name: "CALCUTTA-FIRINGI KALIBARI",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0000973",
  },
  {
    branch_code: "974",
    branch_name: "NEW DELHI-KALKAJI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0000974",
  },
  {
    branch_code: "975",
    branch_name: "KANPUR, KAKADEV(OLD NAME SINDHUNAGAR)",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0000975",
  },
  {
    branch_code: "976",
    branch_name: "NERUL TOWNSHIP",
    category: "METROPOLITAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0000976",
  },
  {
    branch_code: "977",
    branch_name: "KARELI BAUG-VADODARA",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0000977",
  },
  {
    branch_code: "978",
    branch_name: "MUMBAI-FILM CITY AREA(GOREGAO)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000978",
  },
  {
    branch_code: "979",
    branch_name: "PELHAR",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0000979",
  },
  {
    branch_code: "981",
    branch_name: "BYRON BAZAR, RAIPUR",
    category: "METROPOLITAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0000981",
  },
  {
    branch_code: "982",
    branch_name: "MUMBAI-MALAD(E) DEOCHANDNAGAR",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0000982",
  },
  {
    branch_code: "983",
    branch_name: "ATHAWA LINES SURAT",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0000983",
  },
  {
    branch_code: "984",
    branch_name: "CHALE",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000984",
  },
  {
    branch_code: "985",
    branch_name: "TEMBHURDA",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0000985",
  },
  {
    branch_code: "986",
    branch_name: "MHAKVE (BANGE)",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000986",
  },
  {
    branch_code: "987",
    branch_name: "KASHIL",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000987",
  },
  {
    branch_code: "988",
    branch_name: "PETH KINHAI",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000988",
  },
  {
    branch_code: "989",
    branch_name: "KOWAD",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000989",
  },
  {
    branch_code: "990",
    branch_name: "CHINCHOLI RAO",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0000990",
  },
  {
    branch_code: "991",
    branch_name: "BHOO",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000991",
  },
  {
    branch_code: "992",
    branch_name: "PAIT",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0000992",
  },
  {
    branch_code: "993",
    branch_name: "SHEGAON",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0000993",
  },
  {
    branch_code: "994",
    branch_name: "PALSO",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0000994",
  },
  {
    branch_code: "995",
    branch_name: "DANDI",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0000995",
  },
  {
    branch_code: "996",
    branch_name: "VARKUTE MALAVADI",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0000996",
  },
  {
    branch_code: "997",
    branch_name: "KALAS",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0000997",
  },
  {
    branch_code: "998",
    branch_name: "YENEGUR",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0000998",
  },
  {
    branch_code: "999",
    branch_name: "BHOM",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0000999",
  },
  {
    branch_code: "1000",
    branch_name: "PUNE-INDIRA VASAHAT BIBWEWADI",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001000",
  },
  {
    branch_code: "1002",
    branch_name: "SATEPHAL/CHANDUR RAILWAY",
    category: "SEMI URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0001002",
  },
  {
    branch_code: "1003",
    branch_name: "DEOGAON",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0001003",
  },
  {
    branch_code: "1005",
    branch_name: "KORA",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0001005",
  },
  {
    branch_code: "1006",
    branch_name: "OVERSEAS BR-MUMBAI",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0001006",
  },
  {
    branch_code: "1008",
    branch_name: "WIRSHI",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001008",
  },
  {
    branch_code: "1009",
    branch_name: "VADNER KHAKURDI",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0001009",
  },
  {
    branch_code: "1010",
    branch_name: "NANASHI",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0001010",
  },
  {
    branch_code: "1011",
    branch_name: "MODEL TOWN,PANIPAT",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0001011",
  },
  {
    branch_code: "1012",
    branch_name: "KHUTBAO",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001012",
  },
  {
    branch_code: "1013",
    branch_name: "NELKARNJI",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001013",
  },
  {
    branch_code: "1014",
    branch_name: "PIMPALGAON",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001014",
  },
  {
    branch_code: "1015",
    branch_name: "CHAKRATA RD-DEHRADUN",
    category: "URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0001015",
  },
  {
    branch_code: "1016",
    branch_name: "SIRSO",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0001016",
  },
  {
    branch_code: "1018",
    branch_name: "SHRI GANGANAGAR",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001018",
  },
  {
    branch_code: "1019",
    branch_name: "GEORAI BAZAR (JALNA)",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001019",
  },
  {
    branch_code: "1020",
    branch_name: "GEWARDHA",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001020",
  },
  {
    branch_code: "1017",
    branch_name: "KOLHAPUR-SANE GURUJI VASAHAT",
    category: "URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001017",
  },
  {
    branch_code: "1021",
    branch_name: "MICO LAYOUT-BANGALORE",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0001021",
  },
  {
    branch_code: "1022",
    branch_name: "VARKHEDI BK.",
    category: "RURAL",
    zone: "JALGAON",
    ifsc_code: "MAHB0001022",
  },
  {
    branch_code: "1024",
    branch_name: "LOKHANDI SAWARGAON",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0001024",
  },
  {
    branch_code: "1025",
    branch_name: "TPS-PARLI-VAIJNATH",
    category: "SEMI URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0001025",
  },
  {
    branch_code: "1026",
    branch_name: "KASBE TADWALE",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0001026",
  },
  {
    branch_code: "1027",
    branch_name: "KARANJGAVAN",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0001027",
  },
  {
    branch_code: "1028",
    branch_name: "RAJAPUR (NASIK)",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0001028",
  },
  {
    branch_code: "1029",
    branch_name: "MARUL HAVELI",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0001029",
  },
  {
    branch_code: "1030",
    branch_name: "MALE",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001030",
  },
  {
    branch_code: "1031",
    branch_name: "UMBARALE BK.",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0001031",
  },
  {
    branch_code: "1032",
    branch_name: "WASERA",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001032",
  },
  {
    branch_code: "1033",
    branch_name: "MAUSHI/NAGBHIR",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001033",
  },
  {
    branch_code: "1034",
    branch_name: "LAMJANA",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0001034",
  },
  {
    branch_code: "1035",
    branch_name: "UKALIPEN",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0001035",
  },
  {
    branch_code: "1036",
    branch_name: "WASARI",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0001036",
  },
  {
    branch_code: "1037",
    branch_name: "NIMGAON",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0001037",
  },
  {
    branch_code: "1038",
    branch_name: "GADHI",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0001038",
  },
  {
    branch_code: "1040",
    branch_name: "CHAPADGAON",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001040",
  },
  {
    branch_code: "1041",
    branch_name: "KASABA NOOL",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001041",
  },
  {
    branch_code: "1042",
    branch_name: "FARDAPUR",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001042",
  },
  {
    branch_code: "1043",
    branch_name: "SAWALIKHEDA/DHARNI",
    category: "SEMI URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0001043",
  },
  {
    branch_code: "1044",
    branch_name: "GHODADE",
    category: "RURAL",
    zone: "JALGAON",
    ifsc_code: "MAHB0001044",
  },
  {
    branch_code: "1045",
    branch_name: "TARABAI PARK,KOLHAPUR",
    category: "URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001045",
  },
  {
    branch_code: "1046",
    branch_name: "AMGAON DEVALI",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001046",
  },
  {
    branch_code: "1047",
    branch_name: "MANUR",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001047",
  },
  {
    branch_code: "1048",
    branch_name: "NYAHADI",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0001048",
  },
  {
    branch_code: "1049",
    branch_name: "CHIRNER",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001049",
  },
  {
    branch_code: "1050",
    branch_name: "TALMAVALE (DHAMNI)",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0001050",
  },
  {
    branch_code: "1051",
    branch_name: "KAKKERI",
    category: "RURAL",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0001051",
  },
  {
    branch_code: "1053",
    branch_name: "RAJGARH",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0001053",
  },
  {
    branch_code: "1054",
    branch_name: "KHUMAI",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0001054",
  },
  {
    branch_code: "1055",
    branch_name: "MORKHA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0001055",
  },
  {
    branch_code: "1061",
    branch_name: "CHUNALOMA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0001061",
  },
  {
    branch_code: "1064",
    branch_name: "JAMBADA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0001064",
  },
  {
    branch_code: "1056",
    branch_name: "DANAPUR",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001056",
  },
  {
    branch_code: "1057",
    branch_name: "LANJI (RISEWADA)",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0001057",
  },
  {
    branch_code: "1058",
    branch_name: "KHAIRRANJI",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0001058",
  },
  {
    branch_code: "1059",
    branch_name: "AMBOLI",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001059",
  },
  {
    branch_code: "1060",
    branch_name: "NANHORI",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001060",
  },
  {
    branch_code: "1065",
    branch_name: "KAJAL HIPPARGA",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0001065",
  },
  {
    branch_code: "1066",
    branch_name: "GAVASE",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001066",
  },
  {
    branch_code: "1068",
    branch_name: "CHANDUR BISWA",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0001068",
  },
  {
    branch_code: "1069",
    branch_name: "DHANORA (VITALI)",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0001069",
  },
  {
    branch_code: "1070",
    branch_name: "SAGROLI",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0001070",
  },
  {
    branch_code: "1071",
    branch_name: "KUCHANA",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001071",
  },
  {
    branch_code: "1072",
    branch_name: "PUNE-MASULKAR COLONY PIMPRI",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001072",
  },
  {
    branch_code: "1073",
    branch_name: "UPLA (KALIMATH)",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001073",
  },
  {
    branch_code: "1074",
    branch_name: "PIMPRI BK.",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001074",
  },
  {
    branch_code: "1075",
    branch_name: "KONAR",
    category: "RURAL",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001075",
  },
  {
    branch_code: "1076",
    branch_name: "TISGAON",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0001076",
  },
  {
    branch_code: "1077",
    branch_name: "BIJUDHAWADI",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0001077",
  },
  {
    branch_code: "1078",
    branch_name: "JAMB",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0001078",
  },
  {
    branch_code: "1079",
    branch_name: "WARUD BK.",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001079",
  },
  {
    branch_code: "1080",
    branch_name: "VARWAND",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001080",
  },
  {
    branch_code: "1081",
    branch_name: "NIMKHEDI BK.",
    category: "RURAL",
    zone: "JALGAON",
    ifsc_code: "MAHB0001081",
  },
  {
    branch_code: "1082",
    branch_name: "TITUR",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001082",
  },
  {
    branch_code: "1083",
    branch_name: "NEELANGA",
    category: "SEMI URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0001083",
  },
  {
    branch_code: "1084",
    branch_name: "SHIRBHAVI",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0001084",
  },
  {
    branch_code: "1085",
    branch_name: "JALGAON KADEPATHAR",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001085",
  },
  {
    branch_code: "1088",
    branch_name: "CHORA",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001088",
  },
  {
    branch_code: "1089",
    branch_name: "KAIJ (YEOTA)",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0001089",
  },
  {
    branch_code: "1092",
    branch_name: "YELAMBGHAT",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0001092",
  },
  {
    branch_code: "1093",
    branch_name: "POHREGAON",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0001093",
  },
  {
    branch_code: "1095",
    branch_name: "KAUDGAON",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001095",
  },
  {
    branch_code: "1096",
    branch_name: "DHOREGAON",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001096",
  },
  {
    branch_code: "1097",
    branch_name: "KORAI BRANCH",
    category: "RURAL",
    zone: "JALGAON",
    ifsc_code: "MAHB0001097",
  },
  {
    branch_code: "1098",
    branch_name: "KOSAMTONDI",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001098",
  },
  {
    branch_code: "1102",
    branch_name: "SHIVAL (shifted from TULAI)",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0001102",
  },
  {
    branch_code: "1103",
    branch_name: "KHAIRGARH,  SAHASPUR",
    category: "RURAL",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001103",
  },
  {
    branch_code: "1104",
    branch_name: "AKHEGAON",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001104",
  },
  {
    branch_code: "1105",
    branch_name: "MALEGAON MAKTA",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0001105",
  },
  {
    branch_code: "1106",
    branch_name: "NAVALI",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0001106",
  },
  {
    branch_code: "1107",
    branch_name: "WARUL",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001107",
  },
  {
    branch_code: "1108",
    branch_name: "BHAMRAGAD",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001108",
  },
  {
    branch_code: "1109",
    branch_name: "TIMRI BENIKHEDA",
    category: "RURAL",
    zone: "JABALPUR",
    ifsc_code: "MAHB0001109",
  },
  {
    branch_code: "1110",
    branch_name: "KARLA",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001110",
  },
  {
    branch_code: "1111",
    branch_name: "VADESHWAR",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001111",
  },
  {
    branch_code: "1112",
    branch_name: "MUMBAI-LOKHANDWALA COMPLEX",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0001112",
  },
  {
    branch_code: "1113",
    branch_name: "DEHANE",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001113",
  },
  {
    branch_code: "1114",
    branch_name: "SAIWAN",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0001114",
  },
  {
    branch_code: "1115",
    branch_name: "AGASHI",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0001115",
  },
  {
    branch_code: "1116",
    branch_name: "MADH",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001116",
  },
  {
    branch_code: "1117",
    branch_name: "AMBAVADE",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001117",
  },
  {
    branch_code: "1119",
    branch_name: "PANDHARKAWDA",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001119",
  },
  {
    branch_code: "1120",
    branch_name: "PERIMILI",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001120",
  },
  {
    branch_code: "1121",
    branch_name: "PUNE-BALEWADI",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001121",
  },
  {
    branch_code: "1122",
    branch_name: "AKKALKUWA BRANCH",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0001122",
  },
  {
    branch_code: "1123",
    branch_name: "PARGAON",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0001123",
  },
  {
    branch_code: "1124",
    branch_name: "PUNE-NIBM-KONDHWA",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001124",
  },
  {
    branch_code: "1126",
    branch_name: "RAJAHMUNDRY",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0001126",
  },
  {
    branch_code: "1127",
    branch_name: "MAJREWADI-SOLAPUR",
    category: "URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0001127",
  },
  {
    branch_code: "1128",
    branch_name: "TWIN SOLAPUR",
    category: "URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0001128",
  },
  {
    branch_code: "1129",
    branch_name: "Housing Finance Br. (earlier name - Hadapsargaon)",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001129",
  },
  {
    branch_code: "1130",
    branch_name: "SALOKHENAGAR-KOLHAPUR",
    category: "URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001130",
  },
  {
    branch_code: "1131",
    branch_name: "PAILIMETA",
    category: "RURAL",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001131",
  },
  {
    branch_code: "1133",
    branch_name: "VIVEKANAND CHOWK,LATUR.",
    category: "URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0001133",
  },
  {
    branch_code: "1132",
    branch_name: "PUNE-YAMUNANAGAR NIGDI",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001132",
  },
  {
    branch_code: "1134",
    branch_name: "UMARGA",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0001134",
  },
  {
    branch_code: "1135",
    branch_name: "SHIVAJINAGAR-JABALPUR",
    category: "METROPOLITAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0001135",
  },
  {
    branch_code: "1136",
    branch_name: "UMARSARA",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001136",
  },
  {
    branch_code: "1138",
    branch_name: "CHAMPAPETH HYDERABAD",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0001138",
  },
  {
    branch_code: "1139",
    branch_name: "WADGAON CHANDRAPUR",
    category: "URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001139",
  },
  {
    branch_code: "1140",
    branch_name: "PUNE-SSI BRANCH",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001140",
  },
  {
    branch_code: "1141",
    branch_name: "NARENDRANAGAR NAGPUR",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001141",
  },
  {
    branch_code: "1142",
    branch_name: "PUNE-HI-TECH AGRI",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001142",
  },
  {
    branch_code: "1143",
    branch_name: "NASIK-SP HI-TECH AGRIL FINANC",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0001143",
  },
  {
    branch_code: "1144",
    branch_name: "PUNE-OVERSEAS BRANCH",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001144",
  },
  {
    branch_code: "1148",
    branch_name: "DILSUKHNAGAR   ",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0001148",
  },
  {
    branch_code: "1146",
    branch_name: "KORAMANGALA",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0001146",
  },
  {
    branch_code: "1147",
    branch_name: "SSI BANGALORE",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0001147",
  },
  {
    branch_code: "1149",
    branch_name: "MUMBAI-CHARKOP",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0001149",
  },
  {
    branch_code: "1151",
    branch_name: "CHAKAN",
    category: "SEMI URBAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001151",
  },
  {
    branch_code: "1154",
    branch_name: "VADGAON MAVAL",
    category: "SEMI URBAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001154",
  },
  {
    branch_code: "1155",
    branch_name: "J.P.NAGAR, BANGALORE",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0001155",
  },
  {
    branch_code: "1156",
    branch_name: "DAPKI ROAD, AKOLA",
    category: "URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0001156",
  },
  {
    branch_code: "1157",
    branch_name: "WARUD, AMRAVATI",
    category: "SEMI URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0001157",
  },
  {
    branch_code: "1158",
    branch_name: "TALEGAON DABHADE",
    category: "SEMI URBAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001158",
  },
  {
    branch_code: "1159",
    branch_name: "PUNE-'VADGAON BUDRUK",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001159",
  },
  {
    branch_code: "1160",
    branch_name: "U.P.S.C., DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001160",
  },
  {
    branch_code: "1161",
    branch_name: "COLLEGE CAMPUS, JALGAON",
    category: "URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0001161",
  },
  {
    branch_code: "1162",
    branch_name: "BHILAI",
    category: "URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001162",
  },
  {
    branch_code: "1163",
    branch_name: "PHONDA (GOA)",
    category: "SEMI URBAN",
    zone: "GOA",
    ifsc_code: "MAHB0001163",
  },
  {
    branch_code: "1164",
    branch_name: "ANANDNAGAR",
    category: "URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0001164",
  },
  {
    branch_code: "1165",
    branch_name: "KARVENAGAR, NAGPUR",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001165",
  },
  {
    branch_code: "1166",
    branch_name: "MUMBAI- ADARSHNAGAR, WORLI",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0001166",
  },
  {
    branch_code: "1167",
    branch_name: "CHENNAI-SHENOY NAGAR",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0001167",
  },
  {
    branch_code: "1168",
    branch_name: "SATNA",
    category: "URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0001168",
  },
  {
    branch_code: "1169",
    branch_name: "BYTCO COLLEGE, NASIK ROAD",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0001169",
  },
  {
    branch_code: "1170",
    branch_name: "SAINAGAR, AMRAVATI",
    category: "URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0001170",
  },
  {
    branch_code: "1171",
    branch_name: "ATPADI",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001171",
  },
  {
    branch_code: "1172",
    branch_name: "TIRUPATHI",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0001172",
  },
  {
    branch_code: "1173",
    branch_name: "KHED, RATNAGIRI",
    category: "SEMI URBAN",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0001173",
  },
  {
    branch_code: "1174",
    branch_name: "SSPM, SHIVAJI NAGAR, BARSHI",
    category: "URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0001174",
  },
  {
    branch_code: "1175",
    branch_name: "KUKATPALLY(HTYDERABAD)",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0001175",
  },
  {
    branch_code: "1176",
    branch_name: "HARI NAGAR, VADODARA",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0001176",
  },
  {
    branch_code: "1177",
    branch_name: "SHIRDI",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001177",
  },
  {
    branch_code: "1178",
    branch_name: "MUMBAI-SHREEKRISHNANAGAR,BORI",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0001178",
  },
  {
    branch_code: "1179",
    branch_name: "ARVINDNAGAR, HUBLI",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0001179",
  },
  {
    branch_code: "1180",
    branch_name: "INDIRANAGAR, NASIK",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0001180",
  },
  {
    branch_code: "1181",
    branch_name: "CALCUTTA-SALT LAKE",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001181",
  },
  {
    branch_code: "1182",
    branch_name: "BHUBANESHWAR",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0001182",
  },
  {
    branch_code: "1183",
    branch_name: "GOLAKA MANDIR BRANCH, GWALIOR",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0001183",
  },
  {
    branch_code: "1184",
    branch_name: "NAMAKKAL",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0001184",
  },
  {
    branch_code: "1185",
    branch_name: "VITA",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001185",
  },
  {
    branch_code: "1186",
    branch_name: "ANNAPURNA ROAD INDORE",
    category: "METROPOLITAN",
    zone: "INDORE",
    ifsc_code: "MAHB0001186",
  },
  {
    branch_code: "1187",
    branch_name: "MUMBAI-THAKUR VILLAGE KANDIVL",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0001187",
  },
  {
    branch_code: "1188",
    branch_name: "DELHI-JANAKPURI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001188",
  },
  {
    branch_code: "1189",
    branch_name: "GURGAON",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0001189",
  },
  {
    branch_code: "1190",
    branch_name: "PALASIA",
    category: "METROPOLITAN",
    zone: "INDORE",
    ifsc_code: "MAHB0001190",
  },
  {
    branch_code: "1191",
    branch_name: "T.V.CENTRE,HUDCO",
    category: "METROPOLITAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001191",
  },
  {
    branch_code: "1192",
    branch_name: "PORVORIM",
    category: "SEMI URBAN",
    zone: "GOA",
    ifsc_code: "MAHB0001192",
  },
  {
    branch_code: "1193",
    branch_name: "PHAGWARA",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001193",
  },
  {
    branch_code: "1194",
    branch_name: "PANCHKULA",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0001194",
  },
  {
    branch_code: "1195",
    branch_name: "NAGPUR-MUNCIPAL CORPN.,NAGPUR",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001195",
  },
  {
    branch_code: "1196",
    branch_name: "SAVARKAR CHOWK",
    category: "METROPOLITAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001196",
  },
  {
    branch_code: "1197",
    branch_name: "TUMKUR",
    category: "URBAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0001197",
  },
  {
    branch_code: "1198",
    branch_name: "SIVAKASI",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0001198",
  },
  {
    branch_code: "1199",
    branch_name: "KOTTAYAM",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0001199",
  },
  {
    branch_code: "1200",
    branch_name: "SHIVAJI COLLEGE,AKOLA",
    category: "URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0001200",
  },
  {
    branch_code: "1201",
    branch_name: "NOIDA Sector 19",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001201",
  },
  {
    branch_code: "1202",
    branch_name: "JUNAGADH",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001202",
  },
  {
    branch_code: "1203",
    branch_name: "HISSAR",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0001203",
  },
  {
    branch_code: "1204",
    branch_name: "CHENNAI-MYLAPORE",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0001204",
  },
  {
    branch_code: "1205",
    branch_name: "CHENNAI-NEELANGARAI",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0001205",
  },
  {
    branch_code: "1206",
    branch_name: "CHENNAI-VALMIKINAGAR",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0001206",
  },
  {
    branch_code: "1207",
    branch_name: "MUMBAI-OSHIWARA",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0001207",
  },
  {
    branch_code: "1208",
    branch_name: "PUNE-BHUSARI COLONY",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001208",
  },
  {
    branch_code: "1209",
    branch_name: "BHAYANDER (EAST)",
    category: "URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0001209",
  },
  {
    branch_code: "1210",
    branch_name: "PUNE- LULLANAGAR",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001210",
  },
  {
    branch_code: "1213",
    branch_name: "PATIALA BRANCH",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001213",
  },
  {
    branch_code: "1215",
    branch_name: "KUVERBAV  BRANCH",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0001215",
  },
  {
    branch_code: "1216",
    branch_name: "THANE MUNICIPAL CORP.BRANCH",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0001216",
  },
  {
    branch_code: "1219",
    branch_name: "KOLHAPUR-TARARANI VIDYAPEETH",
    category: "URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001219",
  },
  {
    branch_code: "1222",
    branch_name: "MUMBAI-KANNAMWARNAGAR,VIKHROLI(E) BR.",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0001222",
  },
  {
    branch_code: "1223",
    branch_name: "PUNE-KALYANINAGAR ",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001223",
  },
  {
    branch_code: "1224",
    branch_name: "VIJAYNAGAR BRANCH, INDORE",
    category: "METROPOLITAN",
    zone: "INDORE",
    ifsc_code: "MAHB0001224",
  },
  {
    branch_code: "1225",
    branch_name: "ARERA COLONY BRANCH, BHOPAL",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0001225",
  },
  {
    branch_code: "1226",
    branch_name: "CITY CENTRE BRANCH,GWALIOR",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0001226",
  },
  {
    branch_code: "1227",
    branch_name: "THIRUVALLA BRANCH",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0001227",
  },
  {
    branch_code: "1228",
    branch_name: "SARAFA  HOLI BRANCH,  NANDED",
    category: "URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0001228",
  },
  {
    branch_code: "1229",
    branch_name: "CUTTACK BRANCH",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0001229",
  },
  {
    branch_code: "1230",
    branch_name: "BAJRANG CHOWK",
    category: "METROPOLITAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001230",
  },
  {
    branch_code: "1231",
    branch_name: "AJMER BRANCH",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001231",
  },
  {
    branch_code: "1232",
    branch_name: "W.BENGAL HSG.BOARD BR.,KOLKATA",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001232",
  },
  {
    branch_code: "1233",
    branch_name: "RANCHI BRANCH",
    category: "METROPOLITAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0001233",
  },
  {
    branch_code: "1234",
    branch_name: "SIMLA BRANCH",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0001234",
  },
  {
    branch_code: "1235",
    branch_name: "WATAD - KHANDALA  BRANCH",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0001235",
  },
  {
    branch_code: "1237",
    branch_name: "GOMATINAGAR BRANCH, LUCKNOW",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001237",
  },
  {
    branch_code: "1238",
    branch_name: "ROHINI BRANCH,  DELHI",
    category: "URBAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001238",
  },
  {
    branch_code: "1239",
    branch_name: "PASCHIM VIHAR  BRANCH, DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001239",
  },
  {
    branch_code: "1240",
    branch_name: "JAMMU  BRANCH",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001240",
  },
  {
    branch_code: "1241",
    branch_name: "JAMSHEDPUR  BRANCH",
    category: "URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0001241",
  },
  {
    branch_code: "1242",
    branch_name: "NAWANSHAHR  BRANCH",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001242",
  },
  {
    branch_code: "1243",
    branch_name: "MALVIYA NAGAR BRANCH, JAIPUR",
    category: "METROPOLITAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001243",
  },
  {
    branch_code: "1244",
    branch_name: "DWARKA BRANCH, DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001244",
  },
  {
    branch_code: "1245",
    branch_name: "MOHALI(PUNJAB) BRANCH",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001245",
  },
  {
    branch_code: "1246",
    branch_name: "SILIGURI  BRANCH",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001246",
  },
  {
    branch_code: "1247",
    branch_name: "BAPROLA  BRANCH",
    category: "SEMI URBAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001247",
  },
  {
    branch_code: "1248",
    branch_name: "THRISSUR  BRANCH",
    category: "URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0001248",
  },
  {
    branch_code: "1249",
    branch_name: "ALIGANJ BRANCH, LUCKNOW",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001249",
  },
  {
    branch_code: "1250",
    branch_name: "PUSHPANJALI ENCLAVE BR.,DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001250",
  },
  {
    branch_code: "1251",
    branch_name: "MUZAFFARPUR, BIHAR",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0001251",
  },
  {
    branch_code: "1252",
    branch_name: "BARASAT  BRANCH",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001252",
  },
  {
    branch_code: "1253",
    branch_name: "HOWRAH  BRANCH",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001253",
  },
  {
    branch_code: "1255",
    branch_name: "BAHADURGARH,HARYANA",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0001255",
  },
  {
    branch_code: "1256",
    branch_name: "ROHTAK ,HARYANA",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0001256",
  },
  {
    branch_code: "1257",
    branch_name: "MAYUR  VIHAR  BRANCH, DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001257",
  },
  {
    branch_code: "1258",
    branch_name: "DAYANAND VIHAR  BRANCH, DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001258",
  },
  {
    branch_code: "1259",
    branch_name: "SARASWATI BHUVAN COLONY BRANCH",
    category: "METROPOLITAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001259",
  },
  {
    branch_code: "1260",
    branch_name: "STATION ROAD CHHATRAPATI SAMBHAJINAGAR",
    category: "METROPOLITAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001260",
  },
  {
    branch_code: "1261",
    branch_name: "PUNE-BALBHARATI-S.B.ROAD BRANCH",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001261",
  },
  {
    branch_code: "1262",
    branch_name: "GORAKHPUR  BRANCH",
    category: "URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0001262",
  },
  {
    branch_code: "1263",
    branch_name: "UDUPI  BRANCH",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0001263",
  },
  {
    branch_code: "1264",
    branch_name: "NAGERCOIL  BRANCH",
    category: "URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0001264",
  },
  {
    branch_code: "1265",
    branch_name: "BHATINDA BRANCH",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001265",
  },
  {
    branch_code: "1266",
    branch_name: "ECIL ROAD  BRANCH, KHAPRA",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0001266",
  },
  {
    branch_code: "1267",
    branch_name: "MADHAV MAHAVIDYALAYA, GWALIOR",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0001267",
  },
  {
    branch_code: "1268",
    branch_name: "MANDI GOBINDGARH BRANCH",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001268",
  },
  {
    branch_code: "1269",
    branch_name: "RAJA BAZAR BRANCH, PATNA",
    category: "METROPOLITAN",
    zone: "PATNA",
    ifsc_code: "MAHB0001269",
  },
  {
    branch_code: "1270",
    branch_name: "BORING ROAD BRANCH, PATNA",
    category: "METROPOLITAN",
    zone: "PATNA",
    ifsc_code: "MAHB0001270",
  },
  {
    branch_code: "1271",
    branch_name: "GOGAL BRANCH, MARGAO",
    category: "SEMI URBAN",
    zone: "GOA",
    ifsc_code: "MAHB0001271",
  },
  {
    branch_code: "1272",
    branch_name: "BIDHAN NAGAR BRANCH, KOLKATA",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001272",
  },
  {
    branch_code: "1273",
    branch_name: "ERODE  BRANCH",
    category: "URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0001273",
  },
  {
    branch_code: "1274",
    branch_name: "DAYAL BAGH COLONY FARIDABAD",
    category: "METROPOLITAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0001274",
  },
  {
    branch_code: "1275",
    branch_name: "GUWAHATI  BRANCH",
    category: "URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0001275",
  },
  {
    branch_code: "1276",
    branch_name: "KHARGHAR",
    category: "URBAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001276",
  },
  {
    branch_code: "1277",
    branch_name: "ALIGARH  BRANCH",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001277",
  },
  {
    branch_code: "1278",
    branch_name: "AMINABAD  BRANCH, LUCKNOW",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001278",
  },
  {
    branch_code: "1279",
    branch_name: "CHOWK BRANCH, LUCKNOW",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001279",
  },
  {
    branch_code: "1280",
    branch_name: "PUNE-DR.D.Y.PATIL ENGG.COLLEGE BR.",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001280",
  },
  {
    branch_code: "1281",
    branch_name: "VIKAS NAGAR BRANCH, LUCKNOW",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001281",
  },
  {
    branch_code: "1282",
    branch_name: "JAI HIND COLLEGE BRANCH,DEOPUR",
    category: "URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0001282",
  },
  {
    branch_code: "1283",
    branch_name: "AIROLI BRANCH, NAVI MUMBAI",
    category: "METROPOLITAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001283",
  },
  {
    branch_code: "1284",
    branch_name: "R.P.GOGATE COLLEGE, RATNAGIRI",
    category: "SEMI URBAN",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0001284",
  },
  {
    branch_code: "1286",
    branch_name: "ADAJAN   BRANCH, SURAT",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0001286",
  },
  {
    branch_code: "1287",
    branch_name: "MUMBAI-PANTNAGAR BRANCH, GHATKOPAR",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0001287",
  },
  {
    branch_code: "1288",
    branch_name: "ROOP NAGAR BRANCH",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001288",
  },
  {
    branch_code: "1289",
    branch_name: "KHANNA  BRANCH",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001289",
  },
  {
    branch_code: "1290",
    branch_name: "SIGRA,VARANASI BRANCH",
    category: "METROPOLITAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0001290",
  },
  {
    branch_code: "1291",
    branch_name: "CIVIL LINES, ALLAHABAD",
    category: "METROPOLITAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0001291",
  },
  {
    branch_code: "1292",
    branch_name: "CBD BELAPUR SECTOR-11",
    category: "METROPOLITAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001292",
  },
  {
    branch_code: "1293",
    branch_name: "HAPUR BRANCH",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001293",
  },
  {
    branch_code: "1294",
    branch_name: "GREATER NOIDA BRANCH",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001294",
  },
  {
    branch_code: "1295",
    branch_name: "SUSHANT LOK, GURGAON BRANCH",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0001295",
  },
  {
    branch_code: "1296",
    branch_name: "SECTOR-45,CHANDIGARH BRANCH",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0001296",
  },
  {
    branch_code: "1297",
    branch_name: "MOGA BRANCH",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001297",
  },
  {
    branch_code: "1298",
    branch_name: "KALYAN MURBAD BYPASS",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0001298",
  },
  {
    branch_code: "1299",
    branch_name: "BEHELA SAKHER BAZAR ,KOLKATA",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001299",
  },
  {
    branch_code: "1300",
    branch_name: "RUBY PARK,KOLKATA BRANCH",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001300",
  },
  {
    branch_code: "1301",
    branch_name: "MUMBAI-I.C.COLONY,BORIVALI (W) BRANCH",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0001301",
  },
  {
    branch_code: "1302",
    branch_name: "GHODBANDAR ROAD , THANE",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0001302",
  },
  {
    branch_code: "1303",
    branch_name: "JADAVPUR , KOLKATA",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001303",
  },
  {
    branch_code: "1304",
    branch_name: "SRINAGAR",
    category: "METROPOLITAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001304",
  },
  {
    branch_code: "1305",
    branch_name: "GARIA",
    category: "RURAL",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001305",
  },
  {
    branch_code: "1306",
    branch_name: "DWARKA WEST NEW DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001306",
  },
  {
    branch_code: "1307",
    branch_name: "GANDHIDHAM",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001307",
  },
  {
    branch_code: "1308",
    branch_name: "PALAM VIHAR GURGAON",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0001308",
  },
  {
    branch_code: "1309",
    branch_name: "YAMUNANAGAR",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0001309",
  },
  {
    branch_code: "1310",
    branch_name: "HARIDWAR",
    category: "URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0001310",
  },
  {
    branch_code: "1311",
    branch_name: "BURDWAN",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001311",
  },
  {
    branch_code: "1312",
    branch_name: "DHANBAD",
    category: "METROPOLITAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0001312",
  },
  {
    branch_code: "1314",
    branch_name: "MURLINAGAR, VISHAKHAPATTANAM",
    category: "METROPOLITAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0001314",
  },
  {
    branch_code: "1317",
    branch_name: "FEROZABAD",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001317",
  },
  {
    branch_code: "1313",
    branch_name: "VASANT KUNJ, DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001313",
  },
  {
    branch_code: "1315",
    branch_name: "GURDASPUR",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001315",
  },
  {
    branch_code: "1316",
    branch_name: "PATHANKOT",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001316",
  },
  {
    branch_code: "1318",
    branch_name: "AGRA'DEORI ROAD ",
    category: "METROPOLITAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001318",
  },
  {
    branch_code: "1319",
    branch_name: "YELAHANKA, BANGALORE",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0001319",
  },
  {
    branch_code: "1322",
    branch_name: "SANKARACHARYA COLLEGE OF ENGINEERING, BHILLAI",
    category: "URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001322",
  },
  {
    branch_code: "1324",
    branch_name: "EAST KATCHHARI ROAD, MEERUT",
    category: "METROPOLITAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001324",
  },
  {
    branch_code: "1325",
    branch_name: "UJJAIN CHARITABLE TRUST HOSPITAL & RES.CTR., UJJAIN",
    category: "URBAN",
    zone: "INDORE",
    ifsc_code: "MAHB0001325",
  },
  {
    branch_code: "1327",
    branch_name: "TOWN CENTRE",
    category: "METROPOLITAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001327",
  },
  {
    branch_code: "1328",
    branch_name: "PUNE-MODERN COLLEGE ROAD- PUNE",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001328",
  },
  {
    branch_code: "1330",
    branch_name: "VATTIYOORKAVU, THIRUVANANTHAPURAM",
    category: "URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0001330",
  },
  {
    branch_code: "1331",
    branch_name: "AMRAVATI UNIVERSITY BRANCH, AMRAVATI",
    category: "URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0001331",
  },
  {
    branch_code: "1321",
    branch_name: "VIDHARBHA IRRIGATION DEVELOPMENT CORPORATION, NAGPUR",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001321",
  },
  {
    branch_code: "1332",
    branch_name: "INDIRAPURAM, GHAZIABAD",
    category: "METROPOLITAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001332",
  },
  {
    branch_code: "1333",
    branch_name: "GAJUWAKA",
    category: "METROPOLITAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0001333",
  },
  {
    branch_code: "1334",
    branch_name: "GANAPATIPULE",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0001334",
  },
  {
    branch_code: "1337",
    branch_name: "BANGALORE-INDIRANAGAR",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0001337",
  },
  {
    branch_code: "1335",
    branch_name: "BARUIPUR",
    category: "SEMI URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001335",
  },
  {
    branch_code: "1336",
    branch_name: "DURGAPUR",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001336",
  },
  {
    branch_code: "1338",
    branch_name: "RAJARHAT",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001338",
  },
  {
    branch_code: "1339",
    branch_name: "PALWAL",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0001339",
  },
  {
    branch_code: "1340",
    branch_name: "NOIDA, SECTOR 62",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001340",
  },
  {
    branch_code: "1341",
    branch_name: "ASANSOL",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001341",
  },
  {
    branch_code: "1342",
    branch_name: "NEW DELHI, ROHINI, SECTOR-24",
    category: "URBAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001342",
  },
  {
    branch_code: "1343",
    branch_name: "NEW DELHI, RAJOURI GARDEN",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001343",
  },
  {
    branch_code: "1344",
    branch_name: "PUNE-VIMANNAGAR",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001344",
  },
  {
    branch_code: "1345",
    branch_name: "NELLORE",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0001345",
  },
  {
    branch_code: "1346",
    branch_name: "BHILWARA",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001346",
  },
  {
    branch_code: "1347",
    branch_name: "GURGAON, SECTOR-40,",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0001347",
  },
  {
    branch_code: "1350",
    branch_name: "CHINCHINIM, GOA",
    category: "RURAL",
    zone: "GOA",
    ifsc_code: "MAHB0001350",
  },
  {
    branch_code: "1348",
    branch_name: "PUNE- BANER",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001348",
  },
  {
    branch_code: "1349",
    branch_name: "PUNE- WARJE",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001349",
  },
  {
    branch_code: "1353",
    branch_name: "BANSWARA",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001353",
  },
  {
    branch_code: "1354",
    branch_name: "GURGAON, SECTOR-56",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0001354",
  },
  {
    branch_code: "1355",
    branch_name: "PUNE UNIVERSITY CAMPUS- PUNE",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001355",
  },
  {
    branch_code: "1356",
    branch_name: "DELHI, PITAMPURA",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001356",
  },
  {
    branch_code: "1357",
    branch_name: "DELHI, MAYUR VIHAR",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001357",
  },
  {
    branch_code: "1359",
    branch_name: "CHANDIGARH, SECTOE-38D",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0001359",
  },
  {
    branch_code: "1360",
    branch_name: "JAIPUR, VIDYADHARNAGAR",
    category: "METROPOLITAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001360",
  },
  {
    branch_code: "1361",
    branch_name: "KOTHAGUDA",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0001361",
  },
  {
    branch_code: "1362",
    branch_name: "RUDRAPUR",
    category: "URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0001362",
  },
  {
    branch_code: "1363",
    branch_name: "YAMUNAVIHAR, DELHI",
    category: "URBAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001363",
  },
  {
    branch_code: "1364",
    branch_name: "SHAHID BHAGAT SINGH NAGAR, LUDHIANA",
    category: "METROPOLITAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001364",
  },
  {
    branch_code: "1365",
    branch_name: "TREASURY AND INTERNATIONAL BANKING BRANCH",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0001365",
  },
  {
    branch_code: "1367",
    branch_name: "PUNE-HINJAWADI",
    category: "SEMI URBAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001367",
  },
  {
    branch_code: "1366",
    branch_name: "PUNE-KHARADI",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001366",
  },
  {
    branch_code: "1368",
    branch_name: "SOLAPUR-WADIA HOSPITAL",
    category: "URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0001368",
  },
  {
    branch_code: "1372",
    branch_name: "JAIPUR-GOPALPURA BYPASS",
    category: "METROPOLITAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001372",
  },
  {
    branch_code: "1373",
    branch_name: "JAIPUR-CHOPASANI ROAD,JODHPUR",
    category: "METROPOLITAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001373",
  },
  {
    branch_code: "1374",
    branch_name: "JAINAGAR, BANGALORE",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0001374",
  },
  {
    branch_code: "1375",
    branch_name: "PARBHANI-SHIVAJI COLLEGE",
    category: "URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0001375",
  },
  {
    branch_code: "1379",
    branch_name: "Hospital Br, Jabalpur",
    category: "METROPOLITAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0001379",
  },
  {
    branch_code: "1378",
    branch_name: "G S College, Jabalpur",
    category: "METROPOLITAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0001378",
  },
  {
    branch_code: "1381",
    branch_name: "BAREILY",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001381",
  },
  {
    branch_code: "1382",
    branch_name: "Lanja",
    category: "SEMI URBAN",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0001382",
  },
  {
    branch_code: "1383",
    branch_name: "JAYSINGPUR ",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001383",
  },
  {
    branch_code: "1384",
    branch_name: "PUNE PASHAN",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001384",
  },
  {
    branch_code: "1385",
    branch_name: "PUNE BAVADHAN",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001385",
  },
  {
    branch_code: "1387",
    branch_name: "MUMBAI- VIKRIKAR BHAVAN MAZGAON",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0001387",
  },
  {
    branch_code: "1388",
    branch_name: "MUMBAI- MANTRAYALA BR",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0001388",
  },
  {
    branch_code: "1389",
    branch_name: "Gandhinagar, Wardha",
    category: "URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0001389",
  },
  {
    branch_code: "1390",
    branch_name: "MUMBAI- LOWER PAREL.",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0001390",
  },
  {
    branch_code: "1391",
    branch_name: "SONAI",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001391",
  },
  {
    branch_code: "1393",
    branch_name: "JAIPUR",
    category: "METROPOLITAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001393",
  },
  {
    branch_code: "1394",
    branch_name: "GOVINDGARH",
    category: "RURAL",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001394",
  },
  {
    branch_code: "1395",
    branch_name: "KATNI",
    category: "URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0001395",
  },
  {
    branch_code: "1396",
    branch_name: "Kanadia Road, Indore",
    category: "METROPOLITAN",
    zone: "INDORE",
    ifsc_code: "MAHB0001396",
  },
  {
    branch_code: "1397",
    branch_name: "KANKAVALI",
    category: "SEMI URBAN",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0001397",
  },
  {
    branch_code: "1398",
    branch_name: "MEHSANA",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001398",
  },
  {
    branch_code: "1400",
    branch_name: "SATARA PARISAR",
    category: "METROPOLITAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001400",
  },
  {
    branch_code: "1402",
    branch_name: "BUTIBORI ",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001402",
  },
  {
    branch_code: "1403",
    branch_name: "Hudkeshwar, Nagapur",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001403",
  },
  {
    branch_code: "1404",
    branch_name: "BAHRAICH",
    category: "URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001404",
  },
  {
    branch_code: "1405",
    branch_name: "SIDDHARTH NAGAR",
    category: "SEMI URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0001405",
  },
  {
    branch_code: "1401",
    branch_name: "Kausa",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0001401",
  },
  {
    branch_code: "1406",
    branch_name: "KARUR",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0001406",
  },
  {
    branch_code: "1408",
    branch_name: "URLI KANCHAN ",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001408",
  },
  {
    branch_code: "1409",
    branch_name: "JALOCHI",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001409",
  },
  {
    branch_code: "1410",
    branch_name: "ZIRAKPUR",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001410",
  },
  {
    branch_code: "1411",
    branch_name: "AZAMGARH",
    category: "URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0001411",
  },
  {
    branch_code: "1412",
    branch_name: "NAKODAR ROAD, JALANDHAR",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001412",
  },
  {
    branch_code: "1414",
    branch_name: "NAZAFGARH, DELHI",
    category: "SEMI URBAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001414",
  },
  {
    branch_code: "1413",
    branch_name: "PUNE-KATRAJ",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001413",
  },
  {
    branch_code: "1417",
    branch_name: "MANDI ",
    category: "SEMI URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0001417",
  },
  {
    branch_code: "1418",
    branch_name: "TAMBARAM, CHENNAI",
    category: "URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0001418",
  },
  {
    branch_code: "1415",
    branch_name: "BALRAMPUR",
    category: "SEMI URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001415",
  },
  {
    branch_code: "1419",
    branch_name: "KOTHAPET, HYDERABAD",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0001419",
  },
  {
    branch_code: "1420",
    branch_name: "SECTOR - 51, NOIDA",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001420",
  },
  {
    branch_code: "1421",
    branch_name: "MUMBAI-ASHOKVAN, DAHISAR EAST, MUMBAI",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0001421",
  },
  {
    branch_code: "1422",
    branch_name: "BAMBHORI",
    category: "RURAL",
    zone: "JALGAON",
    ifsc_code: "MAHB0001422",
  },
  {
    branch_code: "1423",
    branch_name: "UNA",
    category: "SEMI URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0001423",
  },
  {
    branch_code: "1427",
    branch_name: "RAMPUR",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001427",
  },
  {
    branch_code: "1424",
    branch_name: "LUDHIANA, FOCAL POINT ROAD",
    category: "METROPOLITAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001424",
  },
  {
    branch_code: "1425",
    branch_name: "WAGHOLI",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001425",
  },
  {
    branch_code: "1428",
    branch_name: "JHANSI",
    category: "URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001428",
  },
  {
    branch_code: "1429",
    branch_name: "BASTI",
    category: "URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0001429",
  },
  {
    branch_code: "1430",
    branch_name: "PUNE- PMC",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001430",
  },
  {
    branch_code: "1431",
    branch_name: "PUNE- MSEB",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001431",
  },
  {
    branch_code: "1433",
    branch_name: "BANGALORE, BANASWADI",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0001433",
  },
  {
    branch_code: "1435",
    branch_name: "Ashoka Marg, Nasik",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0001435",
  },
  {
    branch_code: "1436",
    branch_name: "KOPARKHAIRNE",
    category: "METROPOLITAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001436",
  },
  {
    branch_code: "1438",
    branch_name: "JHUNJHUNU",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001438",
  },
  {
    branch_code: "1439",
    branch_name: "JHOTWARA, JAIPUR",
    category: "METROPOLITAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001439",
  },
  {
    branch_code: "1440",
    branch_name: "KOLAR ROAD, BHOPAL",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0001440",
  },
  {
    branch_code: "1441",
    branch_name: "SHANKAR NAGAR, RAIPUR",
    category: "METROPOLITAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001441",
  },
  {
    branch_code: "1437",
    branch_name: "SECTOR - 47-C, CHANDIGARH",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0001437",
  },
  {
    branch_code: "1442",
    branch_name: "NIZAMPET",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0001442",
  },
  {
    branch_code: "1443",
    branch_name: "PUNE- PIMPLE SAUDAGAR",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001443",
  },
  {
    branch_code: "1444",
    branch_name: "PUNE- FATIMANAGAR",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001444",
  },
  {
    branch_code: "1445",
    branch_name: "BAJPE",
    category: "RURAL",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0001445",
  },
  {
    branch_code: "1448",
    branch_name: "BOKARO STEEL CITY",
    category: "URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0001448",
  },
  {
    branch_code: "1451",
    branch_name: "ADYAR",
    category: "RURAL",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0001451",
  },
  {
    branch_code: "1457",
    branch_name: "HIVRE BAJAR",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001457",
  },
  {
    branch_code: "1455",
    branch_name: "SECTOR-9A, GURGAON",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0001455",
  },
  {
    branch_code: "1459",
    branch_name: "NARHE, PUNE",
    category: "SEMI URBAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001459",
  },
  {
    branch_code: "1460",
    branch_name: "NARAYANGAVHAN",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001460",
  },
  {
    branch_code: "1461",
    branch_name: "SOHNA ROAD, GURGAON",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0001461",
  },
  {
    branch_code: "1463",
    branch_name: "SAGAR",
    category: "URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0001463",
  },
  {
    branch_code: "1462",
    branch_name: "SIHORA",
    category: "SEMI URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0001462",
  },
  {
    branch_code: "1467",
    branch_name: "SANGOLA",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0001467",
  },
  {
    branch_code: "1464",
    branch_name: "MAHALUNGE",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001464",
  },
  {
    branch_code: "1466",
    branch_name: "CHIKHALI",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0001466",
  },
  {
    branch_code: "1465",
    branch_name: "SAHARANPUR",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001465",
  },
  {
    branch_code: "1470",
    branch_name: "VIDISHA",
    category: "URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0001470",
  },
  {
    branch_code: "1468",
    branch_name: "RAVER",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0001468",
  },
  {
    branch_code: "1473",
    branch_name: "MOUKHALI",
    category: "RURAL",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001473",
  },
  {
    branch_code: "1474",
    branch_name: "NAGAON",
    category: "URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0001474",
  },
  {
    branch_code: "1475",
    branch_name: "TEZPUR",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0001475",
  },
  {
    branch_code: "1479",
    branch_name: "SIKAR",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001479",
  },
  {
    branch_code: "1480",
    branch_name: "SUJANGARH",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001480",
  },
  {
    branch_code: "1478",
    branch_name: "KAMOTHE",
    category: "URBAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001478",
  },
  {
    branch_code: "1477",
    branch_name: "MAHASAMUND",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001477",
  },
  {
    branch_code: "1476",
    branch_name: "HUPARI",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001476",
  },
  {
    branch_code: "1488",
    branch_name: "Shahade",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0001488",
  },
  {
    branch_code: "1481",
    branch_name: "KOHAT ENCLAVE, DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001481",
  },
  {
    branch_code: "1471",
    branch_name: "SARNI",
    category: "SEMI URBAN",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0001471",
  },
  {
    branch_code: "1489",
    branch_name: "RAJPURA",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001489",
  },
  {
    branch_code: "1469",
    branch_name: "HOSHANGABAD",
    category: "URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0001469",
  },
  {
    branch_code: "1472",
    branch_name: "TIMARNI",
    category: "SEMI URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0001472",
  },
  {
    branch_code: "1485",
    branch_name: "BHIWADI",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001485",
  },
  {
    branch_code: "1487",
    branch_name: "ALWAR",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001487",
  },
  {
    branch_code: "1486",
    branch_name: "RAJA PARK, JAIPUR",
    category: "METROPOLITAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001486",
  },
  {
    branch_code: "1499",
    branch_name: "MORADABAD",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001499",
  },
  {
    branch_code: "1482",
    branch_name: "NERUL WEST SECTOR-8, NAVI MUMBAI",
    category: "METROPOLITAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001482",
  },
  {
    branch_code: "1483",
    branch_name: "BIDAR",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0001483",
  },
  {
    branch_code: "1490",
    branch_name: "MUKTSAR",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001490",
  },
  {
    branch_code: "1491",
    branch_name: "BARWALA",
    category: "RURAL",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0001491",
  },
  {
    branch_code: "1492",
    branch_name: "CHUNNI KALAN",
    category: "RURAL",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001492",
  },
  {
    branch_code: "1484",
    branch_name: "PUNE-NAVI SANGAVI- PUNE",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001484",
  },
  {
    branch_code: "1515",
    branch_name: "NARANPURA, AHMEDABAD",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001515",
  },
  {
    branch_code: "1516",
    branch_name: "SATELLITE, AHMEDABAD",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001516",
  },
  {
    branch_code: "1517",
    branch_name: "VASTRAPUR, AHMEDABAD",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001517",
  },
  {
    branch_code: "1518",
    branch_name: "SANAND",
    category: "SEMI URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001518",
  },
  {
    branch_code: "1519",
    branch_name: "SURENDRANAGAR",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001519",
  },
  {
    branch_code: "1513",
    branch_name: "JAMKHANDI",
    category: "SEMI URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0001513",
  },
  {
    branch_code: "1520",
    branch_name: "PUSAD",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001520",
  },
  {
    branch_code: "1501",
    branch_name: "JHARNA",
    category: "RURAL",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001501",
  },
  {
    branch_code: "1506",
    branch_name: "GANGTOK",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001506",
  },
  {
    branch_code: "1509",
    branch_name: "SURYAPET",
    category: "URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0001509",
  },
  {
    branch_code: "1521",
    branch_name: "PRENEM",
    category: "RURAL",
    zone: "GOA",
    ifsc_code: "MAHB0001521",
  },
  {
    branch_code: "1524",
    branch_name: "HOSUR",
    category: "URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0001524",
  },
  {
    branch_code: "1525",
    branch_name: "SENDURWAFA",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001525",
  },
  {
    branch_code: "1523",
    branch_name: "SIKANDRA, AGRA",
    category: "METROPOLITAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001523",
  },
  {
    branch_code: "1514",
    branch_name: "MURNAD (Kanthur) ",
    category: "RURAL",
    zone: "BENGALURU",
    ifsc_code: "MAHB0001514",
  },
  {
    branch_code: "1510",
    branch_name: "ITANAGAR",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0001510",
  },
  {
    branch_code: "1512",
    branch_name: "KISHANGARH",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001512",
  },
  {
    branch_code: "1526",
    branch_name: "ELURU",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0001526",
  },
  {
    branch_code: "1493",
    branch_name: "KAPURTHALA ",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001493",
  },
  {
    branch_code: "1530",
    branch_name: "VAISHALI GHAZIABAD",
    category: "METROPOLITAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001530",
  },
  {
    branch_code: "1532",
    branch_name: "MAU, MOHANLALGANJ",
    category: "SEMI URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001532",
  },
  {
    branch_code: "1538",
    branch_name: "BHARUCH",
    category: "URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0001538",
  },
  {
    branch_code: "1534",
    branch_name: "CANCONA",
    category: "SEMI URBAN",
    zone: "GOA",
    ifsc_code: "MAHB0001534",
  },
  {
    branch_code: "1537",
    branch_name: "ALKAPURI, VADODARA",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0001537",
  },
  {
    branch_code: "1539",
    branch_name: "SURAT CITY LIGHT",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0001539",
  },
  {
    branch_code: "1533",
    branch_name: "GUWAHATI-GANESHGURI",
    category: "URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0001533",
  },
  {
    branch_code: "1535",
    branch_name: "AMBATTUR (CHEENAI) ",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0001535",
  },
  {
    branch_code: "1527",
    branch_name: "ONGOLE",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0001527",
  },
  {
    branch_code: "1531",
    branch_name: "JAHIRA",
    category: "RURAL",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001531",
  },
  {
    branch_code: "1540",
    branch_name: "PITHAMPUR",
    category: "URBAN",
    zone: "INDORE",
    ifsc_code: "MAHB0001540",
  },
  {
    branch_code: "1542",
    branch_name: "RAJKOT-SADHUWASAWANI RD",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001542",
  },
  {
    branch_code: "1543",
    branch_name: "MADHAPAR",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001543",
  },
  {
    branch_code: "1544",
    branch_name: "BHUJ",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001544",
  },
  {
    branch_code: "1545",
    branch_name: "VADNAGAR",
    category: "SEMI URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001545",
  },
  {
    branch_code: "1546",
    branch_name: "KADI",
    category: "SEMI URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001546",
  },
  {
    branch_code: "1547",
    branch_name: "ZARI-JAMANI",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001547",
  },
  {
    branch_code: "1548",
    branch_name: "MULCHERA",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001548",
  },
  {
    branch_code: "1549",
    branch_name: "ASANGAON",
    category: "SEMI URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0001549",
  },
  {
    branch_code: "1536",
    branch_name: "VAPI",
    category: "URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0001536",
  },
  {
    branch_code: "1551",
    branch_name: "DIBRUGARH",
    category: "URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0001551",
  },
  {
    branch_code: "1553",
    branch_name: "SEAWOOD WEST, NAVI MUMBAI",
    category: "METROPOLITAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001553",
  },
  {
    branch_code: "1554",
    branch_name: "DIGHI",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001554",
  },
  {
    branch_code: "1555",
    branch_name: "NEPTI-APMC YARD ",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001555",
  },
  {
    branch_code: "1552",
    branch_name: "TAMRALIPTA(TAMLUK)",
    category: "SEMI URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001552",
  },
  {
    branch_code: "1562",
    branch_name: "GHAZIPUR",
    category: "URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0001562",
  },
  {
    branch_code: "1564",
    branch_name: "RAMPURA",
    category: "RURAL",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001564",
  },
  {
    branch_code: "1571",
    branch_name: "KARJAT ",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001571",
  },
  {
    branch_code: "1575",
    branch_name: "KOLHAPUR , MID CORPORATE(Gokul Shirgaon)",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001575",
  },
  {
    branch_code: "1578",
    branch_name: "MID CORPORATE WALUJ",
    category: "SEMI URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001578",
  },
  {
    branch_code: "1565",
    branch_name: "SHILONG ",
    category: "URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0001565",
  },
  {
    branch_code: "1566",
    branch_name: "JORHAT",
    category: "URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0001566",
  },
  {
    branch_code: "1567",
    branch_name: "TILHARI ",
    category: "METROPOLITAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0001567",
  },
  {
    branch_code: "1568",
    branch_name: "TINSUKIA",
    category: "URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0001568",
  },
  {
    branch_code: "1572",
    branch_name: "KHAMMAM",
    category: "URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0001572",
  },
  {
    branch_code: "1576",
    branch_name: "AMBEGAON ",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001576",
  },
  {
    branch_code: "1577",
    branch_name: "BALAPUR",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0001577",
  },
  {
    branch_code: "1579",
    branch_name: "BASNA",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001579",
  },
  {
    branch_code: "1580",
    branch_name: "KENDRI ",
    category: "RURAL",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001580",
  },
  {
    branch_code: "1581",
    branch_name: "CARAPUR (Vithalpur)",
    category: "RURAL",
    zone: "GOA",
    ifsc_code: "MAHB0001581",
  },
  {
    branch_code: "1561",
    branch_name: "BANTHRA",
    category: "SEMI URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001561",
  },
  {
    branch_code: "1584",
    branch_name: "KARANJA(LAD)",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0001584",
  },
  {
    branch_code: "1585",
    branch_name: "MUZAFFARNAGAR",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001585",
  },
  {
    branch_code: "1586",
    branch_name: "VANASTHALIPURAM, (HYD)",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0001586",
  },
  {
    branch_code: "1582",
    branch_name: "KASARVADAVALI , THANE ",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0001582",
  },
  {
    branch_code: "1583",
    branch_name: "AGARTALA",
    category: "URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0001583",
  },
  {
    branch_code: "1587",
    branch_name: "MUMBAI-GHATKOPAR (WEST)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0001587",
  },
  {
    branch_code: "1589",
    branch_name: "MATHURA",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001589",
  },
  {
    branch_code: "1590",
    branch_name: "CHOPDA",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0001590",
  },
  {
    branch_code: "1574",
    branch_name: "RAMAKONA ",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0001574",
  },
  {
    branch_code: "1593",
    branch_name: "RAJURA ",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001593",
  },
  {
    branch_code: "1591",
    branch_name: "ROURKELA ",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0001591",
  },
  {
    branch_code: "1594",
    branch_name: "PUNE-RAVET ",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001594",
  },
  {
    branch_code: "1595",
    branch_name: "VIKASPURI, DELHI ",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001595",
  },
  {
    branch_code: "1592",
    branch_name: "AIZAWL ",
    category: "URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0001592",
  },
  {
    branch_code: "1596",
    branch_name: "HAZARIBAG",
    category: "URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0001596",
  },
  {
    branch_code: "1588",
    branch_name: "MUMBAI-JOGESHWARI(WEST)",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0001588",
  },
  {
    branch_code: "1598",
    branch_name: "KHARAGPUR",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001598",
  },
  {
    branch_code: "1599",
    branch_name: "BHAGALPUR",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0001599",
  },
  {
    branch_code: "1600",
    branch_name: "MALDA ",
    category: "SEMI URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001600",
  },
  {
    branch_code: "1601",
    branch_name: "PATAN(GUJARAT)",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001601",
  },
  {
    branch_code: "1602",
    branch_name: "MEERA ROAD EAST ",
    category: "URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0001602",
  },
  {
    branch_code: "1603",
    branch_name: "AMBUR",
    category: "URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0001603",
  },
  {
    branch_code: "1604",
    branch_name: "TIRUNELVALI",
    category: "URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0001604",
  },
  {
    branch_code: "1560",
    branch_name: "KALLI(WEST)",
    category: "SEMI URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001560",
  },
  {
    branch_code: "1605",
    branch_name: "PARABDA",
    category: "RURAL",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001605",
  },
  {
    branch_code: "1606",
    branch_name: "KHEDGAON ",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0001606",
  },
  {
    branch_code: "1607",
    branch_name: "KARANJWAN ",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0001607",
  },
  {
    branch_code: "1609",
    branch_name: "DEORUKH",
    category: "SEMI URBAN",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0001609",
  },
  {
    branch_code: "1608",
    branch_name: "BABHALESHWAR ",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001608",
  },
  {
    branch_code: "1611",
    branch_name: "KOKAMTHAN ",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001611",
  },
  {
    branch_code: "1615",
    branch_name: "PUNE-MOHAMADWADI ",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001615",
  },
  {
    branch_code: "1610",
    branch_name: "PUNE-INDRAYANINAGAR- BHOSARI",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001610",
  },
  {
    branch_code: "1620",
    branch_name: "KARANJA GHADGE ",
    category: "SEMI URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0001620",
  },
  {
    branch_code: "1616",
    branch_name: "BHICHOLI MARDANA",
    category: "METROPOLITAN",
    zone: "INDORE",
    ifsc_code: "MAHB0001616",
  },
  {
    branch_code: "1622",
    branch_name: "GARGOTI (BHUDARGAD)",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001622",
  },
  {
    branch_code: "1623",
    branch_name: "TAKLI (PRAGANE/DEHARE)",
    category: "RURAL",
    zone: "JALGAON",
    ifsc_code: "MAHB0001623",
  },
  {
    branch_code: "1624",
    branch_name: "BAWADA ",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001624",
  },
  {
    branch_code: "1625",
    branch_name: "VADGAON-NIMBALKAR ",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001625",
  },
  {
    branch_code: "1638",
    branch_name: "BILIMORA ",
    category: "SEMI URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0001638",
  },
  {
    branch_code: "1612",
    branch_name: "SHEVGAON",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001612",
  },
  {
    branch_code: "1618",
    branch_name: "DAPOLI",
    category: "SEMI URBAN",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0001618",
  },
  {
    branch_code: "1628",
    branch_name: "ADGAON ",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0001628",
  },
  {
    branch_code: "1629",
    branch_name: "LONAND ",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0001629",
  },
  {
    branch_code: "1630",
    branch_name: "KHANDALA (SATARA)",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0001630",
  },
  {
    branch_code: "1631",
    branch_name: "BARDOLI ",
    category: "SEMI URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0001631",
  },
  {
    branch_code: "1632",
    branch_name: "CHANGODAR ",
    category: "SEMI URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001632",
  },
  {
    branch_code: "1633",
    branch_name: "DODAMARG ",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0001633",
  },
  {
    branch_code: "1634",
    branch_name: "VAIBHAVWADI ",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0001634",
  },
  {
    branch_code: "1635",
    branch_name: "VENGURLA ",
    category: "SEMI URBAN",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0001635",
  },
  {
    branch_code: "1637",
    branch_name: "HALOL",
    category: "SEMI URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0001637",
  },
  {
    branch_code: "1597",
    branch_name: "NEW PANVEL ",
    category: "URBAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001597",
  },
  {
    branch_code: "1647",
    branch_name: "MADHUVANAHALLI ",
    category: "RURAL",
    zone: "BENGALURU",
    ifsc_code: "MAHB0001647",
  },
  {
    branch_code: "1627",
    branch_name: "NIDEBAN ",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0001627",
  },
  {
    branch_code: "1636",
    branch_name: "KADEGAON",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001636",
  },
  {
    branch_code: "1613",
    branch_name: "CHAPRA ",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0001613",
  },
  {
    branch_code: "1626",
    branch_name: "ARNI",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001626",
  },
  {
    branch_code: "1639",
    branch_name: "RAJAGAMBIRAM ",
    category: "RURAL",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0001639",
  },
  {
    branch_code: "1643",
    branch_name: "KHADKI-BK",
    category: "URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0001643",
  },
  {
    branch_code: "1646",
    branch_name: "SONARI",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001646",
  },
  {
    branch_code: "1614",
    branch_name: "AURANGABAD(BIHAR)",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0001614",
  },
  {
    branch_code: "1621",
    branch_name: "KATHORA (BK)",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0001621",
  },
  {
    branch_code: "1649",
    branch_name: "NIPHAD ",
    category: "SEMI URBAN",
    zone: "NASIK",
    ifsc_code: "MAHB0001649",
  },
  {
    branch_code: "1645",
    branch_name: "KARJAT(RAIGAD)",
    category: "SEMI URBAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001645",
  },
  {
    branch_code: "1651",
    branch_name: "TUMSAR",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001651",
  },
  {
    branch_code: "1648",
    branch_name: "GUNJALWADI",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001648",
  },
  {
    branch_code: "1652",
    branch_name: "MAHADULA ",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001652",
  },
  {
    branch_code: "1650",
    branch_name: "PARTUR",
    category: "SEMI URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001650",
  },
  {
    branch_code: "1642",
    branch_name: "WAKODI PHATA ",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001642",
  },
  {
    branch_code: "1641",
    branch_name: "AKOLE",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001641",
  },
  {
    branch_code: "1653",
    branch_name: "DONDAICHA",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0001653",
  },
  {
    branch_code: "1657",
    branch_name: "KUMHARI",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001657",
  },
  {
    branch_code: "1658",
    branch_name: "DHAMADHA",
    category: "RURAL",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001658",
  },
  {
    branch_code: "1619",
    branch_name: "SHRIGONDA",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001619",
  },
  {
    branch_code: "1617",
    branch_name: "DUDHIA",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0001617",
  },
  {
    branch_code: "1656",
    branch_name: "MALKAPUR (KARAD)",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0001656",
  },
  {
    branch_code: "1655",
    branch_name: "GARAULI",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0001655",
  },
  {
    branch_code: "1667",
    branch_name: "MUDHOL",
    category: "SEMI URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0001667",
  },
  {
    branch_code: "1654",
    branch_name: "CHANDAPURA",
    category: "RURAL",
    zone: "BENGALURU",
    ifsc_code: "MAHB0001654",
  },
  {
    branch_code: "1659",
    branch_name: "SANGRUR",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001659",
  },
  {
    branch_code: "1662",
    branch_name: "MANOHARPUR",
    category: "SEMI URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001662",
  },
  {
    branch_code: "1666",
    branch_name: "BADORA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0001666",
  },
  {
    branch_code: "1669",
    branch_name: "KARMALA ",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0001669",
  },
  {
    branch_code: "1668",
    branch_name: "MANGAON ",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001668",
  },
  {
    branch_code: "1671",
    branch_name: "NAVAPUR ",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0001671",
  },
  {
    branch_code: "1673",
    branch_name: "LAMTI ",
    category: "METROPOLITAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0001673",
  },
  {
    branch_code: "1674",
    branch_name: "ULAWE",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001674",
  },
  {
    branch_code: "1640",
    branch_name: "IMPHAL ",
    category: "URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0001640",
  },
  {
    branch_code: "1663",
    branch_name: "DOSTIPUR ",
    category: "RURAL",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001663",
  },
  {
    branch_code: "1672",
    branch_name: "TIRODA ",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001672",
  },
  {
    branch_code: "1675",
    branch_name: "KOLKI",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0001675",
  },
  {
    branch_code: "1678",
    branch_name: "MANTHA ",
    category: "SEMI URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001678",
  },
  {
    branch_code: "1679",
    branch_name: "TRIMBAKESHWAR ",
    category: "SEMI URBAN",
    zone: "NASIK",
    ifsc_code: "MAHB0001679",
  },
  {
    branch_code: "1683",
    branch_name: "KASARAGOD ",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0001683",
  },
  {
    branch_code: "1676",
    branch_name: "HASSAN",
    category: "URBAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0001676",
  },
  {
    branch_code: "1680",
    branch_name: "HATKANGALE ",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001680",
  },
  {
    branch_code: "1694",
    branch_name: "MEHKAR",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0001694",
  },
  {
    branch_code: "1685",
    branch_name: "KANGRA ",
    category: "RURAL",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0001685",
  },
  {
    branch_code: "1686",
    branch_name: "PUNE-PIMPALE GURAV- PUNE ",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001686",
  },
  {
    branch_code: "1689",
    branch_name: "BEED, NAGAR RD ",
    category: "URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0001689",
  },
  {
    branch_code: "1670",
    branch_name: "BERHAMPUR ",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0001670",
  },
  {
    branch_code: "1688",
    branch_name: "NARSINGHPUR ",
    category: "SEMI URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0001688",
  },
  {
    branch_code: "1697",
    branch_name: "DHAMTARI ",
    category: "URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001697",
  },
  {
    branch_code: "1695",
    branch_name: "KORBA",
    category: "URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001695",
  },
  {
    branch_code: "1696",
    branch_name: "RAIGARH",
    category: "URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001696",
  },
  {
    branch_code: "1698",
    branch_name: "AMBIKAPUR ",
    category: "URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001698",
  },
  {
    branch_code: "1703",
    branch_name: "BADSA ",
    category: "RURAL",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0001703",
  },
  {
    branch_code: "1701",
    branch_name: "BEHROR ",
    category: "SEMI URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001701",
  },
  {
    branch_code: "1702",
    branch_name: "JIND",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0001702",
  },
  {
    branch_code: "1707",
    branch_name: "MAHABOOB NAGAR ",
    category: "URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0001707",
  },
  {
    branch_code: "1682",
    branch_name: "SEEGEHALLI ",
    category: "RURAL",
    zone: "BENGALURU",
    ifsc_code: "MAHB0001682",
  },
  {
    branch_code: "1664",
    branch_name: "BARABANKI ",
    category: "SEMI URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001664",
  },
  {
    branch_code: "1693",
    branch_name: "PADRAUNA ",
    category: "SEMI URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0001693",
  },
  {
    branch_code: "1690",
    branch_name: "ANEKAL ",
    category: "SEMI URBAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0001690",
  },
  {
    branch_code: "1699",
    branch_name: "SAKHARNAGAR, NAGPUR ",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001699",
  },
  {
    branch_code: "1700",
    branch_name: "JHARSUGUDA ",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0001700",
  },
  {
    branch_code: "1712",
    branch_name: "MADHUBANI ",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0001712",
  },
  {
    branch_code: "1713",
    branch_name: "MODINAGAR",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001713",
  },
  {
    branch_code: "1716",
    branch_name: "PUNE-B.T.KAWADE RD ",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001716",
  },
  {
    branch_code: "1717",
    branch_name: "YASHODANAGAR, AMRAVATI",
    category: "URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0001717",
  },
  {
    branch_code: "1719",
    branch_name: "RISOD ",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0001719",
  },
  {
    branch_code: "1737",
    branch_name: "AUSA ROAD, LATUR ",
    category: "URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0001737",
  },
  {
    branch_code: "1739",
    branch_name: "KARMAD ",
    category: "RURAL",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001739",
  },
  {
    branch_code: "1745",
    branch_name: "PUNE-NANDED PHATA ",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001745",
  },
  {
    branch_code: "1661",
    branch_name: "PRATAPGARH ",
    category: "SEMI URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0001661",
  },
  {
    branch_code: "1718",
    branch_name: "WALIV (VASAI)",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0001718",
  },
  {
    branch_code: "1711",
    branch_name: "DARBHANGA ",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0001711",
  },
  {
    branch_code: "1720",
    branch_name: "HANUMANGARH ",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001720",
  },
  {
    branch_code: "1749",
    branch_name: "BHUGAON ",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001749",
  },
  {
    branch_code: "1750",
    branch_name: "PIMPALWANDI ",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001750",
  },
  {
    branch_code: "1752",
    branch_name: "KALAMNURI ",
    category: "SEMI URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0001752",
  },
  {
    branch_code: "1738",
    branch_name: "PIMPALGAON BASWANT ",
    category: "SEMI URBAN",
    zone: "NASIK",
    ifsc_code: "MAHB0001738",
  },
  {
    branch_code: "1733",
    branch_name: "KANPUR, GOVINDNAGAR",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001733",
  },
  {
    branch_code: "1714",
    branch_name: "BELWADI ",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001714",
  },
  {
    branch_code: "1725",
    branch_name: "SIVASAGAR",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0001725",
  },
  {
    branch_code: "1723",
    branch_name: "GIRIDIH ",
    category: "URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0001723",
  },
  {
    branch_code: "1734",
    branch_name: "LAWRENCE RD, DELHI ",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001734",
  },
  {
    branch_code: "1735",
    branch_name: "REWARI ",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0001735",
  },
  {
    branch_code: "1715",
    branch_name: "MALTHAN ",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001715",
  },
  {
    branch_code: "1754",
    branch_name: "JANJGIR",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001754",
  },
  {
    branch_code: "1743",
    branch_name: "SURYARAOPET VIJAYAWADA",
    category: "METROPOLITAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0001743",
  },
  {
    branch_code: "1764",
    branch_name: "PALANPUR ",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001764",
  },
  {
    branch_code: "1708",
    branch_name: "BHIMAVARAM ",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0001708",
  },
  {
    branch_code: "1721",
    branch_name: "ARRAH",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0001721",
  },
  {
    branch_code: "1744",
    branch_name: "NANGLOI ( DELHI)",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001744",
  },
  {
    branch_code: "1758",
    branch_name: "HOSHANGABAD Road, BHOPAL ",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0001758",
  },
  {
    branch_code: "1705",
    branch_name: "SHIVRAJPUR ",
    category: "SEMI URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001705",
  },
  {
    branch_code: "1722",
    branch_name: "DIMAPUR ",
    category: "URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0001722",
  },
  {
    branch_code: "1740",
    branch_name: "MOHALI - PHASE II",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001740",
  },
  {
    branch_code: "1691",
    branch_name: "GONDA ",
    category: "URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001691",
  },
  {
    branch_code: "1692",
    branch_name: "SAHJANWA",
    category: "SEMI URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0001692",
  },
  {
    branch_code: "1759",
    branch_name: "GUNA ",
    category: "URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0001759",
  },
  {
    branch_code: "1765",
    branch_name: "SOUTH TUKO GANJ-INDORE ",
    category: "METROPOLITAN",
    zone: "INDORE",
    ifsc_code: "MAHB0001765",
  },
  {
    branch_code: "1741",
    branch_name: "KAITHAL ",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0001741",
  },
  {
    branch_code: "1742",
    branch_name: "KARIMNAGAR ",
    category: "URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0001742",
  },
  {
    branch_code: "1755",
    branch_name: "DULEHRA CHAUHAN ",
    category: "RURAL",
    zone: "NOIDA",
    ifsc_code: "MAHB0001755",
  },
  {
    branch_code: "1756",
    branch_name: "MUMBAI-ANDHERI, SEEPZ",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0001756",
  },
  {
    branch_code: "1724",
    branch_name: "DULIAJAN ",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0001724",
  },
  {
    branch_code: "1726",
    branch_name: "BIJNOR ",
    category: "SEMI URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001726",
  },
  {
    branch_code: "1748",
    branch_name: "BUDAUN ",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001748",
  },
  {
    branch_code: "1763",
    branch_name: "RUDAULI ",
    category: "SEMI URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001763",
  },
  {
    branch_code: "1728",
    branch_name: "MAURANIPUR ",
    category: "SEMI URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001728",
  },
  {
    branch_code: "1731",
    branch_name: "JALALPUR",
    category: "SEMI URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0001731",
  },
  {
    branch_code: "1665",
    branch_name: "AMETHI",
    category: "SEMI URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001665",
  },
  {
    branch_code: "1771",
    branch_name: "TANJAVUR ",
    category: "URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0001771",
  },
  {
    branch_code: "1753",
    branch_name: "WADKI ",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001753",
  },
  {
    branch_code: "1704",
    branch_name: "AYODHYA ",
    category: "SEMI URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001704",
  },
  {
    branch_code: "1727",
    branch_name: "TEHRI",
    category: "SEMI URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0001727",
  },
  {
    branch_code: "1729",
    branch_name: "RAIBARELI",
    category: "URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001729",
  },
  {
    branch_code: "1730",
    branch_name: "BULANDSHAHR ",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001730",
  },
  {
    branch_code: "1732",
    branch_name: "ROORKEE",
    category: "URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0001732",
  },
  {
    branch_code: "1751",
    branch_name: "FARRUKHABAD",
    category: "URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001751",
  },
  {
    branch_code: "1761",
    branch_name: "SHAHJAHANPUR",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001761",
  },
  {
    branch_code: "1780",
    branch_name: "ASTAGAON",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001780",
  },
  {
    branch_code: "1791",
    branch_name: "KOLLAM ",
    category: "URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0001791",
  },
  {
    branch_code: "1736",
    branch_name: "BAHRANWADA KALAN",
    category: "RURAL",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001736",
  },
  {
    branch_code: "1769",
    branch_name: "SHREE NAGAR, THANE ",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0001769",
  },
  {
    branch_code: "1773",
    branch_name: "PUNE-WAKAD",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001773",
  },
  {
    branch_code: "1778",
    branch_name: "SHAKTI NAGAR, DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001778",
  },
  {
    branch_code: "1790",
    branch_name: "ASALGAON BAZAR ",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0001790",
  },
  {
    branch_code: "1792",
    branch_name: "MATORI",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0001792",
  },
  {
    branch_code: "1757",
    branch_name: "MUMBAI-KANDIVALI, EAST  ",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0001757",
  },
  {
    branch_code: "1760",
    branch_name: "KAPTANGANJ",
    category: "RURAL",
    zone: "VARANASI",
    ifsc_code: "MAHB0001760",
  },
  {
    branch_code: "1766",
    branch_name: "HATHRAS ",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001766",
  },
  {
    branch_code: "1767",
    branch_name: "MUMBAI-KALINA, ",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0001767",
  },
  {
    branch_code: "1770",
    branch_name: "GARKHEDA",
    category: "METROPOLITAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001770",
  },
  {
    branch_code: "1774",
    branch_name: "TANDA",
    category: "SEMI URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0001774",
  },
  {
    branch_code: "1776",
    branch_name: "MAHARAJGANJ",
    category: "SEMI URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0001776",
  },
  {
    branch_code: "1777",
    branch_name: "RANI BAGH, DELHI ",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001777",
  },
  {
    branch_code: "1781",
    branch_name: "BHIWANI ",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0001781",
  },
  {
    branch_code: "1783",
    branch_name: "AMBALA CITY ",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0001783",
  },
  {
    branch_code: "1786",
    branch_name: "SOUTH DUMDUM ",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001786",
  },
  {
    branch_code: "1788",
    branch_name: "ROHINI SECTOR,15 DELHI ",
    category: "URBAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001788",
  },
  {
    branch_code: "1789",
    branch_name: "KIRTI NAGAR, DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001789",
  },
  {
    branch_code: "1793",
    branch_name: "REWA ",
    category: "URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0001793",
  },
  {
    branch_code: "1794",
    branch_name: "MARWAR JUNCTION ",
    category: "SEMI URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001794",
  },
  {
    branch_code: "1795",
    branch_name: "KAWARDHA",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001795",
  },
  {
    branch_code: "1796",
    branch_name: "MORBI ",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001796",
  },
  {
    branch_code: "1798",
    branch_name: "PUNE-SINCHAN BHAVAN",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0001798",
  },
  {
    branch_code: "1797",
    branch_name: "PEINT(PETH)",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0001797",
  },
  {
    branch_code: "1801",
    branch_name: "KHEDOSHI",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0001801",
  },
  {
    branch_code: "1687",
    branch_name: "MANIKHAPA",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0001687",
  },
  {
    branch_code: "1762",
    branch_name: "SHAHGANJ",
    category: "SEMI URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0001762",
  },
  {
    branch_code: "1779",
    branch_name: "UMARANALA ",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0001779",
  },
  {
    branch_code: "1782",
    branch_name: "MUKERIAN ",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001782",
  },
  {
    branch_code: "1802",
    branch_name: "GANOULI",
    category: "RURAL",
    zone: "NOIDA",
    ifsc_code: "MAHB0001802",
  },
  {
    branch_code: "1803",
    branch_name: "NOORPUR ",
    category: "RURAL",
    zone: "NOIDA",
    ifsc_code: "MAHB0001803",
  },
  {
    branch_code: "1804",
    branch_name: "TILLA SAHBAZPUR ",
    category: "RURAL",
    zone: "NOIDA",
    ifsc_code: "MAHB0001804",
  },
  {
    branch_code: "1805",
    branch_name: "DEOGHAR ",
    category: "URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0001805",
  },
  {
    branch_code: "1806",
    branch_name: "BABHALGAON ",
    category: "RURAL",
    zone: "LATUR",
    ifsc_code: "MAHB0001806",
  },
  {
    branch_code: "1807",
    branch_name: "ROKADIYA NAGAR,SHEGAON",
    category: "RURAL",
    zone: "AKOLA",
    ifsc_code: "MAHB0001807",
  },
  {
    branch_code: "1808",
    branch_name: "YADGIR ",
    category: "SEMI URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0001808",
  },
  {
    branch_code: "1809",
    branch_name: "NAGPURA ",
    category: "RURAL",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001809",
  },
  {
    branch_code: "1810",
    branch_name: "POTIYADIH",
    category: "RURAL",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001810",
  },
  {
    branch_code: "1811",
    branch_name: "KASAL",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0001811",
  },
  {
    branch_code: "1812",
    branch_name: "SAVADA",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0001812",
  },
  {
    branch_code: "1813",
    branch_name: "PAROLA ",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0001813",
  },
  {
    branch_code: "1814",
    branch_name: "ARMORI ",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001814",
  },
  {
    branch_code: "1815",
    branch_name: "LAKHANI",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001815",
  },
  {
    branch_code: "1816",
    branch_name: "PAUNI",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001816",
  },
  {
    branch_code: "1817",
    branch_name: "VILHOLI",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0001817",
  },
  {
    branch_code: "1818",
    branch_name: "SURGANA",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0001818",
  },
  {
    branch_code: "1819",
    branch_name: "GONDE DUMALA ",
    category: "RURAL",
    zone: "NASIK",
    ifsc_code: "MAHB0001819",
  },
  {
    branch_code: "1820",
    branch_name: "YADRAV",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001820",
  },
  {
    branch_code: "1821",
    branch_name: "CHANDUR BAZAR ",
    category: "SEMI URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0001821",
  },
  {
    branch_code: "1822",
    branch_name: "DEOLI",
    category: "SEMI URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0001822",
  },
  {
    branch_code: "1823",
    branch_name: "BRINDAVAN COMPLEX, THANE ",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0001823",
  },
  {
    branch_code: "1825",
    branch_name: "NAIGAON EAST ",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0001825",
  },
  {
    branch_code: "1826",
    branch_name: "NAVGHAR",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001826",
  },
  {
    branch_code: "1827",
    branch_name: "BORANADA",
    category: "RURAL",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001827",
  },
  {
    branch_code: "1828",
    branch_name: "JEJURI ",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001828",
  },
  {
    branch_code: "1830",
    branch_name: "KURKUMBH",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001830",
  },
  {
    branch_code: "1831",
    branch_name: "JAITAPUR",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0001831",
  },
  {
    branch_code: "1832",
    branch_name: "JAWALA ",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001832",
  },
  {
    branch_code: "1833",
    branch_name: "KASHTI",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001833",
  },
  {
    branch_code: "1834",
    branch_name: "PARNER ",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001834",
  },
  {
    branch_code: "1835",
    branch_name: "DAHIWADI",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0001835",
  },
  {
    branch_code: "1836",
    branch_name: "KARANJE( SHAHUPURI SATARA)",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0001836",
  },
  {
    branch_code: "1838",
    branch_name: "MALSHIRAS ",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0001838",
  },
  {
    branch_code: "1839",
    branch_name: "TEMBHURNI",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0001839",
  },
  {
    branch_code: "1840",
    branch_name: "MANKOLI",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0001840",
  },
  {
    branch_code: "1841",
    branch_name: "MARKAL",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001841",
  },
  {
    branch_code: "1842",
    branch_name: "PARGAON TARF ASAWARI BK",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001842",
  },
  {
    branch_code: "1843",
    branch_name: "DEOLA",
    category: "SEMI URBAN",
    zone: "MALEGAON",
    ifsc_code: "MAHB0001843",
  },
  {
    branch_code: "1844",
    branch_name: "VELLORE ",
    category: "URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0001844",
  },
  {
    branch_code: "1845",
    branch_name: "VADUJ",
    category: "SEMI URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0001845",
  },
  {
    branch_code: "1847",
    branch_name: "JHABUA",
    category: "SEMI URBAN",
    zone: "INDORE",
    ifsc_code: "MAHB0001847",
  },
  {
    branch_code: "1848",
    branch_name: "SULTANPUR ",
    category: "URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0001848",
  },
  {
    branch_code: "1787",
    branch_name: "BONGAIGAON",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0001787",
  },
  {
    branch_code: "1853",
    branch_name: "ROSHANPUR(KHURAMPUR)",
    category: "RURAL",
    zone: "NOIDA",
    ifsc_code: "MAHB0001853",
  },
  {
    branch_code: "1800",
    branch_name: "GAYA",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0001800",
  },
  {
    branch_code: "1824",
    branch_name: "SAMBALPUR ",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0001824",
  },
  {
    branch_code: "1799",
    branch_name: "SIWAN ",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0001799",
  },
  {
    branch_code: "1849",
    branch_name: "ASHOKNAGAR ",
    category: "SEMI URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0001849",
  },
  {
    branch_code: "1854",
    branch_name: "GUJARANWALA TWON, DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0001854",
  },
  {
    branch_code: "1855",
    branch_name: "SAKARI ",
    category: "URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001855",
  },
  {
    branch_code: "1856",
    branch_name: "BUDHAGAON ",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001856",
  },
  {
    branch_code: "1857",
    branch_name: "KOPPAL ",
    category: "SEMI URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0001857",
  },
  {
    branch_code: "1858",
    branch_name: "JAMNER ",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0001858",
  },
  {
    branch_code: "1860",
    branch_name: "TALOJE PANCHNAD",
    category: "URBAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001860",
  },
  {
    branch_code: "1861",
    branch_name: "DEORI",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001861",
  },
  {
    branch_code: "1862",
    branch_name: "BARSHI TAKLI",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0001862",
  },
  {
    branch_code: "1864",
    branch_name: "VIRAMGAM",
    category: "SEMI URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001864",
  },
  {
    branch_code: "1865",
    branch_name: "JAMKHED",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001865",
  },
  {
    branch_code: "1866",
    branch_name: "VAMBHORI",
    category: "SEMI URBAN",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001866",
  },
  {
    branch_code: "1867",
    branch_name: "BURHANGAR",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001867",
  },
  {
    branch_code: "1870",
    branch_name: "CHIKHALGAON ",
    category: "RURAL",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001870",
  },
  {
    branch_code: "1871",
    branch_name: "MALLAPURAM",
    category: "URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0001871",
  },
  {
    branch_code: "1876",
    branch_name: "MARUNJE",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001876",
  },
  {
    branch_code: "1877",
    branch_name: "NACHANE",
    category: "SEMI URBAN",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0001877",
  },
  {
    branch_code: "1878",
    branch_name: "MOHAL",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0001878",
  },
  {
    branch_code: "1886",
    branch_name: "CHITRAKUT, JAIPUR",
    category: "METROPOLITAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001886",
  },
  {
    branch_code: "1888",
    branch_name: "SOMATHANE PHATA",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001888",
  },
  {
    branch_code: "1879",
    branch_name: "GALAND",
    category: "RURAL",
    zone: "NOIDA",
    ifsc_code: "MAHB0001879",
  },
  {
    branch_code: "1880",
    branch_name: "NIZAMPUR ",
    category: "RURAL",
    zone: "NOIDA",
    ifsc_code: "MAHB0001880",
  },
  {
    branch_code: "1883",
    branch_name: "NEEL WAL",
    category: "RURAL",
    zone: "DELHI",
    ifsc_code: "MAHB0001883",
  },
  {
    branch_code: "1892",
    branch_name: "MURUD ( LATUR)",
    category: "SEMI URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0001892",
  },
  {
    branch_code: "1772",
    branch_name: "A.KALAPPUR",
    category: "RURAL",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0001772",
  },
  {
    branch_code: "1872",
    branch_name: "NRUSINHAWADI",
    category: "RURAL",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001872",
  },
  {
    branch_code: "1869",
    branch_name: "SOLAN",
    category: "SEMI URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0001869",
  },
  {
    branch_code: "1873",
    branch_name: "HAJIPUR",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0001873",
  },
  {
    branch_code: "1875",
    branch_name: "DEVALALI CAMP",
    category: "SEMI URBAN",
    zone: "NASIK",
    ifsc_code: "MAHB0001875",
  },
  {
    branch_code: "1893",
    branch_name: "GULLU",
    category: "RURAL",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001893",
  },
  {
    branch_code: "1894",
    branch_name: "DETHAN",
    category: "RURAL",
    zone: "SURAT",
    ifsc_code: "MAHB0001894",
  },
  {
    branch_code: "1897",
    branch_name: "KHULTABAD ",
    category: "SEMI URBAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001897",
  },
  {
    branch_code: "1901",
    branch_name: "WASHI (PEN)",
    category: "RURAL",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001901",
  },
  {
    branch_code: "1884",
    branch_name: "BUPANIA",
    category: "RURAL",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0001884",
  },
  {
    branch_code: "1882",
    branch_name: "PANNA",
    category: "SEMI URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0001882",
  },
  {
    branch_code: "1902",
    branch_name: "BHARASWADA",
    category: "RURAL",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0001902",
  },
  {
    branch_code: "1903",
    branch_name: "DHARANGAON",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0001903",
  },
  {
    branch_code: "1905",
    branch_name: "TELHARA ",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0001905",
  },
  {
    branch_code: "1874",
    branch_name: "SHIKRAPUR",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001874",
  },
  {
    branch_code: "1891",
    branch_name: "PARADIP",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0001891",
  },
  {
    branch_code: "1899",
    branch_name: "SILVASSA",
    category: "SEMI URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0001899",
  },
  {
    branch_code: "1868",
    branch_name: "SIRSA",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0001868",
  },
  {
    branch_code: "1898",
    branch_name: "RAJPIPLA",
    category: "SEMI URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0001898",
  },
  {
    branch_code: "1906",
    branch_name: "NER (YAVATMAL)",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0001906",
  },
  {
    branch_code: "1909",
    branch_name: "VANZ",
    category: "RURAL",
    zone: "SURAT",
    ifsc_code: "MAHB0001909",
  },
  {
    branch_code: "1913",
    branch_name: "DHOLKA ",
    category: "SEMI URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001913",
  },
  {
    branch_code: "1881",
    branch_name: "SHAHDOL",
    category: "SEMI URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0001881",
  },
  {
    branch_code: "1904",
    branch_name: "BARMER ",
    category: "SEMI URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001904",
  },
  {
    branch_code: "1910",
    branch_name: "DAMAN",
    category: "SEMI URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0001910",
  },
  {
    branch_code: "1889",
    branch_name: "RAVULAPALEM ",
    category: "SEMI URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0001889",
  },
  {
    branch_code: "1911",
    branch_name: "RAMTEK",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001911",
  },
  {
    branch_code: "1912",
    branch_name: "PIMPARKHED",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001912",
  },
  {
    branch_code: "1914",
    branch_name: "MANGALWEDHA",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0001914",
  },
  {
    branch_code: "1907",
    branch_name: "PURI",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0001907",
  },
  {
    branch_code: "1917",
    branch_name: "MAHUVA",
    category: "SEMI URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001917",
  },
  {
    branch_code: "1746",
    branch_name: "DEORBEEJA",
    category: "RURAL",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001746",
  },
  {
    branch_code: "1916",
    branch_name: "MAHAD",
    category: "SEMI URBAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0001916",
  },
  {
    branch_code: "1852",
    branch_name: "RAISEN",
    category: "SEMI URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0001852",
  },
  {
    branch_code: "1851",
    branch_name: "SHIVPUR",
    category: "RURAL",
    zone: "BHOPAL",
    ifsc_code: "MAHB0001851",
  },
  {
    branch_code: "1921",
    branch_name: "RAJSAMAND ",
    category: "SEMI URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0001921",
  },
  {
    branch_code: "1895",
    branch_name: "FATEHGARH SAHIB ",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001895",
  },
  {
    branch_code: "1850",
    branch_name: "SEMRA ",
    category: "RURAL",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001850",
  },
  {
    branch_code: "1924",
    branch_name: "AHMEDABAD-CHANDKHEDA ",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001924",
  },
  {
    branch_code: "1927",
    branch_name: "JAIL ROAD, NASIK ",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0001927",
  },
  {
    branch_code: "1922",
    branch_name: "THEUR PHATA ",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001922",
  },
  {
    branch_code: "1926",
    branch_name: "WADI",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001926",
  },
  {
    branch_code: "1918",
    branch_name: "PALITANA ",
    category: "SEMI URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001918",
  },
  {
    branch_code: "1919",
    branch_name: "DHORAJI",
    category: "SEMI URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001919",
  },
  {
    branch_code: "1930",
    branch_name: "LOHA MANDI, INDORE ",
    category: "METROPOLITAN",
    zone: "INDORE",
    ifsc_code: "MAHB0001930",
  },
  {
    branch_code: "1829",
    branch_name: "LONIKAND ",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001829",
  },
  {
    branch_code: "1929",
    branch_name: "NAVEGAON ",
    category: "RURAL",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0001929",
  },
  {
    branch_code: "1928",
    branch_name: "DEVENDRA NAGAR, RAIPUR ",
    category: "METROPOLITAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0001928",
  },
  {
    branch_code: "1775",
    branch_name: "JAGDISHPUR",
    category: "RURAL",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001775",
  },
  {
    branch_code: "1863",
    branch_name: "ABOHAR ",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001863",
  },
  {
    branch_code: "1920",
    branch_name: "FARIDKOT ",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0001920",
  },
  {
    branch_code: "1900",
    branch_name: "FATEHABAD ",
    category: "SEMI URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0001900",
  },
  {
    branch_code: "1931",
    branch_name: "KURSI ROAD, LUCKNOW ",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001931",
  },
  {
    branch_code: "1935",
    branch_name: "ITARSI",
    category: "SEMI URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0001935",
  },
  {
    branch_code: "1942",
    branch_name: "KARVE NAKA ",
    category: "RURAL",
    zone: "SATARA",
    ifsc_code: "MAHB0001942",
  },
  {
    branch_code: "1943",
    branch_name: "ROSHAN GATE ",
    category: "METROPOLITAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0001943",
  },
  {
    branch_code: "1944",
    branch_name: "HANGEWADI",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001944",
  },
  {
    branch_code: "1945",
    branch_name: "SUS",
    category: "RURAL",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0001945",
  },
  {
    branch_code: "1946",
    branch_name: "MANJARI",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001946",
  },
  {
    branch_code: "1947",
    branch_name: "GOPALWADI",
    category: "RURAL",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0001947",
  },
  {
    branch_code: "1950",
    branch_name: "LOHONER ",
    category: "RURAL",
    zone: "MALEGAON",
    ifsc_code: "MAHB0001950",
  },
  {
    branch_code: "1937",
    branch_name: "SITAPUR ",
    category: "URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001937",
  },
  {
    branch_code: "1938",
    branch_name: "LUCKNOW- RAJNI KHAND, ",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0001938",
  },
  {
    branch_code: "1951",
    branch_name: "WAGHODE",
    category: "RURAL",
    zone: "JALGAON",
    ifsc_code: "MAHB0001951",
  },
  {
    branch_code: "1952",
    branch_name: "THULLUR",
    category: "RURAL",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0001952",
  },
  {
    branch_code: "1939",
    branch_name: "SHIVPURI ",
    category: "URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0001939",
  },
  {
    branch_code: "1953",
    branch_name: "SHIROLI (PULACHI)",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001953",
  },
  {
    branch_code: "1954",
    branch_name: "KURDUWADI",
    category: "SEMI URBAN",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0001954",
  },
  {
    branch_code: "1955",
    branch_name: "CIVIL HOSPITAL CHOWK, SANGLI ",
    category: "URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001955",
  },
  {
    branch_code: "1956",
    branch_name: "BHAMBORA",
    category: "RURAL",
    zone: "AHILYANAGAR",
    ifsc_code: "MAHB0001956",
  },
  {
    branch_code: "1957",
    branch_name: "AHMC Bangar",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0001957",
  },
  {
    branch_code: "1958",
    branch_name: "LAKHANDUR",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0001958",
  },
  {
    branch_code: "1972",
    branch_name: "GAUR CHOWK GREATER NOIDA",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0001972",
  },
  {
    branch_code: "1961",
    branch_name: "SHIVAMOGGA",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0001961",
  },
  {
    branch_code: "1960",
    branch_name: "KODOLI, PANHALA",
    category: "SEMI URBAN",
    zone: "KOLHAPUR",
    ifsc_code: "MAHB0001960",
  },
  {
    branch_code: "1959",
    branch_name: "GMS ROAD DEHRADUN",
    category: "URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0001959",
  },
  {
    branch_code: "1964",
    branch_name: "DIGHIKALA",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0001964",
  },
  {
    branch_code: "1965",
    branch_name: "BHIKHANPURA",
    category: "RURAL",
    zone: "PATNA",
    ifsc_code: "MAHB0001965",
  },
  {
    branch_code: "1973",
    branch_name: "MALEGAON WASHIM",
    category: "SEMI URBAN",
    zone: "AKOLA",
    ifsc_code: "MAHB0001973",
  },
  {
    branch_code: "1966",
    branch_name: "KODERMA",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0001966",
  },
  {
    branch_code: "1968",
    branch_name: "CHHATAR MANDU",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0001968",
  },
  {
    branch_code: "1967",
    branch_name: "SITAMARHI",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0001967",
  },
  {
    branch_code: "1962",
    branch_name: "KADAVANTHARA",
    category: "URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0001962",
  },
  {
    branch_code: "1974",
    branch_name: "ALAPPUZHA",
    category: "URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0001974",
  },
  {
    branch_code: "1970",
    branch_name: "JAGATSINGHPUR",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0001970",
  },
  {
    branch_code: "1963",
    branch_name: "BAIRAGARH",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0001963",
  },
  {
    branch_code: "1975",
    branch_name: "CUDDALORE",
    category: "URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0001975",
  },
  {
    branch_code: "1976",
    branch_name: "ETCHERLA",
    category: "RURAL",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0001976",
  },
  {
    branch_code: "1979",
    branch_name: "KOLAR",
    category: "URBAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0001979",
  },
  {
    branch_code: "1971",
    branch_name: "KOHIMA",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0001971",
  },
  {
    branch_code: "1978",
    branch_name: "CALANGUTE",
    category: "SEMI URBAN",
    zone: "GOA",
    ifsc_code: "MAHB0001978",
  },
  {
    branch_code: "1985",
    branch_name: "CHITTOOR",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0001985",
  },
  {
    branch_code: "1986",
    branch_name: "NARODA",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001986",
  },
  {
    branch_code: "1980",
    branch_name: "GURUVAYOOR",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0001980",
  },
  {
    branch_code: "1982",
    branch_name: "THODUPUZHA",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0001982",
  },
  {
    branch_code: "1981",
    branch_name: "KAZHAKOOTTAM",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0001981",
  },
  {
    branch_code: "1989",
    branch_name: "PATIA BHUBNESHWAR",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0001989",
  },
  {
    branch_code: "1969",
    branch_name: "CHARHI",
    category: "RURAL",
    zone: "RANCHI",
    ifsc_code: "MAHB0001969",
  },
  {
    branch_code: "1988",
    branch_name: "GOVINDPURA",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0001988",
  },
  {
    branch_code: "1990",
    branch_name: "VERAVAL",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0001990",
  },
  {
    branch_code: "1987",
    branch_name: "CHENGALPATTU",
    category: "SEMI URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0001987",
  },
  {
    branch_code: "1983",
    branch_name: "THENI",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0001983",
  },
  {
    branch_code: "1984",
    branch_name: "DINDIGUL",
    category: "URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0001984",
  },
  {
    branch_code: "2002",
    branch_name: "MIYAPUR",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002002",
  },
  {
    branch_code: "1991",
    branch_name: "BALESHWAR",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0001991",
  },
  {
    branch_code: "2007",
    branch_name: "ANANTAPUR",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002007",
  },
  {
    branch_code: "2010",
    branch_name: "NARSINGI",
    category: "RURAL",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002010",
  },
  {
    branch_code: "2012",
    branch_name: "KOTHAVALASA",
    category: "SEMI URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002012",
  },
  {
    branch_code: "1995",
    branch_name: "BALURGHAT",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001995",
  },
  {
    branch_code: "1996",
    branch_name: "BANKURA",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001996",
  },
  {
    branch_code: "1997",
    branch_name: "CHINSURAH",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001997",
  },
  {
    branch_code: "2000",
    branch_name: "PURULIYA",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002000",
  },
  {
    branch_code: "2011",
    branch_name: "KANNUR",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002011",
  },
  {
    branch_code: "2018",
    branch_name: "MANJALPUR",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0002018",
  },
  {
    branch_code: "2013",
    branch_name: "MANDSAUR",
    category: "URBAN",
    zone: "INDORE",
    ifsc_code: "MAHB0002013",
  },
  {
    branch_code: "2020",
    branch_name: "JAGITIAL",
    category: "URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002020",
  },
  {
    branch_code: "2021",
    branch_name: "KURNOOL",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002021",
  },
  {
    branch_code: "2022",
    branch_name: "SRIKAKULAM",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002022",
  },
  {
    branch_code: "2004",
    branch_name: "KHALILABAD",
    category: "SEMI URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002004",
  },
  {
    branch_code: "2005",
    branch_name: "LAKHIMPUR",
    category: "URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002005",
  },
  {
    branch_code: "2003",
    branch_name: "BHADOHI",
    category: "SEMI URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002003",
  },
  {
    branch_code: "2055",
    branch_name: "CHIKKAMAGALURU",
    category: "URBAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002055",
  },
  {
    branch_code: "2016",
    branch_name: "GORAKHPUR JABALPUR",
    category: "METROPOLITAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002016",
  },
  {
    branch_code: "2008",
    branch_name: "BERHAMPORE",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002008",
  },
  {
    branch_code: "2009",
    branch_name: "SURI",
    category: "SEMI URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002009",
  },
  {
    branch_code: "2028",
    branch_name: "BETTIAH",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002028",
  },
  {
    branch_code: "2031",
    branch_name: "SASARAM",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002031",
  },
  {
    branch_code: "2036",
    branch_name: "KENDRAPARA",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002036",
  },
  {
    branch_code: "2025",
    branch_name: "CHERLAPALLY",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002025",
  },
  {
    branch_code: "2056",
    branch_name: "VIZIANAGARAM",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002056",
  },
  {
    branch_code: "2014",
    branch_name: "HAVERI",
    category: "SEMI URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0002014",
  },
  {
    branch_code: "2015",
    branch_name: "AERO CITY MOHALI",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002015",
  },
  {
    branch_code: "2006",
    branch_name: "MIRZAPUR",
    category: "URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002006",
  },
  {
    branch_code: "2039",
    branch_name: "PUDUKKOTTAI",
    category: "URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002039",
  },
  {
    branch_code: "2040",
    branch_name: "PERAMBALUR",
    category: "SEMI URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002040",
  },
  {
    branch_code: "2062",
    branch_name: "CHITRADURGA",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0002062",
  },
  {
    branch_code: "2024",
    branch_name: "UNNAO",
    category: "URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002024",
  },
  {
    branch_code: "1994",
    branch_name: "SRI VIJAYA PURAM",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001994",
  },
  {
    branch_code: "1998",
    branch_name: "JALPAIGURI",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001998",
  },
  {
    branch_code: "1999",
    branch_name: "COOCH BEHAR",
    category: "SEMI URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0001999",
  },
  {
    branch_code: "2001",
    branch_name: "RAIGANJ",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002001",
  },
  {
    branch_code: "2067",
    branch_name: "JHARGRAM",
    category: "SEMI URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002067",
  },
  {
    branch_code: "2068",
    branch_name: "KRISHNANAGAR",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002068",
  },
  {
    branch_code: "2017",
    branch_name: "TONK",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002017",
  },
  {
    branch_code: "2027",
    branch_name: "KANKARBAGH PATNA",
    category: "METROPOLITAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002027",
  },
  {
    branch_code: "2075",
    branch_name: "MALEGAON CAMP",
    category: "URBAN",
    zone: "MALEGAON",
    ifsc_code: "MAHB0002075",
  },
  {
    branch_code: "2038",
    branch_name: "KELAMBAKKAM",
    category: "SEMI URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002038",
  },
  {
    branch_code: "2063",
    branch_name: "KANAKAPURA ROAD",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002063",
  },
  {
    branch_code: "2069",
    branch_name: "NIRMAL TS",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002069",
  },
  {
    branch_code: "2070",
    branch_name: "JANGAON",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002070",
  },
  {
    branch_code: "2082",
    branch_name: "AMBEJOGAI ROAD LATUR",
    category: "URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0002082",
  },
  {
    branch_code: "2029",
    branch_name: "BEGUSARAI",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002029",
  },
  {
    branch_code: "2032",
    branch_name: "CHATRA",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002032",
  },
  {
    branch_code: "2052",
    branch_name: "SAMASTIPUR",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002052",
  },
  {
    branch_code: "2057",
    branch_name: "SANGAREDDY",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002057",
  },
  {
    branch_code: "2066",
    branch_name: "CHARKHI DADRI",
    category: "SEMI URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0002066",
  },
  {
    branch_code: "2071",
    branch_name: "PEDDAPALLI",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002071",
  },
  {
    branch_code: "2081",
    branch_name: "KADAPA",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002081",
  },
  {
    branch_code: "2026",
    branch_name: "NEEMUCH",
    category: "URBAN",
    zone: "INDORE",
    ifsc_code: "MAHB0002026",
  },
  {
    branch_code: "2059",
    branch_name: "MARTHANDAM",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002059",
  },
  {
    branch_code: "2019",
    branch_name: "SINGRAULI",
    category: "URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002019",
  },
  {
    branch_code: "2080",
    branch_name: "SHAJAPUR",
    category: "SEMI URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002080",
  },
  {
    branch_code: "2092",
    branch_name: "MIRYALAGUDA",
    category: "URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002092",
  },
  {
    branch_code: "2037",
    branch_name: "FATEHPUR",
    category: "URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002037",
  },
  {
    branch_code: "2058",
    branch_name: "TIRUVANNAMALAI",
    category: "URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002058",
  },
  {
    branch_code: "2077",
    branch_name: "GOPALGANJ",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002077",
  },
  {
    branch_code: "2023",
    branch_name: "HARDOI",
    category: "URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002023",
  },
  {
    branch_code: "2033",
    branch_name: "DUMKA",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002033",
  },
  {
    branch_code: "2035",
    branch_name: "BYASANAGAR",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002035",
  },
  {
    branch_code: "2046",
    branch_name: "KALINGA NAGAR BHUBANESWAR",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002046",
  },
  {
    branch_code: "2050",
    branch_name: "NAWADA",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002050",
  },
  {
    branch_code: "2090",
    branch_name: "KAKKANAD",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002090",
  },
  {
    branch_code: "2091",
    branch_name: "PALAKKAD",
    category: "URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002091",
  },
  {
    branch_code: "2095",
    branch_name: "CHHATARPUR",
    category: "URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002095",
  },
  {
    branch_code: "2096",
    branch_name: "DAMOH",
    category: "URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002096",
  },
  {
    branch_code: "2034",
    branch_name: "BHADRAK",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002034",
  },
  {
    branch_code: "2098",
    branch_name: "LUNAWADA",
    category: "SEMI URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002098",
  },
  {
    branch_code: "2079",
    branch_name: "JAGDALPUR",
    category: "URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002079",
  },
  {
    branch_code: "2054",
    branch_name: "GUMLA",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002054",
  },
  {
    branch_code: "2101",
    branch_name: "BARNALA",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002101",
  },
  {
    branch_code: "2100",
    branch_name: "TARN TARAN",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002100",
  },
  {
    branch_code: "2049",
    branch_name: "RAYAGADA",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002049",
  },
  {
    branch_code: "2093",
    branch_name: "HALDWANI",
    category: "URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002093",
  },
  {
    branch_code: "2119",
    branch_name: "CORPORATE FINANCE BRANCH KOLKATA",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002119",
  },
  {
    branch_code: "2122",
    branch_name: "CORPORATE FINANCE BRANCH SOUTH EXTN DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0002122",
  },
  {
    branch_code: "2123",
    branch_name: "CORPORATE FINANCE BRANCH CONNAUGHT PLACE DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0002123",
  },
  {
    branch_code: "2083",
    branch_name: "CORPORATE FINANCE BRANCH MUMBAI NORTH",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0002083",
  },
  {
    branch_code: "2094",
    branch_name: "BARIPADA",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002094",
  },
  {
    branch_code: "2097",
    branch_name: "TIKAMGARH",
    category: "SEMI URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002097",
  },
  {
    branch_code: "2103",
    branch_name: "MODASA",
    category: "SEMI URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002103",
  },
  {
    branch_code: "2089",
    branch_name: "ANGAMALY",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002089",
  },
  {
    branch_code: "2102",
    branch_name: "SIDDIPET",
    category: "URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002102",
  },
  {
    branch_code: "2109",
    branch_name: "THIRUVARUR",
    category: "SEMI URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002109",
  },
  {
    branch_code: "2088",
    branch_name: "NARNAUL",
    category: "SEMI URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0002088",
  },
  {
    branch_code: "2124",
    branch_name: "CORPORATE FINANCE BRANCH HYDERABAD",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002124",
  },
  {
    branch_code: "2078",
    branch_name: "JAGATPUR ",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002078",
  },
  {
    branch_code: "2116",
    branch_name: "NAGAUR",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002116",
  },
  {
    branch_code: "2061",
    branch_name: "GODDA",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002061",
  },
  {
    branch_code: "2105",
    branch_name: "BHIND",
    category: "URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002105",
  },
  {
    branch_code: "2107",
    branch_name: "MORENA",
    category: "URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002107",
  },
  {
    branch_code: "2115",
    branch_name: "DHOLPUR",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002115",
  },
  {
    branch_code: "2126",
    branch_name: "JAMUI",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002126",
  },
  {
    branch_code: "2132",
    branch_name: "SIDHI",
    category: "SEMI URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002132",
  },
  {
    branch_code: "2041",
    branch_name: "BUXAR",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002041",
  },
  {
    branch_code: "2043",
    branch_name: "MADHEPURA",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002043",
  },
  {
    branch_code: "2047",
    branch_name: "KALPANA SQUARE",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002047",
  },
  {
    branch_code: "2064",
    branch_name: "MAUNATH BHANJAN",
    category: "URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002064",
  },
  {
    branch_code: "2065",
    branch_name: "BALLIA",
    category: "URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002065",
  },
  {
    branch_code: "2072",
    branch_name: "LALITPUR",
    category: "URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002072",
  },
  {
    branch_code: "2073",
    branch_name: "ROBERTSGANJ",
    category: "SEMI URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002073",
  },
  {
    branch_code: "2074",
    branch_name: "HAMIRPUR",
    category: "SEMI URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002074",
  },
  {
    branch_code: "2099",
    branch_name: "MAHOBA",
    category: "SEMI URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002099",
  },
  {
    branch_code: "2104",
    branch_name: "BOTAD",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002104",
  },
  {
    branch_code: "2106",
    branch_name: "JAISALMER",
    category: "SEMI URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002106",
  },
  {
    branch_code: "2108",
    branch_name: "DHARMAPURI",
    category: "SEMI URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002108",
  },
  {
    branch_code: "2110",
    branch_name: "PATHANAMTHITTA",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002110",
  },
  {
    branch_code: "2112",
    branch_name: "NEYATTINKARA",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002112",
  },
  {
    branch_code: "2113",
    branch_name: "SULTAN BATHERY",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002113",
  },
  {
    branch_code: "2114",
    branch_name: "KOTTARAKKARA",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002114",
  },
  {
    branch_code: "2117",
    branch_name: "CORPORATE FINANCE BRANCH BENGALURU",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002117",
  },
  {
    branch_code: "2118",
    branch_name: "MADHAVARAM",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002118",
  },
  {
    branch_code: "2120",
    branch_name: "CORPORATE FINANCE BRANCH CHENNAI",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002120",
  },
  {
    branch_code: "2121",
    branch_name: "BANDA, U.P",
    category: "URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002121",
  },
  {
    branch_code: "2125",
    branch_name: "DIGHA PATNA",
    category: "METROPOLITAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002125",
  },
  {
    branch_code: "2130",
    branch_name: "KOTDWARA",
    category: "SEMI URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002130",
  },
  {
    branch_code: "2133",
    branch_name: "MSME SATARA",
    category: "URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0002133",
  },
  {
    branch_code: "2136",
    branch_name: "RATU ROAD, RANCHI",
    category: "METROPOLITAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002136",
  },
  {
    branch_code: "2137",
    branch_name: "MEDININAGAR",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002137",
  },
  {
    branch_code: "2128",
    branch_name: "PILIBHIT",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002128",
  },
  {
    branch_code: "2048",
    branch_name: "KORAPUT",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002048",
  },
  {
    branch_code: "2129",
    branch_name: "KASGANJ",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002129",
  },
  {
    branch_code: "2131",
    branch_name: "HAMIRPUR HP",
    category: "SEMI URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002131",
  },
  {
    branch_code: "2134",
    branch_name: "RAMANATHANPURAM",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002134",
  },
  {
    branch_code: "2138",
    branch_name: "TITLAGARH",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002138",
  },
  {
    branch_code: "2139",
    branch_name: "KEONJHAR",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002139",
  },
  {
    branch_code: "2140",
    branch_name: "BALANGIR",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002140",
  },
  {
    branch_code: "2142",
    branch_name: "VILLUPURAM",
    category: "SEMI URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002142",
  },
  {
    branch_code: "2143",
    branch_name: "KISHANGANJ",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002143",
  },
  {
    branch_code: "2144",
    branch_name: "ETAH",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002144",
  },
  {
    branch_code: "2145",
    branch_name: "BHAWANIPURAM VIJAYWADA",
    category: "METROPOLITAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002145",
  },
  {
    branch_code: "2146",
    branch_name: "CHIKKABALLAPURA",
    category: "SEMI URBAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002146",
  },
  {
    branch_code: "2147",
    branch_name: "PORUR",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002147",
  },
  {
    branch_code: "2111",
    branch_name: "TIRUMALA",
    category: "RURAL",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002111",
  },
  {
    branch_code: "2148",
    branch_name: "NAHAN",
    category: "SEMI URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002148",
  },
  {
    branch_code: "2153",
    branch_name: "HOUSING FINANCE BRANCH MUMBAI",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0002153",
  },
  {
    branch_code: "1992",
    branch_name: "DHENKANAL",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0001992",
  },
  {
    branch_code: "2154",
    branch_name: "HOUSING FINANCE BRANCH DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0002154",
  },
  {
    branch_code: "2183",
    branch_name: "HOUSING FINANCE BRANCH HYDERABAD",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002183",
  },
  {
    branch_code: "2149",
    branch_name: "DATIA",
    category: "URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002149",
  },
  {
    branch_code: "1993",
    branch_name: "ANGUL",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0001993",
  },
  {
    branch_code: "2155",
    branch_name: "HOUSING FINANCE BRANCH NOIDA",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002155",
  },
  {
    branch_code: "2151",
    branch_name: "BODWAD",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0002151",
  },
  {
    branch_code: "2158",
    branch_name: "SOUTH BOPAL",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002158",
  },
  {
    branch_code: "2159",
    branch_name: "BHATAPARA",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002159",
  },
  {
    branch_code: "2045",
    branch_name: "PURNIA",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002045",
  },
  {
    branch_code: "2141",
    branch_name: "SAHIDNAGAR",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002141",
  },
  {
    branch_code: "2160",
    branch_name: "SAHARSA",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002160",
  },
  {
    branch_code: "2044",
    branch_name: "MOTIHARI",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002044",
  },
  {
    branch_code: "2150",
    branch_name: "GADWAL",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002150",
  },
  {
    branch_code: "2152",
    branch_name: "CHITTAURGARH",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002152",
  },
  {
    branch_code: "2161",
    branch_name: "ANUPPUR",
    category: "SEMI URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002161",
  },
  {
    branch_code: "2162",
    branch_name: "UMARIA",
    category: "SEMI URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002162",
  },
  {
    branch_code: "2168",
    branch_name: "HARDA",
    category: "SEMI URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002168",
  },
  {
    branch_code: "2157",
    branch_name: "KULLU",
    category: "SEMI URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002157",
  },
  {
    branch_code: "2167",
    branch_name: "MANCHERIAL",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002167",
  },
  {
    branch_code: "2178",
    branch_name: "DHARAMSHALA",
    category: "SEMI URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002178",
  },
  {
    branch_code: "2169",
    branch_name: "SHEOPUR",
    category: "SEMI URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002169",
  },
  {
    branch_code: "2165",
    branch_name: "NAYAGARH",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002165",
  },
  {
    branch_code: "2182",
    branch_name: "PALLADAM",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002182",
  },
  {
    branch_code: "2175",
    branch_name: "MAINPURI",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002175",
  },
  {
    branch_code: "2163",
    branch_name: "KHORDHA",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002163",
  },
  {
    branch_code: "2187",
    branch_name: "NELLITHOPPU,PONDICHERRY",
    category: "URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002187",
  },
  {
    branch_code: "2177",
    branch_name: "SHAMLI",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002177",
  },
  {
    branch_code: "2174",
    branch_name: "ORAI",
    category: "URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002174",
  },
  {
    branch_code: "2164",
    branch_name: "CDA CUTTACK",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002164",
  },
  {
    branch_code: "2051",
    branch_name: "BIHARSHARIF",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002051",
  },
  {
    branch_code: "2172",
    branch_name: "WANAPARTHY",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002172",
  },
  {
    branch_code: "2170",
    branch_name: "KANAUDI",
    category: "RURAL",
    zone: "PATNA",
    ifsc_code: "MAHB0002170",
  },
  {
    branch_code: "2190",
    branch_name: "JAM KHAMBHALIA",
    category: "SEMI URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002190",
  },
  {
    branch_code: "2076",
    branch_name: "BHAWANIPATNA",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002076",
  },
  {
    branch_code: "2184",
    branch_name: "VALLABH VIDYANAGAR",
    category: "SEMI URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0002184",
  },
  {
    branch_code: "2060",
    branch_name: "BARGARH",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002060",
  },
  {
    branch_code: "2181",
    branch_name: "SONEPUR",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002181",
  },
  {
    branch_code: "2042",
    branch_name: "KATIHAR",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002042",
  },
  {
    branch_code: "2192",
    branch_name: "KARAIKAL",
    category: "SEMI URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002192",
  },
  {
    branch_code: "2198",
    branch_name: "CHANGANASSERY",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002198",
  },
  {
    branch_code: "2199",
    branch_name: "CHENGANNUR",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002199",
  },
  {
    branch_code: "2200",
    branch_name: "KOLENCHERY",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002200",
  },
  {
    branch_code: "2193",
    branch_name: "KANCHEEPURAM",
    category: "URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002193",
  },
  {
    branch_code: "2191",
    branch_name: "KUMBAKONAM",
    category: "URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002191",
  },
  {
    branch_code: "2189",
    branch_name: "MEDAK",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002189",
  },
  {
    branch_code: "2173",
    branch_name: "CHITRAKOOT DHAM",
    category: "SEMI URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002173",
  },
  {
    branch_code: "2205",
    branch_name: "KURUKSHETRA",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002205",
  },
  {
    branch_code: "2207",
    branch_name: "AMRELI",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002207",
  },
  {
    branch_code: "2213",
    branch_name: "SHIVPUR VARANASI",
    category: "METROPOLITAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002213",
  },
  {
    branch_code: "2176",
    branch_name: "NOIDA SECTOR 75",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002176",
  },
  {
    branch_code: "2206",
    branch_name: "KAMAREDDY",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002206",
  },
  {
    branch_code: "2216",
    branch_name: "MEDAVAKKAM",
    category: "SEMI URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002216",
  },
  {
    branch_code: "2209",
    branch_name: "PRAGATI NAGAR",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002209",
  },
  {
    branch_code: "2208",
    branch_name: "GOVT. BUSINESS BRANCH DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0002208",
  },
  {
    branch_code: "2212",
    branch_name: "JAUNPUR",
    category: "URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002212",
  },
  {
    branch_code: "2201",
    branch_name: "MUVATTUPPUZHA",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002201",
  },
  {
    branch_code: "2202",
    branch_name: "PALA",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002202",
  },
  {
    branch_code: "2203",
    branch_name: "PAYYANNUR",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002203",
  },
  {
    branch_code: "2204",
    branch_name: "VADAKARA",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002204",
  },
  {
    branch_code: "2179",
    branch_name: "KHODASINGI",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002179",
  },
  {
    branch_code: "2188",
    branch_name: "MALKANGIRI",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002188",
  },
  {
    branch_code: "2215",
    branch_name: "CHOUBEY COLONY RAIPUR",
    category: "METROPOLITAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002215",
  },
  {
    branch_code: "2219",
    branch_name: "GONDAL",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002219",
  },
  {
    branch_code: "2233",
    branch_name: "ORAS",
    category: "RURAL",
    zone: "RATNAGIRI",
    ifsc_code: "MAHB0002233",
  },
  {
    branch_code: "2223",
    branch_name: "DAUSA",
    category: "SEMI URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002223",
  },
  {
    branch_code: "2194",
    branch_name: "PERUNDURAI",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002194",
  },
  {
    branch_code: "2195",
    branch_name: "POLLACHI",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002195",
  },
  {
    branch_code: "2222",
    branch_name: "MANSA",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002222",
  },
  {
    branch_code: "2185",
    branch_name: "PARALAKHEMUNDI",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002185",
  },
  {
    branch_code: "2224",
    branch_name: "PATNA SAHIB",
    category: "METROPOLITAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002224",
  },
  {
    branch_code: "2228",
    branch_name: "PRODATTUR",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002228",
  },
  {
    branch_code: "2225",
    branch_name: "AMALAPURAM",
    category: "SEMI URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002225",
  },
  {
    branch_code: "2221",
    branch_name: "FAZILKA",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002221",
  },
  {
    branch_code: "2237",
    branch_name: "NALBARI",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002237",
  },
  {
    branch_code: "2166",
    branch_name: "LAXMI SAGAR BHUBANESWAR",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002166",
  },
  {
    branch_code: "2236",
    branch_name: "UNJHA",
    category: "SEMI URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002236",
  },
  {
    branch_code: "2227",
    branch_name: "MACHILIPATNAM",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002227",
  },
  {
    branch_code: "2229",
    branch_name: "SAGUNA MORE",
    category: "METROPOLITAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002229",
  },
  {
    branch_code: "2238",
    branch_name: "SILCHAR",
    category: "URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002238",
  },
  {
    branch_code: "2197",
    branch_name: "ATTINGAL",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002197",
  },
  {
    branch_code: "2180",
    branch_name: "NABARANGAPUR",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002180",
  },
  {
    branch_code: "2210",
    branch_name: "DIGITAL BANKING UNIT CHHATRAPATI SAMBHAJINAGAR",
    category: "METROPOLITAN",
    zone: "CHHATRAPATI SAMBHAJINAGAR",
    ifsc_code: "MAHB0002210",
  },
  {
    branch_code: "2211",
    branch_name: "DIGITAL BANKING UNIT SATARA",
    category: "URBAN",
    zone: "SATARA",
    ifsc_code: "MAHB0002211",
  },
  {
    branch_code: "2239",
    branch_name: "VYAPAR VIHAR BILASPUR",
    category: "URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002239",
  },
  {
    branch_code: "2226",
    branch_name: "AUTONAGAR",
    category: "METROPOLITAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002226",
  },
  {
    branch_code: "2243",
    branch_name: "INDUSTRIAL AREA PHASE-I",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002243",
  },
  {
    branch_code: "2156",
    branch_name: "BHARATPUR",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002156",
  },
  {
    branch_code: "2196",
    branch_name: "TIRUCHENGODE",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002196",
  },
  {
    branch_code: "2220",
    branch_name: "HARIDWAR ROAD DEHRADUN",
    category: "URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002220",
  },
  {
    branch_code: "2242",
    branch_name: "THIRUVALLUR",
    category: "SEMI URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002242",
  },
  {
    branch_code: "2217",
    branch_name: "MAHBUBABAD",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002217",
  },
  {
    branch_code: "2244",
    branch_name: "BADDI",
    category: "SEMI URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002244",
  },
  {
    branch_code: "2231",
    branch_name: "LAKHISARAI",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002231",
  },
  {
    branch_code: "2246",
    branch_name: "RAMANAGARA",
    category: "SEMI URBAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002246",
  },
  {
    branch_code: "2258",
    branch_name: "TILKAMANJHI BHAGALPUR",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002258",
  },
  {
    branch_code: "2230",
    branch_name: "KHAGARIA",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002230",
  },
  {
    branch_code: "2186",
    branch_name: "SUNDARGARH",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002186",
  },
  {
    branch_code: "2254",
    branch_name: "JUBILEE HILLS",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002254",
  },
  {
    branch_code: "2245",
    branch_name: "JAGADHRI",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002245",
  },
  {
    branch_code: "2256",
    branch_name: "RAMGARH",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002256",
  },
  {
    branch_code: "2252",
    branch_name: "DINDOLI",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0002252",
  },
  {
    branch_code: "2218",
    branch_name: "PHULABANI",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002218",
  },
  {
    branch_code: "2253",
    branch_name: "VARACHHA SURAT",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0002253",
  },
  {
    branch_code: "2260",
    branch_name: "CHOUTUPPAL",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002260",
  },
  {
    branch_code: "2262",
    branch_name: "JHALAWAR",
    category: "SEMI URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002262",
  },
  {
    branch_code: "2255",
    branch_name: "KONDAGAON",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002255",
  },
  {
    branch_code: "2030",
    branch_name: "MUNGER",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002030",
  },
  {
    branch_code: "2257",
    branch_name: "ADITYAPUR",
    category: "URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002257",
  },
  {
    branch_code: "2279",
    branch_name: "LOHARDAGA",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002279",
  },
  {
    branch_code: "2247",
    branch_name: "JASHPUR NAGAR",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002247",
  },
  {
    branch_code: "2261",
    branch_name: "JHAJJAR",
    category: "SEMI URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0002261",
  },
  {
    branch_code: "2277",
    branch_name: "MADIKERI",
    category: "SEMI URBAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002277",
  },
  {
    branch_code: "2288",
    branch_name: "CHAMARAJANAGAR",
    category: "SEMI URBAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002288",
  },
  {
    branch_code: "2291",
    branch_name: "HOUSING FINANCE BRANCH BENGALURU",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002291",
  },
  {
    branch_code: "2235",
    branch_name: "BARWANI",
    category: "SEMI URBAN",
    zone: "INDORE",
    ifsc_code: "MAHB0002235",
  },
  {
    branch_code: "2270",
    branch_name: "RAYACHOTI",
    category: "SEMI URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002270",
  },
  {
    branch_code: "2276",
    branch_name: "RAJOURI",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002276",
  },
  {
    branch_code: "2265",
    branch_name: "JHUNSI",
    category: "METROPOLITAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002265",
  },
  {
    branch_code: "2266",
    branch_name: "KANNAUJ",
    category: "SEMI URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002266",
  },
  {
    branch_code: "2267",
    branch_name: "COLLEGE ROAD NADIAD",
    category: "URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0002267",
  },
  {
    branch_code: "2268",
    branch_name: "VYARA",
    category: "SEMI URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0002268",
  },
  {
    branch_code: "2281",
    branch_name: "ANNA NAGAR MADURAI",
    category: "METROPOLITAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002281",
  },
  {
    branch_code: "2282",
    branch_name: "ARIYALUR",
    category: "SEMI URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002282",
  },
  {
    branch_code: "2283",
    branch_name: "HOUSING FINANCE BRANCH CHENNAI",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002283",
  },
  {
    branch_code: "2284",
    branch_name: "NAGAPATTINAM",
    category: "URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002284",
  },
  {
    branch_code: "2287",
    branch_name: "VELACHERY",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002287",
  },
  {
    branch_code: "2289",
    branch_name: "KATHUA",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002289",
  },
  {
    branch_code: "2290",
    branch_name: "MOKHADA",
    category: "RURAL",
    zone: "THANE",
    ifsc_code: "MAHB0002290",
  },
  {
    branch_code: "2127",
    branch_name: "ARARIA",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002127",
  },
  {
    branch_code: "2171",
    branch_name: "HARMU ROAD",
    category: "METROPOLITAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002171",
  },
  {
    branch_code: "2240",
    branch_name: "ADARSH NAGAR DURG",
    category: "URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002240",
  },
  {
    branch_code: "2248",
    branch_name: "RISHIKESH",
    category: "SEMI URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002248",
  },
  {
    branch_code: "2249",
    branch_name: "KASHIPUR",
    category: "URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002249",
  },
  {
    branch_code: "2251",
    branch_name: "SASNI GATE ALIGARH",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002251",
  },
  {
    branch_code: "2264",
    branch_name: "BIAORA",
    category: "SEMI URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002264",
  },
  {
    branch_code: "2269",
    branch_name: "VESU SURAT",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0002269",
  },
  {
    branch_code: "2273",
    branch_name: "ALIRAJPUR",
    category: "SEMI URBAN",
    zone: "INDORE",
    ifsc_code: "MAHB0002273",
  },
  {
    branch_code: "2274",
    branch_name: "GAWADI",
    category: "RURAL",
    zone: "INDORE",
    ifsc_code: "MAHB0002274",
  },
  {
    branch_code: "2275",
    branch_name: "RANJIT AVENUE AMRITSAR",
    category: "METROPOLITAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002275",
  },
  {
    branch_code: "2278",
    branch_name: "BHABHUA",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002278",
  },
  {
    branch_code: "2280",
    branch_name: "SUPAUL",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002280",
  },
  {
    branch_code: "2292",
    branch_name: "GOLAGHAT",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002292",
  },
  {
    branch_code: "2295",
    branch_name: "NORTH LAKHIMPUR",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002295",
  },
  {
    branch_code: "2272",
    branch_name: "AGAR MALWA",
    category: "SEMI URBAN",
    zone: "INDORE",
    ifsc_code: "MAHB0002272",
  },
  {
    branch_code: "2294",
    branch_name: "DIGITAL BANKING UNIT LOKMANGAL PUNE",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0002294",
  },
  {
    branch_code: "2298",
    branch_name: "J P NAGAR, MYSURU",
    category: "URBAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002298",
  },
  {
    branch_code: "2299",
    branch_name: "MANDYA",
    category: "URBAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002299",
  },
  {
    branch_code: "2301",
    branch_name: "HOUSING FINANCE BRANCH CHANDIGARH",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002301",
  },
  {
    branch_code: "2308",
    branch_name: "HOUSING FINANCE BRANCH GURUGRAM",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0002308",
  },
  {
    branch_code: "2300",
    branch_name: "HOUSING FINANCE BRANCH NAVI MUMBAI",
    category: "METROPOLITAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0002300",
  },
  {
    branch_code: "2296",
    branch_name: "NAMASTE CHOWK KARNAL",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002296",
  },
  {
    branch_code: "2297",
    branch_name: "NARWANA",
    category: "SEMI URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002297",
  },
  {
    branch_code: "2271",
    branch_name: "BAPATLA",
    category: "SEMI URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002271",
  },
  {
    branch_code: "2286",
    branch_name: "SIVGANGA",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002286",
  },
  {
    branch_code: "2324",
    branch_name: "UDHAMPUR",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002324",
  },
  {
    branch_code: "2305",
    branch_name: "DEBAGARH",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002305",
  },
  {
    branch_code: "2307",
    branch_name: "PUTTAPARTHI",
    category: "SEMI URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002307",
  },
  {
    branch_code: "2310",
    branch_name: "KAMLA NAGAR",
    category: "METROPOLITAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002310",
  },
  {
    branch_code: "2322",
    branch_name: "BARAN",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002322",
  },
  {
    branch_code: "2323",
    branch_name: "KATRA",
    category: "RURAL",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002323",
  },
  {
    branch_code: "2340",
    branch_name: "HINDAUN",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002340",
  },
  {
    branch_code: "2346",
    branch_name: "NANDYAL",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002346",
  },
  {
    branch_code: "2214",
    branch_name: "DEORIA",
    category: "URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002214",
  },
  {
    branch_code: "2285",
    branch_name: "NEYVELI",
    category: "URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002285",
  },
  {
    branch_code: "2319",
    branch_name: "BUNDI",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002319",
  },
  {
    branch_code: "2321",
    branch_name: "GORAKHNATH GORAKHPUR",
    category: "URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002321",
  },
  {
    branch_code: "2327",
    branch_name: "LALPUR RANCHI",
    category: "METROPOLITAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002327",
  },
  {
    branch_code: "2328",
    branch_name: "MORABADI",
    category: "METROPOLITAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002328",
  },
  {
    branch_code: "2331",
    branch_name: "NIWARI",
    category: "SEMI URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002331",
  },
  {
    branch_code: "2337",
    branch_name: "MULUGU",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002337",
  },
  {
    branch_code: "2338",
    branch_name: "NARAYANPET",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002338",
  },
  {
    branch_code: "2351",
    branch_name: "NAMBOL",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002351",
  },
  {
    branch_code: "2352",
    branch_name: "NAHARLAGUN",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002352",
  },
  {
    branch_code: "2053",
    branch_name: "CHAIBASA",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002053",
  },
  {
    branch_code: "2232",
    branch_name: "SAHIBGANJ",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002232",
  },
  {
    branch_code: "2263",
    branch_name: "BAGHPAT",
    category: "SEMI URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002263",
  },
  {
    branch_code: "2315",
    branch_name: "DINDORI M.P",
    category: "SEMI URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002315",
  },
  {
    branch_code: "2316",
    branch_name: "BARGAWAN",
    category: "URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002316",
  },
  {
    branch_code: "2320",
    branch_name: "ETAWAH",
    category: "URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002320",
  },
  {
    branch_code: "2325",
    branch_name: "KHARAR",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002325",
  },
  {
    branch_code: "2326",
    branch_name: "BANKA",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002326",
  },
  {
    branch_code: "2329",
    branch_name: "MEMCO MORE",
    category: "METROPOLITAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002329",
  },
  {
    branch_code: "2330",
    branch_name: "GARHWA",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002330",
  },
  {
    branch_code: "2335",
    branch_name: "MOWA",
    category: "METROPOLITAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002335",
  },
  {
    branch_code: "2344",
    branch_name: "NUH",
    category: "SEMI URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0002344",
  },
  {
    branch_code: "2355",
    branch_name: "LAJPAT NAGAR",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0002355",
  },
  {
    branch_code: "2356",
    branch_name: "DILSHAD GARDEN",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0002356",
  },
  {
    branch_code: "2135",
    branch_name: "UDHAGAMANDALAM",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002135",
  },
  {
    branch_code: "2304",
    branch_name: "SHIVANE UTTAMNAGAR",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0002304",
  },
  {
    branch_code: "2314",
    branch_name: "AMROHA",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002314",
  },
  {
    branch_code: "2336",
    branch_name: "NEW TOWN",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002336",
  },
  {
    branch_code: "2345",
    branch_name: "MADHURWADA",
    category: "METROPOLITAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002345",
  },
  {
    branch_code: "2354",
    branch_name: "FAIRLANDS SALEM",
    category: "URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002354",
  },
  {
    branch_code: "2359",
    branch_name: "ALIPURDUAR",
    category: "SEMI URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002359",
  },
  {
    branch_code: "2360",
    branch_name: "MIDNAPORE",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002360",
  },
  {
    branch_code: "2361",
    branch_name: "KALYANI",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002361",
  },
  {
    branch_code: "2309",
    branch_name: "RAJPUR ROAD",
    category: "URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002309",
  },
  {
    branch_code: "2311",
    branch_name: "RAMNAGAR UTTARAKHAND",
    category: "SEMI URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002311",
  },
  {
    branch_code: "2312",
    branch_name: "VIKASNAGAR",
    category: "URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002312",
  },
  {
    branch_code: "2313",
    branch_name: "TANAKPUR",
    category: "SEMI URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002313",
  },
  {
    branch_code: "2332",
    branch_name: "CHAMBA",
    category: "SEMI URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002332",
  },
  {
    branch_code: "2333",
    branch_name: "HOUSING FINANCE BRANCH BHOPAL",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002333",
  },
  {
    branch_code: "2341",
    branch_name: "MODEL TOWN SONIPAT",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0002341",
  },
  {
    branch_code: "2348",
    branch_name: "ADIPUR",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002348",
  },
  {
    branch_code: "2349",
    branch_name: "DEESA",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002349",
  },
  {
    branch_code: "2353",
    branch_name: "SECTOR 13-17 PANIPAT",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0002353",
  },
  {
    branch_code: "2357",
    branch_name: "BAHADUR KE ROAD",
    category: "METROPOLITAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002357",
  },
  {
    branch_code: "2358",
    branch_name: "KITCHLU NAGAR",
    category: "METROPOLITAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002358",
  },
  {
    branch_code: "2362",
    branch_name: "GOVT. BUSINESS BRANCH BHOPAL",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002362",
  },
  {
    branch_code: "2363",
    branch_name: "HOUSING FINANCE BRANCH WAKAD",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0002363",
  },
  {
    branch_code: "2364",
    branch_name: "BELTOLA",
    category: "URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002364",
  },
  {
    branch_code: "2365",
    branch_name: "DHUBRI",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002365",
  },
  {
    branch_code: "2366",
    branch_name: "MALIGAON",
    category: "URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002366",
  },
  {
    branch_code: "2367",
    branch_name: "ULUBARI",
    category: "URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002367",
  },
  {
    branch_code: "2368",
    branch_name: "ADOOR",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002368",
  },
  {
    branch_code: "2369",
    branch_name: "CORPORATE FINANCE BRANCH ERNAKULAM",
    category: "URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002369",
  },
  {
    branch_code: "2370",
    branch_name: "VYTILLA",
    category: "URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002370",
  },
  {
    branch_code: "2371",
    branch_name: "STARTUP BRANCH PUNE",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0002371",
  },
  {
    branch_code: "2317",
    branch_name: "JAJAPUR",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002317",
  },
  {
    branch_code: "2302",
    branch_name: "BARBIL",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002302",
  },
  {
    branch_code: "2347",
    branch_name: "KANKER",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002347",
  },
  {
    branch_code: "2377",
    branch_name: "MID CORPORATE BRANCH THANE",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0002377",
  },
  {
    branch_code: "2385",
    branch_name: "MID CORPORATE BRANCH HYDERABAD",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002385",
  },
  {
    branch_code: "2334",
    branch_name: "SECTOR 11 PANIPAT",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0002334",
  },
  {
    branch_code: "2372",
    branch_name: "MAHANADI VIHAR",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002372",
  },
  {
    branch_code: "2350",
    branch_name: "KALOL",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002350",
  },
  {
    branch_code: "2379",
    branch_name: "M P NAGAR BHOPAL",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002379",
  },
  {
    branch_code: "2404",
    branch_name: "HOUSING FINANCE BRANCH VISHAKHAPATNAM",
    category: "METROPOLITAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002404",
  },
  {
    branch_code: "2408",
    branch_name: "HOUSING FINANCE BRANCH MOHALI",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002408",
  },
  {
    branch_code: "2342",
    branch_name: "JEYPUR",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002342",
  },
  {
    branch_code: "2401",
    branch_name: "LOHEGAON",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0002401",
  },
  {
    branch_code: "2416",
    branch_name: "KALYANPUR",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002416",
  },
  {
    branch_code: "2419",
    branch_name: "AKBARPUR",
    category: "SEMI URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002419",
  },
  {
    branch_code: "2424",
    branch_name: "HOUSING FINANCE BRANCH HADAPSAR",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0002424",
  },
  {
    branch_code: "2303",
    branch_name: "BAGALKOT",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0002303",
  },
  {
    branch_code: "2306",
    branch_name: "TALCHER",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002306",
  },
  {
    branch_code: "2339",
    branch_name: "BHUPALPALLE",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002339",
  },
  {
    branch_code: "2376",
    branch_name: "NARASARAOPET",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002376",
  },
  {
    branch_code: "2380",
    branch_name: "VIRUDHUNAGAR",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002380",
  },
  {
    branch_code: "2383",
    branch_name: "TENKASI",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002383",
  },
  {
    branch_code: "2384",
    branch_name: "TIRUPATHUR",
    category: "SEMI URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002384",
  },
  {
    branch_code: "2388",
    branch_name: "MID CORPORATE BRANCH BENGALURU",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002388",
  },
  {
    branch_code: "2389",
    branch_name: "DEVANAHALLI",
    category: "SEMI URBAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002389",
  },
  {
    branch_code: "2426",
    branch_name: "HOUSING FINANCE BRANCH INDORE",
    category: "METROPOLITAN",
    zone: "INDORE",
    ifsc_code: "MAHB0002426",
  },
  {
    branch_code: "2343",
    branch_name: "KHARIAR ROAD",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002343",
  },
  {
    branch_code: "2318",
    branch_name: "BAUDHGARH",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002318",
  },
  {
    branch_code: "2373",
    branch_name: "VRINDAVAN",
    category: "SEMI URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002373",
  },
  {
    branch_code: "2374",
    branch_name: "BHILAI CHARODA",
    category: "URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002374",
  },
  {
    branch_code: "2378",
    branch_name: "MANDIDEEP",
    category: "SEMI URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002378",
  },
  {
    branch_code: "2381",
    branch_name: "KRISHNAGIRI",
    category: "SEMI URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002381",
  },
  {
    branch_code: "2382",
    branch_name: "RANIPETTAI",
    category: "SEMI URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002382",
  },
  {
    branch_code: "2386",
    branch_name: "HALDIA",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002386",
  },
  {
    branch_code: "2387",
    branch_name: "KALIMPONG",
    category: "SEMI URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002387",
  },
  {
    branch_code: "2390",
    branch_name: "MID CORPORATE BRANCH PUNE",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0002390",
  },
  {
    branch_code: "2392",
    branch_name: "HOUSING FINANCE BRANCH ERNAKULAM",
    category: "URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002392",
  },
  {
    branch_code: "2398",
    branch_name: "BALOD",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002398",
  },
  {
    branch_code: "2399",
    branch_name: "TRANSPORT NAGAR KORBA",
    category: "URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002399",
  },
  {
    branch_code: "2400",
    branch_name: "SHYAM NAGAR",
    category: "METROPOLITAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002400",
  },
  {
    branch_code: "2402",
    branch_name: "KHANPUR",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0002402",
  },
  {
    branch_code: "2403",
    branch_name: "HOUSING FINANCE BRANCH THANE",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0002403",
  },
  {
    branch_code: "2405",
    branch_name: "PARVATHIPURAM",
    category: "SEMI URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002405",
  },
  {
    branch_code: "2409",
    branch_name: "MID CORPORATE BRANCH TALAWADE",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0002409",
  },
  {
    branch_code: "2414",
    branch_name: "BAHODAPUR",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002414",
  },
  {
    branch_code: "2415",
    branch_name: "HOUSING FINANCE BRANCH KOLKATA",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002415",
  },
  {
    branch_code: "2417",
    branch_name: "HOUSING FINANCE BRANCH RAIPUR",
    category: "METROPOLITAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002417",
  },
  {
    branch_code: "2418",
    branch_name: "HOUSING FINANCE BRANCH AHMEDABAD",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002418",
  },
  {
    branch_code: "2422",
    branch_name: "HOUSING FINANCE BRANCH FORT MUMBAI",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0002422",
  },
  {
    branch_code: "2423",
    branch_name: "HOUSING FINANCE BRANCH NASIK",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0002423",
  },
  {
    branch_code: "2425",
    branch_name: "HOUSING FINANCE BRANCH NAGPUR",
    category: "METROPOLITAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0002425",
  },
  {
    branch_code: "2429",
    branch_name: "MANGALDOI",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002429",
  },
  {
    branch_code: "2434",
    branch_name: "PANNA ROAD SATNA",
    category: "URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002434",
  },
  {
    branch_code: "2435",
    branch_name: "ADHARTAL",
    category: "METROPOLITAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002435",
  },
  {
    branch_code: "2437",
    branch_name: "MID CORPORATE BRANCH JAIPUR",
    category: "METROPOLITAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002437",
  },
  {
    branch_code: "2438",
    branch_name: "HOUSING FINANCE BRANCH JAIPUR",
    category: "METROPOLITAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002438",
  },
  {
    branch_code: "2442",
    branch_name: "HOUSING FINANCE BRANCH PATNA",
    category: "METROPOLITAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002442",
  },
  {
    branch_code: "2443",
    branch_name: "HOUSING FINANCE BRANCH LUCKNOW",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002443",
  },
  {
    branch_code: "2444",
    branch_name: "HOUSING FINANCE BRANCH HEBBAL",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002444",
  },
  {
    branch_code: "2445",
    branch_name: "HOUSING FINANCE BRANCH BHUBANESWAR",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002445",
  },
  {
    branch_code: "2447",
    branch_name: "HABSIGUDA",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002447",
  },
  {
    branch_code: "2427",
    branch_name: "BILASPUR H.P",
    category: "SEMI URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002427",
  },
  {
    branch_code: "2375",
    branch_name: "BAREIPALI",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002375",
  },
  {
    branch_code: "2413",
    branch_name: "MAVDI RAJKOT",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002413",
  },
  {
    branch_code: "2406",
    branch_name: "SAMBHAL",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002406",
  },
  {
    branch_code: "2450",
    branch_name: "MID CORPORATE BRANCH DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0002450",
  },
  {
    branch_code: "2395",
    branch_name: "SHIVALIK NAGAR",
    category: "URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002395",
  },
  {
    branch_code: "2452",
    branch_name: "NAGARKURNOOL",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002452",
  },
  {
    branch_code: "2412",
    branch_name: "CARANZALEM",
    category: "SEMI URBAN",
    zone: "GOA",
    ifsc_code: "MAHB0002412",
  },
  {
    branch_code: "2441",
    branch_name: "ABU ROAD",
    category: "SEMI URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002441",
  },
  {
    branch_code: "2396",
    branch_name: "SURAJPUR",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002396",
  },
  {
    branch_code: "2453",
    branch_name: "NARSAMPET",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002453",
  },
  {
    branch_code: "2464",
    branch_name: "GREATER FARIDABAD",
    category: "METROPOLITAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0002464",
  },
  {
    branch_code: "2470",
    branch_name: "TILAK NAGAR",
    category: "METROPOLITAN",
    zone: "MUMBAI NORTH",
    ifsc_code: "MAHB0002470",
  },
  {
    branch_code: "2440",
    branch_name: "DUNGARPUR",
    category: "SEMI URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002440",
  },
  {
    branch_code: "2465",
    branch_name: "KUNDLI",
    category: "SEMI URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0002465",
  },
  {
    branch_code: "2432",
    branch_name: "RANGIA",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002432",
  },
  {
    branch_code: "2456",
    branch_name: "KARUNAGAPPALLY",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002456",
  },
  {
    branch_code: "2460",
    branch_name: "PIRAVOM",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002460",
  },
  {
    branch_code: "2473",
    branch_name: "HOUSING FINANCE BRANCH KUKATPALLY",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002473",
  },
  {
    branch_code: "2431",
    branch_name: "KOKRAJHAR",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002431",
  },
  {
    branch_code: "2448",
    branch_name: "MID CORPORATE BRANCH TIRUPPUR",
    category: "URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002448",
  },
  {
    branch_code: "2449",
    branch_name: "MID CORPORATE BRANCH COIMBATORE",
    category: "METROPOLITAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002449",
  },
  {
    branch_code: "2455",
    branch_name: "CHERTHALA",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002455",
  },
  {
    branch_code: "2474",
    branch_name: "AZADPUR",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0002474",
  },
  {
    branch_code: "2391",
    branch_name: "CHALAKUDY",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002391",
  },
  {
    branch_code: "2393",
    branch_name: "IRINJALAKUDA",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002393",
  },
  {
    branch_code: "2394",
    branch_name: "KUNNAMKULAM",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002394",
  },
  {
    branch_code: "2397",
    branch_name: "BAIKUNTHPUR",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002397",
  },
  {
    branch_code: "2457",
    branch_name: "KESAVADASAPURAM",
    category: "URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002457",
  },
  {
    branch_code: "2469",
    branch_name: "KHODIYAR COLONY",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002469",
  },
  {
    branch_code: "2478",
    branch_name: "RAM NAGAR COIMBATORE",
    category: "METROPOLITAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002478",
  },
  {
    branch_code: "2480",
    branch_name: "CHHOTA UDAIPUR",
    category: "SEMI URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0002480",
  },
  {
    branch_code: "2481",
    branch_name: "DOHAD",
    category: "URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0002481",
  },
  {
    branch_code: "2482",
    branch_name: "UMARGAON",
    category: "SEMI URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0002482",
  },
  {
    branch_code: "2486",
    branch_name: "AIIMS ROAD GORAKHPUR",
    category: "URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002486",
  },
  {
    branch_code: "2487",
    branch_name: "AURAIYA",
    category: "SEMI URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002487",
  },
  {
    branch_code: "2488",
    branch_name: "PEENYA",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002488",
  },
  {
    branch_code: "2454",
    branch_name: "ALUVA",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002454",
  },
  {
    branch_code: "2458",
    branch_name: "KOTHAMANGALAM",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002458",
  },
  {
    branch_code: "2462",
    branch_name: "THRIPPUNITHURA",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002462",
  },
  {
    branch_code: "2466",
    branch_name: "MAHAVIR TOLA ARRAH",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002466",
  },
  {
    branch_code: "2467",
    branch_name: "SHEOHAR",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002467",
  },
  {
    branch_code: "2468",
    branch_name: "SHEIKHPURA",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002468",
  },
  {
    branch_code: "2475",
    branch_name: "NARAINA VIHAR",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0002475",
  },
  {
    branch_code: "2476",
    branch_name: "MID CORPORATE BRANCH KOLKATA",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002476",
  },
  {
    branch_code: "2479",
    branch_name: "YANAM",
    category: "SEMI URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002479",
  },
  {
    branch_code: "2407",
    branch_name: "NOIDA SECTOR 16B",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002407",
  },
  {
    branch_code: "2410",
    branch_name: "DHANORI",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0002410",
  },
  {
    branch_code: "2420",
    branch_name: "BATALA",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002420",
  },
  {
    branch_code: "2421",
    branch_name: "MALERKOTLA",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002421",
  },
  {
    branch_code: "2428",
    branch_name: "BARPETA",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002428",
  },
  {
    branch_code: "2430",
    branch_name: "GOALPARA",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002430",
  },
  {
    branch_code: "2433",
    branch_name: "DHARMANAGAR",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002433",
  },
  {
    branch_code: "2439",
    branch_name: "PRATAPGARH RAJASTHAN",
    category: "SEMI URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002439",
  },
  {
    branch_code: "2446",
    branch_name: "BHANJANAGAR",
    category: "SEMI URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002446",
  },
  {
    branch_code: "2451",
    branch_name: "KOTHAGUDEM",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002451",
  },
  {
    branch_code: "2459",
    branch_name: "OTTAPPALAM",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002459",
  },
  {
    branch_code: "2461",
    branch_name: "THAMARASSERY",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002461",
  },
  {
    branch_code: "2463",
    branch_name: "MANJERI",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002463",
  },
  {
    branch_code: "2471",
    branch_name: "CHINCHOLI MIDC",
    category: "RURAL",
    zone: "SOLAPUR",
    ifsc_code: "MAHB0002471",
  },
  {
    branch_code: "2472",
    branch_name: "GURUGRAM SECTOR 67",
    category: "URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0002472",
  },
  {
    branch_code: "2477",
    branch_name: "BARI BRAHMANA",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002477",
  },
  {
    branch_code: "2483",
    branch_name: "BASMATH",
    category: "SEMI URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0002483",
  },
  {
    branch_code: "2484",
    branch_name: "MANJLEGAON",
    category: "SEMI URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0002484",
  },
  {
    branch_code: "2485",
    branch_name: "KHADGAON RING ROAD",
    category: "URBAN",
    zone: "LATUR",
    ifsc_code: "MAHB0002485",
  },
  {
    branch_code: "2489",
    branch_name: "KHUNTI",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002489",
  },
  {
    branch_code: "2490",
    branch_name: "LATEHAR",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002490",
  },
  {
    branch_code: "2491",
    branch_name: "MID CORPORATE BRANCH CHENNAI",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002491",
  },
  {
    branch_code: "2492",
    branch_name: "JALORE",
    category: "SEMI URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002492",
  },
  {
    branch_code: "2493",
    branch_name: "ANISABAD",
    category: "METROPOLITAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002493",
  },
  {
    branch_code: "2494",
    branch_name: "ASHOK RAJPATH",
    category: "METROPOLITAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002494",
  },
  {
    branch_code: "2495",
    branch_name: "DEHRI",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002495",
  },
  {
    branch_code: "2496",
    branch_name: "SAKAT SANALA",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002496",
  },
  {
    branch_code: "2498",
    branch_name: "ALLAPUR",
    category: "METROPOLITAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002498",
  },
  {
    branch_code: "2499",
    branch_name: "BHINGA",
    category: "SEMI URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002499",
  },
  {
    branch_code: "2500",
    branch_name: "MUGHALSARAI",
    category: "URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002500",
  },
  {
    branch_code: "2501",
    branch_name: "BAORI KALAN",
    category: "RURAL",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002501",
  },
  {
    branch_code: "2504",
    branch_name: "GHANSOLI",
    category: "METROPOLITAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0002504",
  },
  {
    branch_code: "2505",
    branch_name: "SANPADA",
    category: "METROPOLITAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0002505",
  },
  {
    branch_code: "2507",
    branch_name: "HAILAKANDI",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002507",
  },
  {
    branch_code: "2508",
    branch_name: "SRIBHUMI",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002508",
  },
  {
    branch_code: "2512",
    branch_name: "HEBBAL",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002512",
  },
  {
    branch_code: "2497",
    branch_name: "TANDUR",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002497",
  },
  {
    branch_code: "2502",
    branch_name: "DUMARTARAI",
    category: "METROPOLITAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002502",
  },
  {
    branch_code: "2509",
    branch_name: "PANJAGUTTA",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002509",
  },
  {
    branch_code: "2510",
    branch_name: "SIRPUR TS",
    category: "RURAL",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002510",
  },
  {
    branch_code: "2511",
    branch_name: "VEMULAWADA",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002511",
  },
  {
    branch_code: "2513",
    branch_name: "NEW AMRITSAR",
    category: "METROPOLITAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002513",
  },
  {
    branch_code: "2506",
    branch_name: "NOIDA SECTOR 122",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002506",
  },
  {
    branch_code: "2516",
    branch_name: "KANHANGAD",
    category: "URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002516",
  },
  {
    branch_code: "2518",
    branch_name: "MITHANPURA",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002518",
  },
  {
    branch_code: "2519",
    branch_name: "OKHLA INDUSTRIAL AREA",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0002519",
  },
  {
    branch_code: "2527",
    branch_name: "HOUSING FINANCE BRANCH COIMBATORE",
    category: "METROPOLITAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002527",
  },
  {
    branch_code: "2531",
    branch_name: "KUSHALNAGAR",
    category: "SEMI URBAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002531",
  },
  {
    branch_code: "2520",
    branch_name: "VIJAYANAGAR MYSURU",
    category: "URBAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002520",
  },
  {
    branch_code: "2514",
    branch_name: "CIVIL LINES LUDHIANA",
    category: "METROPOLITAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002514",
  },
  {
    branch_code: "2539",
    branch_name: "TENALI",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002539",
  },
  {
    branch_code: "2521",
    branch_name: "MAIHAR",
    category: "SEMI URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002521",
  },
  {
    branch_code: "2524",
    branch_name: "STATION ROAD REWA",
    category: "URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002524",
  },
  {
    branch_code: "2532",
    branch_name: "BHAYALI ROAD VADODARA",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0002532",
  },
  {
    branch_code: "2503",
    branch_name: "MANJHANPUR",
    category: "SEMI URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002503",
  },
  {
    branch_code: "2523",
    branch_name: "TANUKU",
    category: "SEMI URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002523",
  },
  {
    branch_code: "2546",
    branch_name: "MIDC JALGAON",
    category: "URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0002546",
  },
  {
    branch_code: "2526",
    branch_name: "GOBICHETTIPALAYAM",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002526",
  },
  {
    branch_code: "2528",
    branch_name: "THIRUMANGALAM",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002528",
  },
  {
    branch_code: "2529",
    branch_name: "VADAVALLI",
    category: "METROPOLITAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002529",
  },
  {
    branch_code: "2530",
    branch_name: "K R PURAM",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002530",
  },
  {
    branch_code: "2533",
    branch_name: "JAHANGIRABAD",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0002533",
  },
  {
    branch_code: "2536",
    branch_name: "GOKAK",
    category: "SEMI URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0002536",
  },
  {
    branch_code: "2537",
    branch_name: "HOUSING FINANCE BRANCH MANGALORE",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0002537",
  },
  {
    branch_code: "2541",
    branch_name: "SOUBHAGYA NAGAR",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002541",
  },
  {
    branch_code: "2543",
    branch_name: "KALLAKKURICHI",
    category: "SEMI URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002543",
  },
  {
    branch_code: "2551",
    branch_name: "SARJAPURA ROAD",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002551",
  },
  {
    branch_code: "2563",
    branch_name: "SARAVANAMPATTI",
    category: "METROPOLITAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002563",
  },
  {
    branch_code: "2564",
    branch_name: "THURAIYUR",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002564",
  },
  {
    branch_code: "2569",
    branch_name: "BETIM",
    category: "RURAL",
    zone: "GOA",
    ifsc_code: "MAHB0002569",
  },
  {
    branch_code: "2570",
    branch_name: "HOUSING FINANCE BRANCH MADGAON",
    category: "SEMI URBAN",
    zone: "GOA",
    ifsc_code: "MAHB0002570",
  },
  {
    branch_code: "2571",
    branch_name: "QUEPEM",
    category: "SEMI URBAN",
    zone: "GOA",
    ifsc_code: "MAHB0002571",
  },
  {
    branch_code: "2572",
    branch_name: "THIVIM",
    category: "RURAL",
    zone: "GOA",
    ifsc_code: "MAHB0002572",
  },
  {
    branch_code: "2517",
    branch_name: "MAHE",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002517",
  },
  {
    branch_code: "2522",
    branch_name: "ARWAL",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002522",
  },
  {
    branch_code: "2534",
    branch_name: "STATION ROAD NAVSARI",
    category: "URBAN",
    zone: "SURAT",
    ifsc_code: "MAHB0002534",
  },
  {
    branch_code: "2535",
    branch_name: "HANDEWADI",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0002535",
  },
  {
    branch_code: "2538",
    branch_name: "MANDAPETA",
    category: "SEMI URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002538",
  },
  {
    branch_code: "2540",
    branch_name: "BAPUJI NAGAR",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002540",
  },
  {
    branch_code: "2542",
    branch_name: "UPPER BAZAR RANCHI",
    category: "METROPOLITAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002542",
  },
  {
    branch_code: "2545",
    branch_name: "BOOTY MORE RANCHI",
    category: "METROPOLITAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002545",
  },
  {
    branch_code: "2547",
    branch_name: "SARDARPURA",
    category: "METROPOLITAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002547",
  },
  {
    branch_code: "2548",
    branch_name: "PENDRA",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002548",
  },
  {
    branch_code: "2549",
    branch_name: "RAJIM",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002549",
  },
  {
    branch_code: "2556",
    branch_name: "HAYATNAGAR",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002556",
  },
  {
    branch_code: "2557",
    branch_name: "NALGONDA",
    category: "URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002557",
  },
  {
    branch_code: "2559",
    branch_name: "ABHAYNAGAR",
    category: "RURAL",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002559",
  },
  {
    branch_code: "2560",
    branch_name: "NARENGI",
    category: "URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002560",
  },
  {
    branch_code: "2561",
    branch_name: "PASIGHAT",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002561",
  },
  {
    branch_code: "2565",
    branch_name: "SIMDEGA",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002565",
  },
  {
    branch_code: "2566",
    branch_name: "BAWADIYA KALAN",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002566",
  },
  {
    branch_code: "2567",
    branch_name: "PHULNAKHARA",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002567",
  },
  {
    branch_code: "2574",
    branch_name: "TUGHLAKABAD EXTENSION",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0002574",
  },
  {
    branch_code: "2575",
    branch_name: "RAXAUL",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002575",
  },
  {
    branch_code: "2576",
    branch_name: "HOUSING FINANCE BRANCH DWARKA",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0002576",
  },
  {
    branch_code: "2552",
    branch_name: "CONTAI",
    category: "SEMI URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002552",
  },
  {
    branch_code: "2553",
    branch_name: "RAMPURHAT",
    category: "SEMI URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002553",
  },
  {
    branch_code: "2554",
    branch_name: "RANIGANJ",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002554",
  },
  {
    branch_code: "2555",
    branch_name: "HANUMAKONDA",
    category: "URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002555",
  },
  {
    branch_code: "2573",
    branch_name: "IBRAHIMPATNAM",
    category: "SEMI URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002573",
  },
  {
    branch_code: "2583",
    branch_name: "INDUSTRIAL AREA JALANDHAR",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002583",
  },
  {
    branch_code: "2587",
    branch_name: "TALODA",
    category: "SEMI URBAN",
    zone: "JALGAON",
    ifsc_code: "MAHB0002587",
  },
  {
    branch_code: "2585",
    branch_name: "VASTRAL",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002585",
  },
  {
    branch_code: "2596",
    branch_name: "CHEEKA",
    category: "SEMI URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002596",
  },
  {
    branch_code: "2594",
    branch_name: "DABRA",
    category: "SEMI URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002594",
  },
  {
    branch_code: "2588",
    branch_name: "ADONI",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002588",
  },
  {
    branch_code: "2544",
    branch_name: "MAYILADUTHURAI",
    category: "SEMI URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002544",
  },
  {
    branch_code: "2600",
    branch_name: "BADLAPUR WEST",
    category: "URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0002600",
  },
  {
    branch_code: "2601",
    branch_name: "MIDC AMBERNATH",
    category: "URBAN",
    zone: "THANE",
    ifsc_code: "MAHB0002601",
  },
  {
    branch_code: "2599",
    branch_name: "INDUSTRIAL AREA AMBALA CANTT.",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002599",
  },
  {
    branch_code: "2581",
    branch_name: "KHATIMA",
    category: "SEMI URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002581",
  },
  {
    branch_code: "2582",
    branch_name: "SITARGANJ",
    category: "SEMI URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002582",
  },
  {
    branch_code: "2550",
    branch_name: "BANER NX",
    category: "METROPOLITAN",
    zone: "PUNE CITY",
    ifsc_code: "MAHB0002550",
  },
  {
    branch_code: "2586",
    branch_name: "NIKOL",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002586",
  },
  {
    branch_code: "2590",
    branch_name: "WADSA (DESAIGANJ)",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0002590",
  },
  {
    branch_code: "2610",
    branch_name: "SAVNER",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0002610",
  },
  {
    branch_code: "2562",
    branch_name: "RAJAPALAYAM",
    category: "URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002562",
  },
  {
    branch_code: "2577",
    branch_name: "AERODRUM ROAD INDORE",
    category: "METROPOLITAN",
    zone: "INDORE",
    ifsc_code: "MAHB0002577",
  },
  {
    branch_code: "2597",
    branch_name: "SILICON CITY INDORE",
    category: "METROPOLITAN",
    zone: "INDORE",
    ifsc_code: "MAHB0002597",
  },
  {
    branch_code: "2558",
    branch_name: "RAMGUNDAM",
    category: "URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002558",
  },
  {
    branch_code: "2568",
    branch_name: "BAMBOLIM",
    category: "RURAL",
    zone: "GOA",
    ifsc_code: "MAHB0002568",
  },
  {
    branch_code: "2592",
    branch_name: "PATANCHERUVU",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002592",
  },
  {
    branch_code: "2593",
    branch_name: "SURAJPUR GREATER NOIDA",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002593",
  },
  {
    branch_code: "2614",
    branch_name: "MID CORPORATE BRANCH HADAPSAR",
    category: "METROPOLITAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0002614",
  },
  {
    branch_code: "2617",
    branch_name: "SHIOLIM",
    category: "SEMI URBAN",
    zone: "GOA",
    ifsc_code: "MAHB0002617",
  },
  {
    branch_code: "2637",
    branch_name: "FAIZABAD",
    category: "URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002637",
  },
  {
    branch_code: "2638",
    branch_name: "MAHANAGAR",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002638",
  },
  {
    branch_code: "2436",
    branch_name: "MID CORPORATE BRANCH CUFF PARADE",
    category: "METROPOLITAN",
    zone: "MUMBAI SOUTH",
    ifsc_code: "MAHB0002436",
  },
  {
    branch_code: "2515",
    branch_name: "LEH",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002515",
  },
  {
    branch_code: "2578",
    branch_name: "MHASRUL",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0002578",
  },
  {
    branch_code: "2579",
    branch_name: "MID CORPORATE BRANCH NASHIK",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0002579",
  },
  {
    branch_code: "2580",
    branch_name: "MUMBAI NAKA",
    category: "METROPOLITAN",
    zone: "NASIK",
    ifsc_code: "MAHB0002580",
  },
  {
    branch_code: "2584",
    branch_name: "KURALI",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002584",
  },
  {
    branch_code: "2589",
    branch_name: "DURGAPUR CITY CENTER",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002589",
  },
  {
    branch_code: "2591",
    branch_name: "KOMPALLE",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002591",
  },
  {
    branch_code: "2595",
    branch_name: "GOKUL ROAD HUBBALLI",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0002595",
  },
  {
    branch_code: "2598",
    branch_name: "NILADRI VIHAR",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002598",
  },
  {
    branch_code: "2602",
    branch_name: "PUNJABI BAGH",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0002602",
  },
  {
    branch_code: "2603",
    branch_name: "ATAL NAGAR RAIPUR",
    category: "METROPOLITAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002603",
  },
  {
    branch_code: "2604",
    branch_name: "PAONTA SAHIB",
    category: "SEMI URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002604",
  },
  {
    branch_code: "2605",
    branch_name: "KESHWAPUR HUBBALLI",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0002605",
  },
  {
    branch_code: "2606",
    branch_name: "KUNDAPURA",
    category: "SEMI URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0002606",
  },
  {
    branch_code: "2607",
    branch_name: "RAMTIRTH NAGAR",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0002607",
  },
  {
    branch_code: "2608",
    branch_name: "TARAORI",
    category: "SEMI URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002608",
  },
  {
    branch_code: "2609",
    branch_name: "TOHANA",
    category: "SEMI URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002609",
  },
  {
    branch_code: "2611",
    branch_name: "AVINASHI ROAD COIMBATORE",
    category: "METROPOLITAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002611",
  },
  {
    branch_code: "2612",
    branch_name: "KARAIKKUDI",
    category: "URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002612",
  },
  {
    branch_code: "2613",
    branch_name: "KOVILPATTI",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002613",
  },
  {
    branch_code: "2615",
    branch_name: "MOSHI",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0002615",
  },
  {
    branch_code: "2616",
    branch_name: "KULITHALAI",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002616",
  },
  {
    branch_code: "2618",
    branch_name: "DERA BASSI",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002618",
  },
  {
    branch_code: "2619",
    branch_name: "FEROZPUR ROAD LUDHIANA",
    category: "METROPOLITAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002619",
  },
  {
    branch_code: "2621",
    branch_name: "KANJIRAPPALLY",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002621",
  },
  {
    branch_code: "2622",
    branch_name: "KATTAPPANA",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002622",
  },
  {
    branch_code: "2623",
    branch_name: "KUNNAMANGALAM",
    category: "URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002623",
  },
  {
    branch_code: "2624",
    branch_name: "NORTH PARAVUR",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002624",
  },
  {
    branch_code: "2625",
    branch_name: "NEDUMANGAD",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002625",
  },
  {
    branch_code: "2626",
    branch_name: "LAXMI NAGAR",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0002626",
  },
  {
    branch_code: "2628",
    branch_name: "VAIKOM",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002628",
  },
  {
    branch_code: "2629",
    branch_name: "WEST FORT THRISSUR",
    category: "URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002629",
  },
  {
    branch_code: "2630",
    branch_name: "PALI RAJASTHAN",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002630",
  },
  {
    branch_code: "2631",
    branch_name: "ARJUNI MORGAON",
    category: "RURAL",
    zone: "NAGPUR",
    ifsc_code: "MAHB0002631",
  },
  {
    branch_code: "2632",
    branch_name: "PARSEONI",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0002632",
  },
  {
    branch_code: "2633",
    branch_name: "DARJILING",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002633",
  },
  {
    branch_code: "2634",
    branch_name: "PIPARIYA",
    category: "SEMI URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002634",
  },
  {
    branch_code: "2635",
    branch_name: "GOTA",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002635",
  },
  {
    branch_code: "2636",
    branch_name: "SHILAJ",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002636",
  },
  {
    branch_code: "2639",
    branch_name: "CHITRANJAN PARK DELHI",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0002639",
  },
  {
    branch_code: "2640",
    branch_name: "MADIPAKKAM",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002640",
  },
  {
    branch_code: "2641",
    branch_name: "POONAMALLE",
    category: "SEMI URBAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002641",
  },
  {
    branch_code: "2642",
    branch_name: "CHAS",
    category: "URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002642",
  },
  {
    branch_code: "2643",
    branch_name: "MANJHNE",
    category: "RURAL",
    zone: "RANCHI",
    ifsc_code: "MAHB0002643",
  },
  {
    branch_code: "2644",
    branch_name: "PAKUR",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002644",
  },
  {
    branch_code: "2645",
    branch_name: "DALSINGHSARAI",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002645",
  },
  {
    branch_code: "2646",
    branch_name: "JHANJHARPUR",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002646",
  },
  {
    branch_code: "2647",
    branch_name: "KALI ASTHAN ROAD",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002647",
  },
  {
    branch_code: "2648",
    branch_name: "SAWAI MADHOPUR",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002648",
  },
  {
    branch_code: "2649",
    branch_name: "AMBARI ",
    category: "URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002649",
  },
  {
    branch_code: "2650",
    branch_name: "HOJAI",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002650",
  },
  {
    branch_code: "2651",
    branch_name: "SIROHI",
    category: "SEMI URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002651",
  },
  {
    branch_code: "2411",
    branch_name: "CHIKHALI PUNE",
    category: "METROPOLITAN",
    zone: "PUNE WEST",
    ifsc_code: "MAHB0002411",
  },
  {
    branch_code: "2652",
    branch_name: "VAISHALI NAGAR AJMER",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002652",
  },
  {
    branch_code: "2653",
    branch_name: "ANNA NAGAR CHENNAI",
    category: "METROPOLITAN",
    zone: "CHENNAI",
    ifsc_code: "MAHB0002653",
  },
  {
    branch_code: "2654",
    branch_name: "VATVA",
    category: "METROPOLITAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002654",
  },
  {
    branch_code: "2655",
    branch_name: "TALAB TILLO JAMMU",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002655",
  },
  {
    branch_code: "2660",
    branch_name: "GADCHANDUR",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0002660",
  },
  {
    branch_code: "2656",
    branch_name: "NEEMSAR",
    category: "SEMI URBAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002656",
  },
  {
    branch_code: "2657",
    branch_name: "SARVODAY NAGAR",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002657",
  },
  {
    branch_code: "2662",
    branch_name: "MID CORPORATE BRANCH VADODARA",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0002662",
  },
  {
    branch_code: "2658",
    branch_name: "SECTOR 66-A MOHALI",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002658",
  },
  {
    branch_code: "2659",
    branch_name: "KAROND",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002659",
  },
  {
    branch_code: "2627",
    branch_name: "RAMANATTUKARA",
    category: "SEMI URBAN",
    zone: "ERNAKULAM",
    ifsc_code: "MAHB0002627",
  },
  {
    branch_code: "2661",
    branch_name: "TAPOO",
    category: "RURAL",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002661",
  },
  {
    branch_code: "2663",
    branch_name: "BODH GAYA",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002663",
  },
  {
    branch_code: "2664",
    branch_name: "OLD GOA",
    category: "RURAL",
    zone: "GOA",
    ifsc_code: "MAHB0002664",
  },
  {
    branch_code: "2665",
    branch_name: "OMALUR",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002665",
  },
  {
    branch_code: "2666",
    branch_name: "HOUSING FINANCE BRANCH LUDHIANA",
    category: "METROPOLITAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002666",
  },
  {
    branch_code: "2525",
    branch_name: "SUPREME COURT BRANCH",
    category: "METROPOLITAN",
    zone: "DELHI",
    ifsc_code: "MAHB0002525",
  },
  {
    branch_code: "2673",
    branch_name: "MINAL RESIDENCY",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002673",
  },
  {
    branch_code: "2677",
    branch_name: "HOUSING FINANCE BRANCH VASAI-VIRAR",
    category: "METROPOLITAN",
    zone: "THANE",
    ifsc_code: "MAHB0002677",
  },
  {
    branch_code: "2671",
    branch_name: "ASHTA SEHORE",
    category: "SEMI URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002671",
  },
  {
    branch_code: "2672",
    branch_name: "HOUSING FINANCE BRANCH KAKINADA",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002672",
  },
  {
    branch_code: "2670",
    branch_name: "MANESAR",
    category: "SEMI URBAN",
    zone: "GURUGRAM",
    ifsc_code: "MAHB0002670",
  },
  {
    branch_code: "2676",
    branch_name: "SONARPUR",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002676",
  },
  {
    branch_code: "2681",
    branch_name: "HOUSING FINANCE BRANCH HOWRAH",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002681",
  },
  {
    branch_code: "2690",
    branch_name: "LAL BAZAR BETTIAH",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002690",
  },
  {
    branch_code: "2669",
    branch_name: "RAJNAGAR EXTENSION",
    category: "METROPOLITAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002669",
  },
  {
    branch_code: "2691",
    branch_name: "BHATKAL",
    category: "Semi Urban",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0002691",
  },
  {
    branch_code: "2668",
    branch_name: "SHUJALPUR",
    category: "Semi Urban",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002668",
  },
  {
    branch_code: "2692",
    branch_name: "PUTTUR",
    category: "Semi Urban",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0002692",
  },
  {
    branch_code: "2696",
    branch_name: "HOUSING FINANCE BRANCH DEHRADUN",
    category: "URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002696",
  },
  {
    branch_code: "2679",
    branch_name: "AMGAON",
    category: "SEMI URBAN",
    zone: "NAGPUR",
    ifsc_code: "MAHB0002679",
  },
  {
    branch_code: "2697",
    branch_name: "HOUSING FINANCE BRANCH ROURKELA",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002697",
  },
  {
    branch_code: "2708",
    branch_name: "HOUSING FINANCE BRANCH GHAZIABAD",
    category: "METROPOLITAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002708",
  },
  {
    branch_code: "2678",
    branch_name: "MANGALAGIRI",
    category: "URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002678",
  },
  {
    branch_code: "2675",
    branch_name: "BANGRASIA CHIKLOD ROAD",
    category: "METROPOLITAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002675",
  },
  {
    branch_code: "2694",
    branch_name: "KUDASAN",
    category: "URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002694",
  },
  {
    branch_code: "2667",
    branch_name: "DARWHA",
    category: "SEMI URBAN",
    zone: "CHANDRAPUR",
    ifsc_code: "MAHB0002667",
  },
  {
    branch_code: "2695",
    branch_name: "PITHAPURAM",
    category: "SEMI URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002695",
  },
  {
    branch_code: "2682",
    branch_name: "SACHIN",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0002682",
  },
  {
    branch_code: "2674",
    branch_name: "SEONI MALWA",
    category: "SEMI URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002674",
  },
  {
    branch_code: "2689",
    branch_name: "GACHIBOWLI",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002689",
  },
  {
    branch_code: "2707",
    branch_name: "HOUSING FINANCE BRANCH VARANASI",
    category: "METROPOLITAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002707",
  },
  {
    branch_code: "2722",
    branch_name: "B N REDDY NAGAR",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002722",
  },
  {
    branch_code: "2720",
    branch_name: "BANGA",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002720",
  },
  {
    branch_code: "2721",
    branch_name: "GIDDERBAHA",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002721",
  },
  {
    branch_code: "2701",
    branch_name: "UTTARKASHI",
    category: "SEMI URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002701",
  },
  {
    branch_code: "2709",
    branch_name: "GANJ BASODA",
    category: "SEMI URBAN",
    zone: "BHOPAL",
    ifsc_code: "MAHB0002709",
  },
  {
    branch_code: "2684",
    branch_name: "GOPALPUR CUTTACK",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002684",
  },
  {
    branch_code: "2693",
    branch_name: "MAHAVEER CIRCLE",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0002693",
  },
  {
    branch_code: "2703",
    branch_name: "DANAPUR PATNA",
    category: "URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002703",
  },
  {
    branch_code: "2710",
    branch_name: "JAGIROAD",
    category: "SEMI URBAN",
    zone: "GUWAHATI",
    ifsc_code: "MAHB0002710",
  },
  {
    branch_code: "2700",
    branch_name: "PREMNAGAR",
    category: "URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002700",
  },
  {
    branch_code: "2706",
    branch_name: "KESHOD",
    category: "SEMI URBAN",
    zone: "AHMEDABAD",
    ifsc_code: "MAHB0002706",
  },
  {
    branch_code: "2704",
    branch_name: "CHUNAR",
    category: "SEMI URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002704",
  },
  {
    branch_code: "2687",
    branch_name: "AMEENPUR",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002687",
  },
  {
    branch_code: "2688",
    branch_name: "CHINTAL",
    category: "METROPOLITAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002688",
  },
  {
    branch_code: "2719",
    branch_name: "KICHHA",
    category: "SEMI URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002719",
  },
  {
    branch_code: "2725",
    branch_name: "METTUPALAYAM",
    category: "SEMI URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002725",
  },
  {
    branch_code: "2731",
    branch_name: "CHANDANNAGAR",
    category: "URBAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002731",
  },
  {
    branch_code: "2683",
    branch_name: "ASKA ROAD BERHAMPUR",
    category: "URBAN",
    zone: "BHUBANESWAR",
    ifsc_code: "MAHB0002683",
  },
  {
    branch_code: "2698",
    branch_name: "NAINI PRAYAGRAJ",
    category: "METROPOLITAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002698",
  },
  {
    branch_code: "2702",
    branch_name: "BIHTA",
    category: "SEMI URBAN",
    zone: "PATNA",
    ifsc_code: "MAHB0002702",
  },
  {
    branch_code: "2713",
    branch_name: "ADARSH NAGAR JABALPUR",
    category: "METROPOLITAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002713",
  },
  {
    branch_code: "2714",
    branch_name: "DHANVANTARI NAGAR JABALPUR",
    category: "METROPOLITAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002714",
  },
  {
    branch_code: "2717",
    branch_name: "TEXTILE MARKET AMRAVATI",
    category: "URBAN",
    zone: "AMRAVATI",
    ifsc_code: "MAHB0002717",
  },
  {
    branch_code: "2718",
    branch_name: "RANJHI",
    category: "METROPOLITAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002718",
  },
  {
    branch_code: "2730",
    branch_name: "HOUSING FINANCE BRANCH KOTA",
    category: "METROPOLITAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002730",
  },
  {
    branch_code: "2734",
    branch_name: "SELAQUI VIKAS NAGAR ROAD",
    category: "SEMI URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002734",
  },
  {
    branch_code: "2735",
    branch_name: "MALOUT",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002735",
  },
  {
    branch_code: "2736",
    branch_name: "NABHA",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002736",
  },
  {
    branch_code: "2737",
    branch_name: "SAMRALA",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002737",
  },
  {
    branch_code: "2747",
    branch_name: "HOUSING FINANCE BRANCH VADODARA",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0002747",
  },
  {
    branch_code: "2705",
    branch_name: "GORAKHPUR TARAMANDAL",
    category: "URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002705",
  },
  {
    branch_code: "2743",
    branch_name: "KATARGAM SURAT",
    category: "METROPOLITAN",
    zone: "SURAT",
    ifsc_code: "MAHB0002743",
  },
  {
    branch_code: "2748",
    branch_name: "JAGRAON",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002748",
  },
  {
    branch_code: "2715",
    branch_name: "GADARWARA",
    category: "SEMI URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002715",
  },
  {
    branch_code: "2699",
    branch_name: "KRISHNANAGAR DEHRADUN",
    category: "URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002699",
  },
  {
    branch_code: "2742",
    branch_name: "RAJAM",
    category: "SEMI URBAN",
    zone: "VIJAYAWADA",
    ifsc_code: "MAHB0002742",
  },
  {
    branch_code: "2716",
    branch_name: "KHURAI",
    category: "SEMI URBAN",
    zone: "JABALPUR",
    ifsc_code: "MAHB0002716",
  },
  {
    branch_code: "2744",
    branch_name: "DRONAGIRI RAIGAD",
    category: "URBAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0002744",
  },
  {
    branch_code: "2745",
    branch_name: "TALOJA MIDC",
    category: "URBAN",
    zone: "NAVI MUMBAI",
    ifsc_code: "MAHB0002745",
  },
  {
    branch_code: "2752",
    branch_name: "GHATKESAR",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002752",
  },
  {
    branch_code: "2732",
    branch_name: "SURVEY PARK",
    category: "METROPOLITAN",
    zone: "KOLKATA",
    ifsc_code: "MAHB0002732",
  },
  {
    branch_code: "2759",
    branch_name: "SUNAM",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002759",
  },
  {
    branch_code: "2753",
    branch_name: "KODAD",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002753",
  },
  {
    branch_code: "2763",
    branch_name: "ALAMBAGH",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002763",
  },
  {
    branch_code: "2764",
    branch_name: "GOMTINAGAR EXTENSION",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002764",
  },
  {
    branch_code: "2765",
    branch_name: "RAMADEVI KANPUR",
    category: "METROPOLITAN",
    zone: "LUCKNOW",
    ifsc_code: "MAHB0002765",
  },
  {
    branch_code: "2751",
    branch_name: "BODUPPAL",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002751",
  },
  {
    branch_code: "2754",
    branch_name: "ZAHEERABAD",
    category: "SEMI URBAN",
    zone: "HYDERABAD",
    ifsc_code: "MAHB0002754",
  },
  {
    branch_code: "2760",
    branch_name: "BASANT CITY, LUDHIANA",
    category: "METROPOLITAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002760",
  },
  {
    branch_code: "2761",
    branch_name: "KOTKAPURA",
    category: "SEMI URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002761",
  },
  {
    branch_code: "2762",
    branch_name: "CHANDIGARH ROAD LUDHIANA",
    category: "METROPOLITAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002762",
  },
  {
    branch_code: "2741",
    branch_name: "SAHARANPUR ROAD DEHRADUN",
    category: "URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002741",
  },
  {
    branch_code: "2777",
    branch_name: "ALMORA",
    category: "SEMI URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002777",
  },
  {
    branch_code: "2723",
    branch_name: "DHARAPURAM ROAD TIRUPPUR",
    category: "URBAN",
    zone: "COIMBATORE",
    ifsc_code: "MAHB0002723",
  },
  {
    branch_code: "2685",
    branch_name: "CHURU",
    category: "URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002685",
  },
  {
    branch_code: "2755",
    branch_name: "GANGAVATHI",
    category: "URBAN",
    zone: "HUBBALLI",
    ifsc_code: "MAHB0002755",
  },
  {
    branch_code: "2727",
    branch_name: "BICHOLIM",
    category: "SEMI URBAN",
    zone: "GOA",
    ifsc_code: "MAHB0002727",
  },
  {
    branch_code: "2728",
    branch_name: "CURCHOREM-CACORA GOA",
    category: "SEMI URBAN",
    zone: "GOA",
    ifsc_code: "MAHB0002728",
  },
  {
    branch_code: "2729",
    branch_name: "NAGARBHAVI",
    category: "METROPOLITAN",
    zone: "BENGALURU",
    ifsc_code: "MAHB0002729",
  },
  {
    branch_code: "2749",
    branch_name: "VASHUNDHRA",
    category: "METROPOLITAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002749",
  },
  {
    branch_code: "2680",
    branch_name: "SUKMA",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002680",
  },
  {
    branch_code: "2733",
    branch_name: "GREATER NOIDA WEST SECTOR 1",
    category: "URBAN",
    zone: "NOIDA",
    ifsc_code: "MAHB0002733",
  },
  {
    branch_code: "2738",
    branch_name: "BHAGWANPUR",
    category: "RURAL",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002738",
  },
  {
    branch_code: "2739",
    branch_name: "GADARPUR",
    category: "RURAL",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002739",
  },
  {
    branch_code: "2740",
    branch_name: "JAINAGAR RUDRAPUR",
    category: "URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002740",
  },
  {
    branch_code: "2746",
    branch_name: "SARANGARH",
    category: "SEMI URBAN",
    zone: "RAIPUR",
    ifsc_code: "MAHB0002746",
  },
  {
    branch_code: "2757",
    branch_name: "KUCHAMAN CITY",
    category: "SEMI URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002757",
  },
  {
    branch_code: "2758",
    branch_name: "SALUMBAR",
    category: "SEMI URBAN",
    zone: "JAIPUR",
    ifsc_code: "MAHB0002758",
  },
  {
    branch_code: "2766",
    branch_name: "PANCHKULA SECTOR 20",
    category: "URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002766",
  },
  {
    branch_code: "2767",
    branch_name: "JAMTARA",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002767",
  },
  {
    branch_code: "2768",
    branch_name: "KUMARDUBI",
    category: "SEMI URBAN",
    zone: "RANCHI",
    ifsc_code: "MAHB0002768",
  },
  {
    branch_code: "2771",
    branch_name: "GK MALL PAKHOWAL ROAD LUDHIANA",
    category: "METROPOLITAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002771",
  },
  {
    branch_code: "2772",
    branch_name: "RAHON ROAD LUDHIANA",
    category: "METROPOLITAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002772",
  },
  {
    branch_code: "2773",
    branch_name: "MODEL TOWN LUDHIANA",
    category: "METROPOLITAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002773",
  },
  {
    branch_code: "2774",
    branch_name: "AKHNOOR ROAD JAMMU",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002774",
  },
  {
    branch_code: "2775",
    branch_name: "GANPATI ENCLAVE BATHINDA",
    category: "URBAN",
    zone: "LUDHIANA",
    ifsc_code: "MAHB0002775",
  },
  {
    branch_code: "2778",
    branch_name: "HANSI",
    category: "SEMI URBAN",
    zone: "CHANDIGARH",
    ifsc_code: "MAHB0002778",
  },
  {
    branch_code: "2779",
    branch_name: "AKBARPUR AMBEDKAR NAGAR",
    category: "URBAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002779",
  },
  {
    branch_code: "2781",
    branch_name: "KASIA",
    category: "RURAL",
    zone: "VARANASI",
    ifsc_code: "MAHB0002781",
  },
  {
    branch_code: "2782",
    branch_name: "LAHURABIR",
    category: "METROPOLITAN",
    zone: "VARANASI",
    ifsc_code: "MAHB0002782",
  },
  {
    branch_code: "2784",
    branch_name: "PITHORAGARH",
    category: "SEMI URBAN",
    zone: "DEHRADUN",
    ifsc_code: "MAHB0002784",
  },
  {
    branch_code: "2787",
    branch_name: "VALPOI",
    category: "RURAL",
    zone: "GOA",
    ifsc_code: "MAHB0002787",
  },
  {
    branch_code: "2786",
    branch_name: "BARAMATI MIDC",
    category: "SEMI URBAN",
    zone: "PUNE EAST",
    ifsc_code: "MAHB0002786",
  },
  {
    branch_code: "2795",
    branch_name: "NAGPUR ROAD CHHINDWARA",
    category: "URBAN",
    zone: "CHHINDWARA",
    ifsc_code: "MAHB0002795",
  },
];
